/* 🚨🚨🚨 DO NOT EDIT: This file has been auto generated by graphql-code-generator */
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';

import { mutationFetcher } from './codegen.fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type EntireFieldWrapper<T> = T;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Time: any;
};

export type Address = {
  __typename?: 'Address';
  city: EntireFieldWrapper<Scalars['String']>;
  country: EntireFieldWrapper<Scalars['String']>;
  line1: EntireFieldWrapper<Scalars['String']>;
  line2: EntireFieldWrapper<Scalars['String']>;
  postalCode: EntireFieldWrapper<Scalars['String']>;
  state: EntireFieldWrapper<Scalars['String']>;
};

export type AddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
};

export type AdvertisingAssetType = 'image' | 'logo' | 'unspecified' | 'video';

export type AdvertisingCreateCampaignInput = {
  campaignCtaText?: InputMaybe<Scalars['String']>;
  campaignText?: InputMaybe<Scalars['String']>;
  campaignTitle?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  destinationUrl: Scalars['String'];
  endDate: Scalars['Time'];
  images?: InputMaybe<Array<CampaignAssetInput>>;
  logos?: InputMaybe<Array<CampaignAssetInput>>;
  name: Scalars['String'];
  startDate: Scalars['Time'];
  targetGeolocation: AdvertisingGeolocation;
  template: CampaignTemplateType;
  videos?: InputMaybe<Array<CampaignAssetInput>>;
};

export type AdvertisingCreateCampaignResponse = {
  __typename?: 'AdvertisingCreateCampaignResponse';
  campaign?: EntireFieldWrapper<Maybe<Campaign>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AdvertisingDeleteCampaignInput = {
  id: Scalars['ID'];
};

export type AdvertisingDeleteCampaignResponse = {
  __typename?: 'AdvertisingDeleteCampaignResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AdvertisingGeolocation = 'global';

export type AdvertisingGetCampaignInput = {
  id: Scalars['ID'];
};

export type AdvertisingGetCampaignResponse = {
  __typename?: 'AdvertisingGetCampaignResponse';
  campaign?: EntireFieldWrapper<Maybe<Campaign>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AdvertisingGetRandomNCampaignsInput = {
  assetType?: InputMaybe<AdvertisingAssetType>;
  campaignQuantity?: InputMaybe<Scalars['Int']>;
  geolocation?: InputMaybe<AdvertisingGeolocation>;
};

export type AdvertisingGetRandomNCampaignsResponse = {
  __typename?: 'AdvertisingGetRandomNCampaignsResponse';
  campaigns?: EntireFieldWrapper<Maybe<Array<Campaign>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type AdvertisingGetTotalActionsByMonthInput = {
  currentPage?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type AdvertisingGetTotalActionsByMonthResponse = {
  __typename?: 'AdvertisingGetTotalActionsByMonthResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  monthlyActions?: EntireFieldWrapper<Maybe<Array<MonthlyAction>>>;
  pagination?: EntireFieldWrapper<Maybe<AdvertisingMonthlyActionListPagination>>;
};

export type AdvertisingGetUploadedInput = {
  uploadId: Scalars['String'];
};

export type AdvertisingGetUploadedResponse = {
  __typename?: 'AdvertisingGetUploadedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  imageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type AdvertisingIncreaseClickForCampaignInput = {
  clickTime: Scalars['Time'];
  id: Scalars['String'];
};

export type AdvertisingIncreaseClickForCampaignResponse = {
  __typename?: 'AdvertisingIncreaseClickForCampaignResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AdvertisingIncreaseViewForCampaignInput = {
  id: Scalars['String'];
  viewTime: Scalars['Time'];
};

export type AdvertisingIncreaseViewForCampaignResponse = {
  __typename?: 'AdvertisingIncreaseViewForCampaignResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AdvertisingListCampaignInput = {
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
};

export type AdvertisingListCampaignResponse = {
  __typename?: 'AdvertisingListCampaignResponse';
  campaigns?: EntireFieldWrapper<Maybe<Array<Campaign>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<AdvertisingListPagination>>;
};

export type AdvertisingListPagination = {
  __typename?: 'AdvertisingListPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type AdvertisingMonthlyActionListPagination = {
  __typename?: 'AdvertisingMonthlyActionListPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type AdvertisingUpdateCampaignInput = {
  campaignCtaText?: InputMaybe<Scalars['String']>;
  campaignText?: InputMaybe<Scalars['String']>;
  campaignTitle?: InputMaybe<Scalars['String']>;
  deleteAssetsIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  destinationUrl?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Time']>;
  id: Scalars['ID'];
  images?: InputMaybe<Array<CampaignAssetInput>>;
  logos?: InputMaybe<Array<CampaignAssetInput>>;
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Time']>;
  targetGeolocation?: InputMaybe<AdvertisingGeolocation>;
  template?: InputMaybe<CampaignTemplateType>;
  videos?: InputMaybe<Array<CampaignAssetInput>>;
};

export type AdvertisingUpdateCampaignResponse = {
  __typename?: 'AdvertisingUpdateCampaignResponse';
  campaign?: EntireFieldWrapper<Maybe<Campaign>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AdvertisingUploadsCreateSignedUrlInput = {
  uploadFile: Scalars['String'];
};

export type AdvertisingUploadsCreateSignedUrlResponse = {
  __typename?: 'AdvertisingUploadsCreateSignedUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['String']>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type AffiliateInfo = {
  __typename?: 'AffiliateInfo';
  affiliateId: EntireFieldWrapper<Scalars['ID']>;
  affiliatePercentage: EntireFieldWrapper<Scalars['Float']>;
};

export type AllAccessBanner = {
  __typename?: 'AllAccessBanner';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNav: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNavPromo: EntireFieldWrapper<Scalars['Int']>;
  bannerAboveNavState: EntireFieldWrapper<Scalars['String']>;
  button: EntireFieldWrapper<AllAccessBannerButton>;
  countdown?: EntireFieldWrapper<Maybe<SiteBannerCountdown>>;
  text: EntireFieldWrapper<Scalars['String']>;
  textColor: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SiteBannerType>;
};

export type AllAccessBannerButton = {
  __typename?: 'AllAccessBannerButton';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  hoverTextColor: EntireFieldWrapper<Scalars['String']>;
  link: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  textColor: EntireFieldWrapper<Scalars['String']>;
};

export type AllAccessYearlyBanner = {
  __typename?: 'AllAccessYearlyBanner';
  backgroundImage: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNav: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNavState: EntireFieldWrapper<Scalars['String']>;
  buttonText: EntireFieldWrapper<Scalars['String']>;
  buttonUrl: EntireFieldWrapper<Scalars['String']>;
  features: EntireFieldWrapper<Array<Scalars['String']>>;
  headline: EntireFieldWrapper<Scalars['String']>;
  isHidden: EntireFieldWrapper<Scalars['Boolean']>;
  showInHeader: EntireFieldWrapper<Scalars['Boolean']>;
  type: EntireFieldWrapper<SiteBannerType>;
  yearly: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AllAccessYearlyExtendBanner = {
  __typename?: 'AllAccessYearlyExtendBanner';
  backgroundImage: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNav: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNavState: EntireFieldWrapper<Scalars['String']>;
  buttonText: EntireFieldWrapper<Scalars['String']>;
  countdownDt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  features: EntireFieldWrapper<Array<Scalars['String']>>;
  headline: EntireFieldWrapper<Scalars['String']>;
  inProgress: EntireFieldWrapper<Scalars['Boolean']>;
  lastOrderPaymentUrl: EntireFieldWrapper<Scalars['String']>;
  subscriptionId: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SiteBannerType>;
};

export type AllAccessYearlyTrialBanner = {
  __typename?: 'AllAccessYearlyTrialBanner';
  backgroundImage: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNav: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNavState: EntireFieldWrapper<Scalars['String']>;
  buttonText: EntireFieldWrapper<Scalars['String']>;
  buttonUrl: EntireFieldWrapper<Scalars['String']>;
  features: EntireFieldWrapper<Array<Scalars['String']>>;
  headline: EntireFieldWrapper<Scalars['String']>;
  isHidden: EntireFieldWrapper<Scalars['Boolean']>;
  showInHeader: EntireFieldWrapper<Scalars['Boolean']>;
  type: EntireFieldWrapper<SiteBannerType>;
  yearly: EntireFieldWrapper<Scalars['Boolean']>;
};

export type Answer = {
  __typename?: 'Answer';
  answer: EntireFieldWrapper<Scalars['String']>;
  assets?: EntireFieldWrapper<Maybe<Array<AskCfAsset>>>;
  commentCount: EntireFieldWrapper<Scalars['Int']>;
  comments?: EntireFieldWrapper<Maybe<Array<Comment>>>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  downvotes: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  isBestAnswer: EntireFieldWrapper<Scalars['Boolean']>;
  isDisliked: EntireFieldWrapper<Scalars['Boolean']>;
  isGenieAnswer: EntireFieldWrapper<Scalars['Boolean']>;
  isHtmlAnswer: EntireFieldWrapper<Scalars['Boolean']>;
  isLiked: EntireFieldWrapper<Scalars['Boolean']>;
  upvotes: EntireFieldWrapper<Scalars['Int']>;
  user: EntireFieldWrapper<PublicUserProfile>;
  /** @deprecated Use user field instead */
  userId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
};

export type AskCfAsset = {
  __typename?: 'AskCFAsset';
  id: EntireFieldWrapper<Scalars['ID']>;
  optimizedUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type: EntireFieldWrapper<AskCfAssetType>;
  url: EntireFieldWrapper<Scalars['String']>;
};

export type AskCfAssetInput = {
  assetType: AskCfAssetTypeInput;
  assetUrl: Scalars['String'];
};

export type AskCfAssetType = 'image' | 'unspecified' | 'video';

export type AskCfAssetTypeInput = 'image' | 'unspecified' | 'video';

export type AskCfConfirmQuestionInput = {
  questionId: Scalars['String'];
};

export type AskCfConfirmQuestionResponse = {
  __typename?: 'AskCFConfirmQuestionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  question?: EntireFieldWrapper<Maybe<Question>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfConfirmTopicInput = {
  topicId?: InputMaybe<Scalars['ID']>;
  topicName?: InputMaybe<Scalars['String']>;
  topicSlug: Scalars['String'];
};

export type AskCfConfirmTopicResponse = {
  __typename?: 'AskCFConfirmTopicResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfDeleteAnswerInput = {
  answerId: Scalars['String'];
  deleteReason: Scalars['String'];
};

export type AskCfDeleteAnswerResponse = {
  __typename?: 'AskCFDeleteAnswerResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfDeleteAnswersFromUserInput = {
  deleteReason: Scalars['String'];
  userId: Scalars['String'];
};

export type AskCfDeleteAnswersFromUserResponse = {
  __typename?: 'AskCFDeleteAnswersFromUserResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfDeleteQuestionInput = {
  deleteReason: Scalars['String'];
  questionId: Scalars['String'];
};

export type AskCfDeleteQuestionResponse = {
  __typename?: 'AskCFDeleteQuestionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfDeleteQuestionsFromUserInput = {
  deleteReason: Scalars['String'];
  userId: Scalars['String'];
};

export type AskCfDeleteQuestionsFromUserResponse = {
  __typename?: 'AskCFDeleteQuestionsFromUserResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfDiscardQuestionInput = {
  questionId: Scalars['String'];
};

export type AskCfDiscardQuestionResponse = {
  __typename?: 'AskCFDiscardQuestionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfDiscoveryFeedInput = {
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
};

export type AskCfDislikeAnswerInput = {
  answerId: Scalars['String'];
};

export type AskCfDislikeAnswerResponse = {
  __typename?: 'AskCFDislikeAnswerResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfDislikeCommentInput = {
  commentId: Scalars['String'];
};

export type AskCfDislikeCommentResponse = {
  __typename?: 'AskCFDislikeCommentResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfFeedResponse = {
  __typename?: 'AskCFFeedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<AskCfListQuestionsPagination>>;
  questions?: EntireFieldWrapper<Maybe<Array<Question>>>;
};

export type AskCfFollowQuestionInput = {
  questionId: Scalars['String'];
};

export type AskCfFollowQuestionResponse = {
  __typename?: 'AskCFFollowQuestionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfFollowedQuestionsInput = {
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
};

export type AskCfFollowingFeedInput = {
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
};

export type AskCfGetGivenTopicsInput = {
  topicSlugs: Array<Scalars['String']>;
};

export type AskCfGetQuestionInput = {
  answersPage: Scalars['Int'];
  answersPerPage: Scalars['Int'];
  id?: InputMaybe<Scalars['ID']>;
  questionSlug?: InputMaybe<Scalars['String']>;
};

export type AskCfGetQuestionPartialThreadInput = {
  answerId: Scalars['ID'];
  commentId?: InputMaybe<Scalars['ID']>;
  questionId?: InputMaybe<Scalars['ID']>;
  questionSlug?: InputMaybe<Scalars['String']>;
};

export type AskCfGetQuestionPartialThreadResponse = {
  __typename?: 'AskCFGetQuestionPartialThreadResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  question?: EntireFieldWrapper<Maybe<Question>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfGetQuestionResponse = {
  __typename?: 'AskCFGetQuestionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  question?: EntireFieldWrapper<Maybe<Question>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfGetTopicInput = {
  topicId?: InputMaybe<Scalars['ID']>;
  topicSlug?: InputMaybe<Scalars['String']>;
};

export type AskCfGetUploadedInput = {
  uploadId: Scalars['String'];
};

export type AskCfGetUploadedResponse = {
  __typename?: 'AskCFGetUploadedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  imageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type AskCfGetUserStatsInput = {
  userId: Scalars['ID'];
};

export type AskCfGiveTipToAnswerInput = {
  answerId: Scalars['String'];
};

export type AskCfGiveTipToAnswerResponse = {
  __typename?: 'AskCFGiveTipToAnswerResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfHomeFeedInput = {
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
};

export type AskCfLikeAnswerInput = {
  answerId: Scalars['String'];
};

export type AskCfLikeAnswerResponse = {
  __typename?: 'AskCFLikeAnswerResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfLikeCommentInput = {
  commentId: Scalars['String'];
};

export type AskCfLikeCommentResponse = {
  __typename?: 'AskCFLikeCommentResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfListCommentsInput = {
  answerId: Scalars['ID'];
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
  parentCommentId?: InputMaybe<Scalars['ID']>;
};

export type AskCfListCommentsResponse = {
  __typename?: 'AskCFListCommentsResponse';
  comments?: EntireFieldWrapper<Maybe<Array<Comment>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<AskCfListPagination>>;
};

export type AskCfListPagination = {
  __typename?: 'AskCFListPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type AskCfListQuestionsPagination = {
  __typename?: 'AskCFListQuestionsPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type AskCfPostAnswerInput = {
  answer: Scalars['String'];
  assets?: InputMaybe<Array<AskCfAssetInput>>;
  description?: InputMaybe<Scalars['String']>;
  questionId: Scalars['String'];
};

export type AskCfPostAnswerResponse = {
  __typename?: 'AskCFPostAnswerResponse';
  answer?: EntireFieldWrapper<Maybe<Answer>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfPostCommentInput = {
  answerId: Scalars['String'];
  comment: Scalars['String'];
  comment_parent_id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
};

export type AskCfPostCommentResponse = {
  __typename?: 'AskCFPostCommentResponse';
  comment?: EntireFieldWrapper<Maybe<Comment>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfPostQuestionInput = {
  assets?: InputMaybe<Array<AskCfAssetInput>>;
  context?: InputMaybe<Scalars['String']>;
  question: Scalars['String'];
};

export type AskCfPostQuestionResponse = {
  __typename?: 'AskCFPostQuestionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  question?: EntireFieldWrapper<Maybe<Question>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfSetBestAnswerInput = {
  answerId: Scalars['ID'];
  questionId: Scalars['ID'];
};

export type AskCfSetBestAnswerResponse = {
  __typename?: 'AskCFSetBestAnswerResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfTopic = {
  __typename?: 'AskCFTopic';
  id: EntireFieldWrapper<Scalars['ID']>;
  name: EntireFieldWrapper<Scalars['String']>;
  questionCount: EntireFieldWrapper<Scalars['Int']>;
  textIdentifier: EntireFieldWrapper<Scalars['String']>;
  topicSlug: EntireFieldWrapper<Scalars['String']>;
  userFollows: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfTopicDeleteInput = {
  topicId: Scalars['ID'];
};

export type AskCfTopicDeleteResponse = {
  __typename?: 'AskCFTopicDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfTopicFeedInput = {
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
  topicId?: InputMaybe<Scalars['ID']>;
  topicSlug?: InputMaybe<Scalars['String']>;
};

export type AskCfUnfollowQuestionInput = {
  questionId: Scalars['String'];
};

export type AskCfUnfollowQuestionResponse = {
  __typename?: 'AskCFUnfollowQuestionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfUploadCreateSignedUrlInput = {
  uploadFile: Scalars['String'];
};

export type AskCfUploadCreateSignedUrlResponse = {
  __typename?: 'AskCFUploadCreateSignedUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['String']>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type AskCfUserAnsweredFeedInput = {
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
  userId: Scalars['ID'];
};

export type AskCfUserDigestSubscribeResponse = {
  __typename?: 'AskCFUserDigestSubscribeResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfUserDigestUnsubscribeResponse = {
  __typename?: 'AskCFUserDigestUnsubscribeResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskCfUserFeedInput = {
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
  userId?: InputMaybe<Scalars['ID']>;
  userSlug?: InputMaybe<Scalars['String']>;
};

export type AskCfUserStats = {
  __typename?: 'AskCFUserStats';
  answerCount: EntireFieldWrapper<Scalars['Int']>;
  questionCount: EntireFieldWrapper<Scalars['Int']>;
  questionsFollowedCount: EntireFieldWrapper<Scalars['Int']>;
  userId: EntireFieldWrapper<Scalars['ID']>;
};

export type AssetDownloadResponse = {
  __typename?: 'AssetDownloadResponse';
  assetId: EntireFieldWrapper<Scalars['ID']>;
  /** This field is populated when skip trial is triggered */
  paymentRequired?: EntireFieldWrapper<Maybe<ContentPaymentRequired>>;
  /** Note that we currently only support the ID (`product.id`) */
  product: EntireFieldWrapper<ContentProduct>;
  /** @deprecated Use `product.id` instead */
  product_id: EntireFieldWrapper<Scalars['ID']>;
  url: EntireFieldWrapper<Scalars['String']>;
};

export type AssetDownloadResponseV2 = {
  __typename?: 'AssetDownloadResponseV2';
  assetId: EntireFieldWrapper<Scalars['ID']>;
  productId: EntireFieldWrapper<Scalars['ID']>;
  url: EntireFieldWrapper<Scalars['String']>;
};

export type AssetsDownloadResponseV2 = {
  __typename?: 'AssetsDownloadResponseV2';
  assets: EntireFieldWrapper<Array<AssetDownloadResponseV2>>;
  errors: EntireFieldWrapper<Array<ErrorMessage>>;
};

export type AuthChallenge = {
  __typename?: 'AuthChallenge';
  email?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  otp?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  text?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type: EntireFieldWrapper<ChallengeType>;
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  currency?: EntireFieldWrapper<Maybe<Currency>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  subscriptionId: EntireFieldWrapper<Scalars['String']>;
  token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  user?: EntireFieldWrapper<Maybe<User>>;
};

export type AuthType = 'authTypeApple' | 'authTypeFacebook' | 'authTypeGoogle';

export type AvailableCurrencyCode = 'eur' | 'gbp' | 'usd';

export type AvailablePaymentMethod = 'bacsDebit' | 'card' | 'paypal' | 'sepaDebit';

export type AwaitingRenewalConfirmationBanner = {
  __typename?: 'AwaitingRenewalConfirmationBanner';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNav: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNavState: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SiteBannerType>;
};

export type BillingDetails = {
  __typename?: 'BillingDetails';
  address: EntireFieldWrapper<Address>;
  email: EntireFieldWrapper<Scalars['String']>;
  euTaxId: EntireFieldWrapper<Scalars['String']>;
  firstName: EntireFieldWrapper<Scalars['String']>;
  lastName: EntireFieldWrapper<Scalars['String']>;
  taxId?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type BillingDetailsInput = {
  address: AddressInput;
  email: Scalars['String'];
  euTaxId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  taxId?: InputMaybe<Scalars['String']>;
};

export type BillingPeriod = 'month' | 'year';

export type BlocksRange = {
  __typename?: 'BlocksRange';
  maxBlocksAllowed: EntireFieldWrapper<Scalars['Int']>;
  minBlocksAllowed: EntireFieldWrapper<Scalars['Int']>;
};

export type BuildPaymentDataForSubscriptionResult = {
  __typename?: 'BuildPaymentDataForSubscriptionResult';
  payment?: EntireFieldWrapper<Maybe<Payment>>;
  userBanned?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type CfMainEnterpriseRequestInput = {
  answer: Scalars['String'];
  asset: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  employees: EnterpriseRequestEmployees;
  job?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  owner?: InputMaybe<Scalars['Int']>;
  project?: InputMaybe<Scalars['String']>;
  question: Scalars['String'];
  usage: Scalars['String'];
};

export type CfMainEnterpriseRequestResponse = {
  __typename?: 'CFMainEnterpriseRequestResponse';
  enterpriseRequests?: EntireFieldWrapper<Maybe<EnterpriseRequest>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type CfMainGetEnterpriseRequestInput = {
  id: Scalars['Int'];
};

export type CfMainGetEnterpriseRequestResponse = {
  __typename?: 'CFMainGetEnterpriseRequestResponse';
  enterpriseRequest?: EntireFieldWrapper<Maybe<EnterpriseRequest>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type CfMainIsUserFavorite = {
  __typename?: 'CFMainIsUserFavorite';
  isFavorite: EntireFieldWrapper<Scalars['Boolean']>;
  productID: EntireFieldWrapper<Scalars['Int']>;
};

export type CfMainListEnterpriseRequestsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CfMainListEnterpriseRequestsPagination = {
  __typename?: 'CFMainListEnterpriseRequestsPagination';
  limit: EntireFieldWrapper<Scalars['Int']>;
  nextOffset: EntireFieldWrapper<Scalars['Int']>;
  offset: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type CfMainListEnterpriseRequestsResponse = {
  __typename?: 'CFMainListEnterpriseRequestsResponse';
  enterpriseRequests?: EntireFieldWrapper<Maybe<Array<EnterpriseRequest>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<CfMainListEnterpriseRequestsPagination>>;
};

export type CfMainProductsFavoritesCount = {
  __typename?: 'CFMainProductsFavoritesCount';
  favoritesCounts: EntireFieldWrapper<Array<CfMainProductsFavoritesCountItem>>;
};

export type CfMainProductsFavoritesCountItem = {
  __typename?: 'CFMainProductsFavoritesCountItem';
  count: EntireFieldWrapper<Scalars['Int']>;
  isFavorite: EntireFieldWrapper<Scalars['Boolean']>;
  productId: EntireFieldWrapper<Scalars['Int']>;
};

export type CfMainUpdateEnterpriseRequestInput = {
  id: Scalars['Int'];
  owner: Scalars['Int'];
};

export type CfMainUpdateEnterpriseRequestResponse = {
  __typename?: 'CFMainUpdateEnterpriseRequestResponse';
  enterpriseRequests?: EntireFieldWrapper<Maybe<EnterpriseRequest>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type CfSubscription = {
  __typename?: 'CFSubscription';
  billingPeriod?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  currency?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  discountedPrice?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  endDate?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
  nextPaymentDate?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  status: EntireFieldWrapper<Scalars['String']>;
  totalAmount: EntireFieldWrapper<Scalars['String']>;
};

export type CacheControlScope = 'PRIVATE' | 'PUBLIC';

export type CalculatePricesInput = {
  currency: CurrencyCode;
  match?: InputMaybe<Scalars['Boolean']>;
  prices: Array<Scalars['Int']>;
};

export type CalculatePricesResponse = {
  __typename?: 'CalculatePricesResponse';
  currency: EntireFieldWrapper<CurrencyCode>;
  prices: EntireFieldWrapper<Array<TransformedPricesResponse>>;
};

export type Campaign = {
  __typename?: 'Campaign';
  clicks: EntireFieldWrapper<Scalars['Int']>;
  content: EntireFieldWrapper<Contents>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  ctr: EntireFieldWrapper<Scalars['Float']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  endDate: EntireFieldWrapper<Scalars['DateTime']>;
  geolocation: EntireFieldWrapper<AdvertisingGeolocation>;
  id: EntireFieldWrapper<Scalars['ID']>;
  name: EntireFieldWrapper<Scalars['String']>;
  startDate: EntireFieldWrapper<Scalars['DateTime']>;
  views: EntireFieldWrapper<Scalars['Int']>;
};

export type CampaignAsset = {
  __typename?: 'CampaignAsset';
  assetType: EntireFieldWrapper<AdvertisingAssetType>;
  assetUrl: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  placementOrder: EntireFieldWrapper<Scalars['Int']>;
};

export type CampaignAssetInput = {
  assetType: AdvertisingAssetType;
  assetUrl: Scalars['String'];
  placementOrder: Scalars['Int'];
};

export type CampaignTemplateType = 'imageAndLogo' | 'imageOnly' | 'imagesAndText' | 'videoAndImage' | 'videoOnly';

export type CancelSubscriptionInput = {
  subscriptionId: Scalars['String'];
};

export type CancelSubscriptionResponse = {
  __typename?: 'CancelSubscriptionResponse';
  error?: EntireFieldWrapper<Maybe<ErrorGrowth>>;
};

export type Category =
  | 'bundles'
  | 'crafts'
  | 'embroidery'
  | 'fonts'
  | 'graphics'
  | 'knitting'
  | 'laserCutting'
  | 'pngs'
  | 'svgs'
  | 'threeDPaperCrafts';

export type ChallengeType = 'challenge2fa' | 'challengeOtp';

export type ChangeUserRoleStatus = 'AwaitingAdminApproval' | 'Unknown' | 'Updated';

export type ClassesBanner = {
  __typename?: 'ClassesBanner';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  bannerTitleClass: EntireFieldWrapper<Scalars['String']>;
  button: EntireFieldWrapper<ClassesBannerButton>;
  fontSize: EntireFieldWrapper<Scalars['String']>;
  hideByDefault: EntireFieldWrapper<Scalars['Boolean']>;
  lineHeight: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  textColor: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SiteBannerType>;
};

export type ClassesBannerButton = {
  __typename?: 'ClassesBannerButton';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  link: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  textColor: EntireFieldWrapper<Scalars['String']>;
};

export type ClientType = 'ClientTypeAndroid' | 'ClientTypeIOS' | 'ClientTypeWeb';

export type Clubhouse = {
  __typename?: 'Clubhouse';
  askTopics?: EntireFieldWrapper<Maybe<Array<Scalars['String']>>>;
  avatarImage?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  bannerImage?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  bgColor?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  digitalAssetsFilters?: EntireFieldWrapper<Maybe<Array<Scalars['String']>>>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  invitesTotal?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  isMember: EntireFieldWrapper<Scalars['Boolean']>;
  isSubscribedToDigest: EntireFieldWrapper<Scalars['Boolean']>;
  lightBgColor?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  membersLast30Days?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  membersTotal: EntireFieldWrapper<Scalars['Int']>;
  name: EntireFieldWrapper<Scalars['String']>;
  query: EntireFieldWrapper<Scalars['String']>;
  slug: EntireFieldWrapper<Scalars['String']>;
  textColor?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type: EntireFieldWrapper<ClubhouseType>;
  userPendingInviters?: EntireFieldWrapper<Maybe<Array<PublicUserProfile>>>;
};

export type ClubhouseAcceptInviteInput = {
  clubhouseSlug: Scalars['String'];
};

export type ClubhouseAcceptInviteResponse = {
  __typename?: 'ClubhouseAcceptInviteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type ClubhouseDigestFrequency = 'DAILY' | 'DISABLED' | 'UNSPECIFIED' | 'WEEKLY';

export type ClubhouseFriendsListInput = {
  clubhouseSlug: Scalars['String'];
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type ClubhouseFriendsListResponse = {
  __typename?: 'ClubhouseFriendsListResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  friends?: EntireFieldWrapper<Maybe<Array<ClubhouseMember>>>;
  pagination?: EntireFieldWrapper<Maybe<ClubhousesListPagination>>;
};

export type ClubhouseInviteInput = {
  clubhouseSlug: Scalars['String'];
  friendId?: InputMaybe<Scalars['String']>;
  friendsEmails?: InputMaybe<Array<Scalars['String']>>;
  inviteMessage?: InputMaybe<Scalars['String']>;
};

export type ClubhouseInviteResponse = {
  __typename?: 'ClubhouseInviteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type ClubhouseIsMemberInput = {
  clubhouseSlug: Scalars['String'];
};

export type ClubhouseIsMemberResponse = {
  __typename?: 'ClubhouseIsMemberResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  isMember: EntireFieldWrapper<Scalars['Boolean']>;
};

export type ClubhouseJoinInput = {
  clubhouseSlug: Scalars['String'];
};

export type ClubhouseJoinResponse = {
  __typename?: 'ClubhouseJoinResponse';
  Success: EntireFieldWrapper<Scalars['Boolean']>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type ClubhouseLeaveInput = {
  clubhouseSlug: Scalars['String'];
};

export type ClubhouseLeaveResponse = {
  __typename?: 'ClubhouseLeaveResponse';
  Success: EntireFieldWrapper<Scalars['Boolean']>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type ClubhouseListPendingInvitationInput = {
  clubhouseSlug: Scalars['String'];
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type ClubhouseListPendingInvitationPagination = {
  __typename?: 'ClubhouseListPendingInvitationPagination';
  TotalInvites: EntireFieldWrapper<Scalars['Int']>;
  page: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type ClubhouseListPendingInvitationResponse = {
  __typename?: 'ClubhouseListPendingInvitationResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<ClubhouseListPendingInvitationPagination>>;
  pendingInviters?: EntireFieldWrapper<Maybe<Array<PublicUserProfile>>>;
};

export type ClubhouseMember = {
  __typename?: 'ClubhouseMember';
  isAlreadyInvited: EntireFieldWrapper<Scalars['Boolean']>;
  isMember: EntireFieldWrapper<Scalars['Boolean']>;
  userProfile: EntireFieldWrapper<PublicUserProfile>;
};

export type ClubhouseOnlineInput = {
  id: Scalars['ID'];
};

export type ClubhouseType =
  | 'brand'
  | 'businessAndSelling'
  | 'craft'
  | 'holiday'
  | 'lifeEvent'
  | 'materialsAndMachines'
  | 'unspecified';

export type ClubhouseUpdateDigestPreferenceInput = {
  clubhouseSlug: Scalars['String'];
  frequency: ClubhouseDigestFrequency;
};

export type ClubhouseUpdateDigestPreferenceResponse = {
  __typename?: 'ClubhouseUpdateDigestPreferenceResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type ClubhousesAdminUploadCreateSignedUrlInput = {
  uploadFile: Scalars['String'];
};

export type ClubhousesAdminUploadCreateSignedUrlResponse = {
  __typename?: 'ClubhousesAdminUploadCreateSignedUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['String']>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type ClubhousesComment = {
  __typename?: 'ClubhousesComment';
  assets?: EntireFieldWrapper<Maybe<Array<ImageAsset>>>;
  /** @deprecated No longer supported */
  childRepliesCount?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  commentsCount?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  /** @deprecated Use 'assets' instead */
  images?: EntireFieldWrapper<Maybe<Array<ImageAsset>>>;
  isLiked: EntireFieldWrapper<Scalars['Boolean']>;
  likesCount: EntireFieldWrapper<Scalars['Int']>;
  parentId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  /** @deprecated No longer supported */
  text?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  user: EntireFieldWrapper<PublicUserProfile>;
};

export type ClubhousesCommentsPagination = {
  __typename?: 'ClubhousesCommentsPagination';
  nextCursor?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  page: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type ClubhousesCommunityLeaderStatusInput = {
  clubhouseSlug: Scalars['String'];
  userId: Scalars['String'];
};

export type ClubhousesCommunityLeaderStatusResponse = {
  __typename?: 'ClubhousesCommunityLeaderStatusResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  isLeader: EntireFieldWrapper<Scalars['Boolean']>;
  leaderInfo?: EntireFieldWrapper<Maybe<CommunityLeaderInfo>>;
};

export type ClubhousesCommunityLeadersListInput = {
  clubhouseSlug: Scalars['String'];
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type ClubhousesCommunityLeadersListResponse = {
  __typename?: 'ClubhousesCommunityLeadersListResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  leaders?: EntireFieldWrapper<Maybe<Array<CommunityLeader>>>;
  pagination?: EntireFieldWrapper<Maybe<ClubhousesListPagination>>;
  totalMembers: EntireFieldWrapper<Scalars['Int']>;
};

export type ClubhousesCreateCommunityLeaderInput = {
  clubhouseSlug: Scalars['String'];
  rights?: InputMaybe<Array<CommunityLeaderRight>>;
  userId: Scalars['String'];
};

export type ClubhousesCreateCommunityLeaderResponse = {
  __typename?: 'ClubhousesCreateCommunityLeaderResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  leader?: EntireFieldWrapper<Maybe<CommunityLeader>>;
};

export type ClubhousesCreateDiscussionInput = {
  clubhouseSlug: Scalars['String'];
  content: Scalars['String'];
  headline: Scalars['String'];
  images?: InputMaybe<Array<Scalars['String']>>;
  topicSlug: Scalars['String'];
};

export type ClubhousesCreateDiscussionReplyInput = {
  assets?: InputMaybe<Array<Scalars['String']>>;
  content?: InputMaybe<Scalars['String']>;
  discussionId: Scalars['ID'];
  images?: InputMaybe<Array<Scalars['String']>>;
  parentId?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ClubhousesCreateDiscussionReplyResponse = {
  __typename?: 'ClubhousesCreateDiscussionReplyResponse';
  comment?: EntireFieldWrapper<Maybe<ClubhousesComment>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type ClubhousesCreateDiscussionResponse = {
  __typename?: 'ClubhousesCreateDiscussionResponse';
  discussion?: EntireFieldWrapper<Maybe<Discussion>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type ClubhousesDeleteDiscussionInput = {
  id: Scalars['ID'];
};

export type ClubhousesDeleteDiscussionReplyInput = {
  clubhouseSlug: Scalars['String'];
  id: Scalars['ID'];
};

export type ClubhousesDeleteDiscussionReplyResponse = {
  __typename?: 'ClubhousesDeleteDiscussionReplyResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type ClubhousesDeleteDiscussionResponse = {
  __typename?: 'ClubhousesDeleteDiscussionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type ClubhousesFomUserPagination = {
  __typename?: 'ClubhousesFomUserPagination';
  page: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type ClubhousesFomUserResponse = {
  __typename?: 'ClubhousesFomUserResponse';
  clubhouses?: EntireFieldWrapper<Maybe<Array<Clubhouse>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<ClubhousesListPagination>>;
};

export type ClubhousesFromUserInput = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  userId: Scalars['ID'];
};

export type ClubhousesGetDiscussionInput = {
  discussionId?: InputMaybe<Scalars['ID']>;
  discussionSlug?: InputMaybe<Scalars['String']>;
  repliesLimit?: InputMaybe<Scalars['Int']>;
};

export type ClubhousesGetDiscussionRepliesInput = {
  cursor?: InputMaybe<Scalars['ID']>;
  discussionId?: InputMaybe<Scalars['ID']>;
  discussionSlug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
};

export type ClubhousesGetDiscussionRepliesResponse = {
  __typename?: 'ClubhousesGetDiscussionRepliesResponse';
  comments?: EntireFieldWrapper<Maybe<Array<ClubhousesComment>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<ClubhousesCommentsPagination>>;
  /** @deprecated Use 'comments' instead */
  replies?: EntireFieldWrapper<Maybe<Array<ClubhousesComment>>>;
};

export type ClubhousesGetDiscussionResponse = {
  __typename?: 'ClubhousesGetDiscussionResponse';
  discussion?: EntireFieldWrapper<Maybe<Discussion>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type ClubhousesGetSubscriberCountInput = {
  clubhouseSlug: Scalars['String'];
};

export type ClubhousesGetSubscriberCountResponse = {
  __typename?: 'ClubhousesGetSubscriberCountResponse';
  dailyDigestSubscriberCount: EntireFieldWrapper<Scalars['Int']>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  totalSubscriberCount: EntireFieldWrapper<Scalars['Int']>;
  weeklyDigestSubscriberCount: EntireFieldWrapper<Scalars['Int']>;
};

export type ClubhousesGetUploadedInput = {
  assetId: Scalars['String'];
};

export type ClubhousesGetUploadedResponse = {
  __typename?: 'ClubhousesGetUploadedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  imageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type ClubhousesGetUserStatsInput = {
  userId: Scalars['String'];
};

export type ClubhousesGetUserStatsResponse = {
  __typename?: 'ClubhousesGetUserStatsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  stats: EntireFieldWrapper<ClubhousesUserStats>;
};

export type ClubhousesGiveTipToDiscussionInput = {
  discussionId: Scalars['ID'];
};

export type ClubhousesGiveTipToDiscussionResponse = {
  __typename?: 'ClubhousesGiveTipToDiscussionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type ClubhousesLikeReplyInput = {
  commentId: Scalars['ID'];
};

export type ClubhousesLikeReplyResponse = {
  __typename?: 'ClubhousesLikeReplyResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type ClubhousesListInput = {
  filter?: InputMaybe<ClubhouseType>;
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
};

export type ClubhousesListPagination = {
  __typename?: 'ClubhousesListPagination';
  page: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type ClubhousesListResponse = {
  __typename?: 'ClubhousesListResponse';
  clubhouses?: EntireFieldWrapper<Maybe<Array<Clubhouse>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<ClubhousesListPagination>>;
};

export type ClubhousesMemberSortBy = 'joinedAt' | 'name';

export type ClubhousesReactToDiscussionInput = {
  discussionId: Scalars['Int'];
  reactionAction: ClubhousesReactionAction;
  reactionType: ClubhousesReactionType;
};

export type ClubhousesReactToDiscussionResponse = {
  __typename?: 'ClubhousesReactToDiscussionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type ClubhousesReactionAction = 'ADD' | 'REMOVE';

export type ClubhousesReactionType = 'LIKE';

export type ClubhousesRemoveLikeReplyInput = {
  commentId: Scalars['ID'];
};

export type ClubhousesRemoveLikeReplyResponse = {
  __typename?: 'ClubhousesRemoveLikeReplyResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type ClubhousesTopDiscussionsListInput = {
  clubhouseSlug: Scalars['String'];
  limit: Scalars['Int'];
};

export type ClubhousesTopDiscussionsListResponse = {
  __typename?: 'ClubhousesTopDiscussionsListResponse';
  discussions?: EntireFieldWrapper<Maybe<Array<DiscussionListItem>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type ClubhousesTopicDiscussionsListInput = {
  clubhouseSlug: Scalars['String'];
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  sortOptions: ClubhousesTopicDiscussionsSortOptions;
  topicSlug: Scalars['String'];
};

export type ClubhousesTopicDiscussionsListResponse = {
  __typename?: 'ClubhousesTopicDiscussionsListResponse';
  discussions?: EntireFieldWrapper<Maybe<Array<DiscussionListItem>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<ClubhousesListPagination>>;
};

export type ClubhousesTopicDiscussionsSortOptions = 'allTime' | 'top';

export type ClubhousesTopicsListInput = {
  clubhouseSlug: Scalars['String'];
  discussionsCount?: InputMaybe<Scalars['Int']>;
};

export type ClubhousesTopicsListResponse = {
  __typename?: 'ClubhousesTopicsListResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  topics?: EntireFieldWrapper<Maybe<Array<Topic>>>;
};

export type ClubhousesUploadCreateSignedUrlInput = {
  uploadFile: Scalars['String'];
};

export type ClubhousesUploadCreateSignedUrlResponse = {
  __typename?: 'ClubhousesUploadCreateSignedUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['String']>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type ClubhousesUserBalance = {
  __typename?: 'ClubhousesUserBalance';
  balance: EntireFieldWrapper<Scalars['Int']>;
};

export type ClubhousesUserInput = {
  userId: Scalars['ID'];
};

export type ClubhousesUserProfile = {
  __typename?: 'ClubhousesUserProfile';
  balance: EntireFieldWrapper<ClubhousesUserBalance>;
  stats: EntireFieldWrapper<ClubhousesUserStats>;
  user: EntireFieldWrapper<PublicUserProfile>;
};

export type ClubhousesUserResponse = {
  __typename?: 'ClubhousesUserResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  user?: EntireFieldWrapper<Maybe<ClubhousesUserProfile>>;
};

export type ClubhousesUserStats = {
  __typename?: 'ClubhousesUserStats';
  commentsStats: EntireFieldWrapper<CommentsStats>;
  discussionsStats: EntireFieldWrapper<DiscussionsStats>;
  userId: EntireFieldWrapper<Scalars['ID']>;
};

export type ClubhousesUsersBatchInput = {
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ClubhousesUsersBatchResponse = {
  __typename?: 'ClubhousesUsersBatchResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  users?: EntireFieldWrapper<Maybe<Array<ClubhousesUserProfile>>>;
};

export type CoinAvailableRewards = {
  __typename?: 'CoinAvailableRewards';
  projectPosts?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  reviews?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
};

export type CoinOrigin = {
  __typename?: 'CoinOrigin';
  action: EntireFieldWrapper<CoinTransactionOrigin>;
  product?: EntireFieldWrapper<Maybe<CoinProduct>>;
  user?: EntireFieldWrapper<Maybe<PublicUserProfile>>;
};

export type CoinProduct = {
  __typename?: 'CoinProduct';
  id: EntireFieldWrapper<Scalars['ID']>;
  image?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  slug: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  url: EntireFieldWrapper<Scalars['String']>;
};

export type CoinRewardsSettings = {
  __typename?: 'CoinRewardsSettings';
  postProductReview: EntireFieldWrapper<Scalars['Int']>;
  postSocialProductProject: EntireFieldWrapper<Scalars['Int']>;
  registerAccount: EntireFieldWrapper<Scalars['Int']>;
};

export type CoinSettings = {
  __typename?: 'CoinSettings';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  rewards?: EntireFieldWrapper<Maybe<CoinRewardsSettings>>;
  spending?: EntireFieldWrapper<Maybe<CoinSpendingSettings>>;
};

export type CoinSpendingActionsSettings = {
  __typename?: 'CoinSpendingActionsSettings';
  tipPostAuthor: EntireFieldWrapper<Scalars['Int']>;
  tipUser: EntireFieldWrapper<Scalars['Int']>;
};

export type CoinSpendingProductsSettings = {
  __typename?: 'CoinSpendingProductsSettings';
  bundles: EntireFieldWrapper<Scalars['Int']>;
  classes: EntireFieldWrapper<Scalars['Int']>;
  communityGraphics: EntireFieldWrapper<Scalars['Int']>;
  crafts: EntireFieldWrapper<Scalars['Int']>;
};

export type CoinSpendingSettings = {
  __typename?: 'CoinSpendingSettings';
  actions: EntireFieldWrapper<CoinSpendingActionsSettings>;
  products: EntireFieldWrapper<CoinSpendingProductsSettings>;
};

export type CoinTransaction = {
  __typename?: 'CoinTransaction';
  amount: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  origin: EntireFieldWrapper<CoinOrigin>;
  parent?: EntireFieldWrapper<Maybe<CoinTransaction>>;
  reason?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  status: EntireFieldWrapper<CoinTransactionStatus>;
  type: EntireFieldWrapper<CoinTransactionType>;
};

export type CoinTransactionOrigin =
  | 'adminChange'
  | 'productDownloaded'
  | 'productProjectPosted'
  | 'productReviewed'
  | 'socialPostTipped'
  | 'userTipped';

export type CoinTransactionResponse = {
  __typename?: 'CoinTransactionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  transaction?: EntireFieldWrapper<Maybe<CoinTransaction>>;
};

export type CoinTransactionStatus = 'cancelled' | 'confirmed' | 'pending';

export type CoinTransactionType = 'earn' | 'spend';

export type CoinTransactionsResponse = {
  __typename?: 'CoinTransactionsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<Pagination>>;
  transactions?: EntireFieldWrapper<Maybe<Array<CoinTransaction>>>;
};

export type CoinTransactionsResponseByProduct = {
  __typename?: 'CoinTransactionsResponseByProduct';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  transactions?: EntireFieldWrapper<Maybe<Array<CoinTransaction>>>;
};

export type CoinWallet = {
  __typename?: 'CoinWallet';
  availableRewards: EntireFieldWrapper<CoinAvailableRewards>;
  balance: EntireFieldWrapper<Scalars['Int']>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  transactions: EntireFieldWrapper<CoinWalletTransactions>;
};

export type CoinWalletTransactionsArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type CoinWalletTransactions = {
  __typename?: 'CoinWalletTransactions';
  pagination?: EntireFieldWrapper<Maybe<Pagination>>;
  transactions?: EntireFieldWrapper<Maybe<Array<CoinTransaction>>>;
};

export type CoinsBundle = {
  __typename?: 'CoinsBundle';
  coins?: EntireFieldWrapper<Maybe<CoinsBundleTransactionInfo>>;
  craftsCharacteristic?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  fontCharacteristic?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  graphicCharacteristic?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  image?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  isCoinRewardBundle?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<CoinsBundleType>;
  url: EntireFieldWrapper<Scalars['String']>;
};

export type CoinsBundleTransactionInfo = {
  __typename?: 'CoinsBundleTransactionInfo';
  amount?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  spent?: EntireFieldWrapper<Maybe<CoinTransaction>>;
};

export type CoinsBundleType = {
  __typename?: 'CoinsBundleType';
  title: EntireFieldWrapper<Scalars['String']>;
};

export type CoinsBundlesResponse = {
  __typename?: 'CoinsBundlesResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  items: EntireFieldWrapper<Array<CoinsBundle>>;
};

export type CoinsDownload = {
  __typename?: 'CoinsDownload';
  id: EntireFieldWrapper<Scalars['ID']>;
  image: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<Scalars['String']>;
  url: EntireFieldWrapper<Scalars['String']>;
};

export type CoinsDownloadMeta = {
  __typename?: 'CoinsDownloadMeta';
  total?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
};

export type CoinsDownloadsOrderBy = 'dateAsc' | 'dateDesc' | 'rand';

export type CoinsDownloadsResponse = {
  __typename?: 'CoinsDownloadsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  items: EntireFieldWrapper<Array<CoinsDownload>>;
  meta?: EntireFieldWrapper<Maybe<CoinsDownloadMeta>>;
};

export type CoinsEntityTipRequest = {
  entityId: Scalars['String'];
  entityType: CoinsEntityType;
};

export type CoinsEntityTipResponse = {
  __typename?: 'CoinsEntityTipResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type CoinsEntityType = 'font' | 'unspecified';

export type CoinsGiveTipResponse = {
  __typename?: 'CoinsGiveTipResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  transactions?: EntireFieldWrapper<Maybe<Array<CoinTransaction>>>;
};

export type CoinsPopularProduct = {
  __typename?: 'CoinsPopularProduct';
  id: EntireFieldWrapper<Scalars['Int']>;
  image: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<CoinsPopularProductCategory>;
  url: EntireFieldWrapper<Scalars['String']>;
};

export type CoinsPopularProductCategory = {
  __typename?: 'CoinsPopularProductCategory';
  slug: EntireFieldWrapper<Scalars['String']>;
};

export type CoinsPopularResponse = {
  __typename?: 'CoinsPopularResponse';
  classes?: EntireFieldWrapper<Maybe<Array<CoinsPopularProduct>>>;
  crafts?: EntireFieldWrapper<Maybe<Array<CoinsPopularProduct>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type CoinsSpendResponse = {
  __typename?: 'CoinsSpendResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  transaction?: EntireFieldWrapper<Maybe<CoinTransaction>>;
};

export type Comment = {
  __typename?: 'Comment';
  asset?: EntireFieldWrapper<Maybe<AskCfAsset>>;
  childComments?: EntireFieldWrapper<Maybe<Array<Comment>>>;
  comment: EntireFieldWrapper<Scalars['String']>;
  commentCount: EntireFieldWrapper<Scalars['Int']>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  downvotes: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  isDisliked: EntireFieldWrapper<Scalars['Boolean']>;
  isLiked: EntireFieldWrapper<Scalars['Boolean']>;
  upvotes: EntireFieldWrapper<Scalars['Int']>;
  user: EntireFieldWrapper<PublicUserProfile>;
};

export type CommentsStats = {
  __typename?: 'CommentsStats';
  commentsCreatedCount: EntireFieldWrapper<Scalars['Int']>;
  commentsReactedCount: EntireFieldWrapper<Scalars['Int']>;
  reactionsReceivedCount: EntireFieldWrapper<Scalars['Int']>;
};

export type CommunityLeader = {
  __typename?: 'CommunityLeader';
  clubhouseSlug: EntireFieldWrapper<Scalars['String']>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  rights?: EntireFieldWrapper<Maybe<Array<CommunityLeaderRight>>>;
  user: EntireFieldWrapper<PublicUserProfile>;
};

export type CommunityLeaderInfo = {
  __typename?: 'CommunityLeaderInfo';
  clubhouseSlug: EntireFieldWrapper<Scalars['String']>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  rights?: EntireFieldWrapper<Maybe<Array<CommunityLeaderRight>>>;
};

export type CommunityLeaderRight = 'canRemoveComments' | 'canRemoveDiscussions' | 'unspecified';

export type ContentAlternativeSlug = {
  __typename?: 'ContentAlternativeSlug';
  language: EntireFieldWrapper<ContentLanguage>;
  slug: EntireFieldWrapper<Scalars['String']>;
};

export type ContentAsset = {
  __typename?: 'ContentAsset';
  downloadable: EntireFieldWrapper<Scalars['Boolean']>;
  downloads_count: EntireFieldWrapper<Scalars['Int']>;
  file_path: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  product_id: EntireFieldWrapper<Scalars['ID']>;
  resolution?: EntireFieldWrapper<Maybe<ContentAssetResolution>>;
  size_bytes: EntireFieldWrapper<Scalars['Int']>;
  type: EntireFieldWrapper<ContentAssetType>;
  variant: EntireFieldWrapper<ContentAssetVariant>;
};

export type ContentAssetResolution = {
  __typename?: 'ContentAssetResolution';
  height: EntireFieldWrapper<Scalars['Int']>;
  width: EntireFieldWrapper<Scalars['Int']>;
};

export type ContentAssetResolutionV2 = {
  __typename?: 'ContentAssetResolutionV2';
  height: EntireFieldWrapper<Scalars['Int']>;
  width: EntireFieldWrapper<Scalars['Int']>;
};

export type ContentAssetType =
  | 'ASSET_TYPE_BACKGROUND_REMOVED'
  | 'ASSET_TYPE_DOWNSCALED'
  | 'ASSET_TYPE_ORIGINAL'
  | 'ASSET_TYPE_ORIGINAL_UNOPTIMIZED'
  | 'ASSET_TYPE_PREVIEW'
  | 'ASSET_TYPE_PRINTABLE'
  | 'ASSET_TYPE_THUMBNAIL'
  | 'ASSET_TYPE_UNSPECIFIED'
  | 'ASSET_TYPE_UPSCALED';

export type ContentAssetTypeV2 =
  /** This asset type is generated from the original image by applying a background remove algorithm. */
  | 'ASSET_TYPE_BACKGROUND_REMOVED'
  | 'ASSET_TYPE_DOWNSCALED'
  | 'ASSET_TYPE_ORIGINAL'
  | 'ASSET_TYPE_PREVIEW'
  | 'ASSET_TYPE_THUMBNAIL'
  | 'ASSET_TYPE_UNSPECIFIED'
  | 'ASSET_TYPE_UPSCALED';

export type ContentAssetV2 = {
  __typename?: 'ContentAssetV2';
  downloadsCount: EntireFieldWrapper<Scalars['Int']>;
  filePath: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  productId: EntireFieldWrapper<Scalars['ID']>;
  resolution?: EntireFieldWrapper<Maybe<ContentAssetResolutionV2>>;
  sizeBytes: EntireFieldWrapper<Scalars['Int']>;
  type: EntireFieldWrapper<ContentAssetTypeV2>;
  variant: EntireFieldWrapper<ContentAssetVariantV2>;
};

export type ContentAssetVariant =
  | 'ASSET_VARIANT_DESKTOP'
  | 'ASSET_VARIANT_LARGE'
  | 'ASSET_VARIANT_MEDIUM'
  | 'ASSET_VARIANT_MOBILE'
  | 'ASSET_VARIANT_SMALL'
  | 'ASSET_VARIANT_UNSPECIFIED'
  | 'ASSET_VARIANT_WATERMARKED'
  | 'ASSET_VARIANT_XLARGE'
  | 'ASSET_VARIANT_XSMALL';

export type ContentAssetVariantV2 =
  | 'ASSET_VARIANT_DESKTOP'
  | 'ASSET_VARIANT_LARGE'
  | 'ASSET_VARIANT_MEDIUM'
  | 'ASSET_VARIANT_MOBILE'
  | 'ASSET_VARIANT_SMALL'
  | 'ASSET_VARIANT_UNSPECIFIED'
  | 'ASSET_VARIANT_WATERMARKED'
  | 'ASSET_VARIANT_XLARGE';

export type ContentCategory = {
  __typename?: 'ContentCategory';
  _language: EntireFieldWrapper<ContentLanguage>;
  alternativeSlugs: EntireFieldWrapper<Array<ContentCategorySlug>>;
  ancestors: EntireFieldWrapper<Array<Scalars['String']>>;
  contentBottom: EntireFieldWrapper<Scalars['String']>;
  contentTop: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  name: EntireFieldWrapper<Scalars['String']>;
  parentId: EntireFieldWrapper<Scalars['String']>;
  parents: EntireFieldWrapper<Array<ContentCategory>>;
  root?: EntireFieldWrapper<Maybe<ContentCategory>>;
  seo: EntireFieldWrapper<ContentCategorySeo>;
  slug: EntireFieldWrapper<Scalars['String']>;
  totalProducts: EntireFieldWrapper<Scalars['Int']>;
  type: EntireFieldWrapper<Scalars['String']>;
};

export type ContentCategorySeo = {
  __typename?: 'ContentCategorySEO';
  description: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
};

export type ContentCategorySeoV2 = {
  __typename?: 'ContentCategorySeoV2';
  description: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
};

export type ContentCategorySlug = {
  __typename?: 'ContentCategorySlug';
  language: EntireFieldWrapper<ContentLanguage>;
  slug: EntireFieldWrapper<Scalars['String']>;
};

export type ContentCategorySlugV2 = {
  __typename?: 'ContentCategorySlugV2';
  language: EntireFieldWrapper<ContentLanguageV2>;
  slug: EntireFieldWrapper<Scalars['String']>;
};

export type ContentCategoryV2 = {
  __typename?: 'ContentCategoryV2';
  _language: EntireFieldWrapper<ContentLanguageV2>;
  alternativeSlugs: EntireFieldWrapper<Array<ContentCategorySlugV2>>;
  ancestors: EntireFieldWrapper<Array<Scalars['String']>>;
  contentBottom: EntireFieldWrapper<Scalars['String']>;
  contentTop: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  name: EntireFieldWrapper<Scalars['String']>;
  parentId: EntireFieldWrapper<Scalars['String']>;
  parents: EntireFieldWrapper<Array<ContentCategoryV2>>;
  root?: EntireFieldWrapper<Maybe<ContentCategoryV2>>;
  seo: EntireFieldWrapper<ContentCategorySeoV2>;
  slug: EntireFieldWrapper<Scalars['String']>;
  totalProducts: EntireFieldWrapper<Scalars['Int']>;
  type: EntireFieldWrapper<Scalars['String']>;
};

export type ContentCreateFavoriteListInput = {
  name: Scalars['String'];
};

export type ContentCreateReview = {
  body: Scalars['String'];
  getInTouch?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
  rating?: InputMaybe<Scalars['Int']>;
};

export type ContentDownloadAssetsInput = {
  ids: Array<Scalars['ID']>;
};

export type ContentDownloadSource = 'Studio' | 'Website';

export type ContentEditReview = {
  body?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  rating?: InputMaybe<Scalars['Int']>;
};

export type ContentFavorite = {
  __typename?: 'ContentFavorite';
  categories?: EntireFieldWrapper<Maybe<Array<ContentCategory>>>;
  categoryIds?: EntireFieldWrapper<Maybe<Array<Scalars['ID']>>>;
  createdAt: EntireFieldWrapper<Scalars['Time']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  listIds: EntireFieldWrapper<Array<Scalars['ID']>>;
  lists: EntireFieldWrapper<Array<ContentFavoriteList>>;
  product: EntireFieldWrapper<ContentProduct>;
  productId: EntireFieldWrapper<Scalars['ID']>;
  updatedAt: EntireFieldWrapper<Scalars['Time']>;
  userId: EntireFieldWrapper<Scalars['ID']>;
};

export type ContentFavoriteList = {
  __typename?: 'ContentFavoriteList';
  createdAt: EntireFieldWrapper<Scalars['Time']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  name: EntireFieldWrapper<Scalars['String']>;
  updatedAt: EntireFieldWrapper<Scalars['Time']>;
  userId: EntireFieldWrapper<Scalars['ID']>;
};

export type ContentFetchLicenseInput = {
  key?: InputMaybe<Scalars['ID']>;
  productID: Scalars['ID'];
  source?: InputMaybe<ContentDownloadSource>;
};

export type ContentLanguage =
  | 'LANGUAGE_DE'
  | 'LANGUAGE_EN'
  | 'LANGUAGE_ES'
  | 'LANGUAGE_FR'
  | 'LANGUAGE_IT'
  | 'LANGUAGE_NL'
  | 'LANGUAGE_PL'
  | 'LANGUAGE_PT_BR';

export type ContentLanguageV2 =
  | 'LANGUAGE_DE'
  | 'LANGUAGE_EN'
  | 'LANGUAGE_ES'
  | 'LANGUAGE_FR'
  | 'LANGUAGE_IT'
  | 'LANGUAGE_NL'
  | 'LANGUAGE_PL'
  | 'LANGUAGE_PT_BR';

export type ContentLicense = {
  __typename?: 'ContentLicense';
  createdAt: EntireFieldWrapper<Scalars['DateTime']>;
  key: EntireFieldWrapper<Scalars['ID']>;
};

export type ContentLinkBlock = {
  __typename?: 'ContentLinkBlock';
  id: EntireFieldWrapper<Scalars['ID']>;
  links: EntireFieldWrapper<Array<ContentLinkBlockLink>>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<ContentLinkBlockType>;
};

export type ContentLinkBlockLink = {
  __typename?: 'ContentLinkBlockLink';
  anchor: EntireFieldWrapper<Scalars['String']>;
  url: EntireFieldWrapper<Scalars['String']>;
};

export type ContentLinkBlockType = 'GENERATED' | 'MANUAL';

export type ContentListFavoritesInput = {
  cursor?: InputMaybe<Scalars['String']>;
  listId?: InputMaybe<Scalars['ID']>;
};

export type ContentMetadata = {
  __typename?: 'ContentMetadata';
  key: EntireFieldWrapper<Scalars['String']>;
  value: EntireFieldWrapper<Scalars['String']>;
};

export type ContentPagination = {
  __typename?: 'ContentPagination';
  categoryId: EntireFieldWrapper<Scalars['ID']>;
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  limit: EntireFieldWrapper<Scalars['Int']>;
  pages: EntireFieldWrapper<Scalars['Int']>;
  products: EntireFieldWrapper<Array<ContentProduct>>;
  type: EntireFieldWrapper<ContentPaginationType>;
};

export type ContentPaginationType = 'DiscoverMore' | 'Popularity' | 'Recommended' | 'Unspecified';

export type ContentPaginationV2 = {
  __typename?: 'ContentPaginationV2';
  categoryId: EntireFieldWrapper<Scalars['ID']>;
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  pages: EntireFieldWrapper<Scalars['Int']>;
  products: EntireFieldWrapper<Array<ContentProductPreview>>;
  type: EntireFieldWrapper<ContentPaginationType>;
};

export type ContentPaymentRequired = {
  __typename?: 'ContentPaymentRequired';
  paymentUrl: EntireFieldWrapper<Scalars['String']>;
  status: EntireFieldWrapper<Scalars['String']>;
};

export type ContentProduct = {
  __typename?: 'ContentProduct';
  _language: EntireFieldWrapper<ContentLanguage>;
  alternativeSlugs?: EntireFieldWrapper<Maybe<Array<ContentAlternativeSlug>>>;
  assets: EntireFieldWrapper<Array<ContentAsset>>;
  author_id: EntireFieldWrapper<Scalars['String']>;
  canonicalId: EntireFieldWrapper<Scalars['String']>;
  category: EntireFieldWrapper<ContentCategory>;
  category_id: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['Time']>;
  deleted_at?: EntireFieldWrapper<Maybe<Scalars['Time']>>;
  description: EntireFieldWrapper<Scalars['String']>;
  downloads_count: EntireFieldWrapper<Scalars['Int']>;
  format: EntireFieldWrapper<ContentProductFormat>;
  id: EntireFieldWrapper<Scalars['String']>;
  licenses: EntireFieldWrapper<Array<ContentLicense>>;
  linkBlocks: EntireFieldWrapper<Array<ContentLinkBlock>>;
  metadata: EntireFieldWrapper<Array<ContentMetadata>>;
  pricing: EntireFieldWrapper<ContentProductPricing>;
  publicAssets: EntireFieldWrapper<Array<ContentAsset>>;
  /** @deprecated Use top-level fields instead, e.g: title, description */
  seo: EntireFieldWrapper<ContentSeo>;
  slug: EntireFieldWrapper<Scalars['String']>;
  status: EntireFieldWrapper<ContentProductStatus>;
  tags?: EntireFieldWrapper<Maybe<Array<Scalars['String']>>>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<ContentProductType>;
  updated_at: EntireFieldWrapper<Scalars['Time']>;
  url: EntireFieldWrapper<Scalars['String']>;
  user_id: EntireFieldWrapper<Scalars['String']>;
  views_count: EntireFieldWrapper<Scalars['Int']>;
  woocommerce_product_id?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
};

export type ContentProductFavoriteCount = {
  __typename?: 'ContentProductFavoriteCount';
  total: EntireFieldWrapper<Scalars['Int']>;
  userIds: EntireFieldWrapper<Array<Scalars['ID']>>;
  users: EntireFieldWrapper<Array<PublicUserProfile>>;
};

export type ContentProductFormat =
  | 'PRODUCT_FORMAT_LANDSCAPE_3_2'
  | 'PRODUCT_FORMAT_LANDSCAPE_16_9'
  | 'PRODUCT_FORMAT_PORTRAIT_2_3'
  | 'PRODUCT_FORMAT_PORTRAIT_4_5'
  | 'PRODUCT_FORMAT_PORTRAIT_9_16'
  | 'PRODUCT_FORMAT_SQUARE_1_1'
  | 'PRODUCT_FORMAT_UNSPECIFIED';

export type ContentProductPreview = {
  __typename?: 'ContentProductPreview';
  authorId: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  previewHeight: EntireFieldWrapper<Scalars['Int']>;
  previewPath: EntireFieldWrapper<Scalars['String']>;
  previewWidth: EntireFieldWrapper<Scalars['Int']>;
  slug: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
};

export type ContentProductPricing = {
  __typename?: 'ContentProductPricing';
  price: EntireFieldWrapper<Scalars['Int']>;
  sale_price?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
};

export type ContentProductReviews = {
  __typename?: 'ContentProductReviews';
  _language: EntireFieldWrapper<ContentLanguage>;
  cursor: EntireFieldWrapper<Scalars['String']>;
  product: EntireFieldWrapper<ContentProduct>;
  productId: EntireFieldWrapper<Scalars['ID']>;
  rating: EntireFieldWrapper<ContentReviewRating>;
  replies: EntireFieldWrapper<Array<ContentReview>>;
  reviews: EntireFieldWrapper<Array<ContentReview>>;
};

export type ContentProductReviewsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  language: ContentLanguage;
  limit: Scalars['Int'];
  productId: Scalars['ID'];
};

export type ContentProductStats = {
  __typename?: 'ContentProductStats';
  downloads: EntireFieldWrapper<Scalars['Int']>;
  favorites: EntireFieldWrapper<Scalars['Int']>;
  views: EntireFieldWrapper<Scalars['Int']>;
};

export type ContentProductStatus =
  | 'STATUS_APPROVED'
  | 'STATUS_BLOCKED'
  | 'STATUS_DELETED'
  | 'STATUS_PENDING'
  | 'STATUS_PUBLISHED'
  | 'STATUS_UNSPECIFIED';

export type ContentProductType = 'PRODUCT_TYPE_CRAFT' | 'PRODUCT_TYPE_GRAPHICS' | 'PRODUCT_TYPE_UNSPECIFIED';

export type ContentReview = {
  __typename?: 'ContentReview';
  body: EntireFieldWrapper<Scalars['String']>;
  createdAt: EntireFieldWrapper<Scalars['Time']>;
  id: EntireFieldWrapper<Scalars['String']>;
  parentId?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  productId: EntireFieldWrapper<Scalars['String']>;
  rating?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  updatedAt: EntireFieldWrapper<Scalars['Time']>;
  user: EntireFieldWrapper<PublicUserProfile>;
  userId: EntireFieldWrapper<Scalars['String']>;
};

export type ContentReviewRating = {
  __typename?: 'ContentReviewRating';
  average: EntireFieldWrapper<Scalars['Float']>;
  count: EntireFieldWrapper<Scalars['Int']>;
  groups: EntireFieldWrapper<Array<ContentReviewRatingGroup>>;
};

export type ContentReviewRatingGroup = {
  __typename?: 'ContentReviewRatingGroup';
  count: EntireFieldWrapper<Scalars['Int']>;
  rating: EntireFieldWrapper<Scalars['Int']>;
};

export type ContentSeo = {
  __typename?: 'ContentSeo';
  description: EntireFieldWrapper<Scalars['String']>;
  h1: EntireFieldWrapper<Scalars['String']>;
  image_alt: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
};

export type ContentUpdateFavoriteInput = {
  listIds: Array<Scalars['ID']>;
  productId: Scalars['ID'];
};

export type ContentUpdateFavoriteListInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ContentUserFavoritesCountInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  language?: InputMaybe<ContentLanguage>;
};

export type ContentUserListCountPerCategory = {
  __typename?: 'ContentUserListCountPerCategory';
  category: EntireFieldWrapper<ContentCategory>;
  categoryId: EntireFieldWrapper<Scalars['ID']>;
  language: EntireFieldWrapper<ContentLanguage>;
  total: EntireFieldWrapper<Scalars['Int']>;
};

export type ContentUserListFavorites = {
  __typename?: 'ContentUserListFavorites';
  favorites?: EntireFieldWrapper<Maybe<Array<ContentFavorite>>>;
  total: EntireFieldWrapper<Scalars['Int']>;
};

export type ContentUserListFavoritesCount = {
  __typename?: 'ContentUserListFavoritesCount';
  total: EntireFieldWrapper<Scalars['Int']>;
  totalPerCategory?: EntireFieldWrapper<Maybe<Array<ContentUserListCountPerCategory>>>;
};

export type ContentUserListFavoritesInput = {
  categoryId?: InputMaybe<Scalars['ID']>;
  language: ContentLanguage;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type Contents = {
  __typename?: 'Contents';
  destinationUrl: EntireFieldWrapper<Scalars['String']>;
  template: EntireFieldWrapper<CampaignTemplateType>;
  templateFormatImageOnly?: EntireFieldWrapper<Maybe<TemplateFormatImageOnly>>;
  templateFormatImagesAndLogo?: EntireFieldWrapper<Maybe<TemplateFormatImagesAndLogo>>;
  templateFormatImagesAndText?: EntireFieldWrapper<Maybe<TemplateFormatImagesAndText>>;
  templateFormatVideoAndImage?: EntireFieldWrapper<Maybe<TemplateFormatVideoAndImage>>;
  templateFormatVideoOnly?: EntireFieldWrapper<Maybe<TemplateFormatVideoOnly>>;
};

export type CountryCode =
  | 'AD'
  | 'AE'
  | 'AF'
  | 'AG'
  | 'AI'
  | 'AL'
  | 'AM'
  | 'AO'
  | 'AQ'
  | 'AR'
  | 'AS'
  | 'AT'
  | 'AU'
  | 'AW'
  | 'AX'
  | 'AZ'
  | 'BA'
  | 'BB'
  | 'BD'
  | 'BE'
  | 'BF'
  | 'BG'
  | 'BH'
  | 'BI'
  | 'BJ'
  | 'BL'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BQ'
  | 'BR'
  | 'BS'
  | 'BT'
  | 'BV'
  | 'BW'
  | 'BY'
  | 'BZ'
  | 'CA'
  | 'CC'
  | 'CD'
  | 'CF'
  | 'CG'
  | 'CH'
  | 'CI'
  | 'CK'
  | 'CL'
  | 'CM'
  | 'CN'
  | 'CO'
  | 'CR'
  | 'CU'
  | 'CV'
  | 'CW'
  | 'CX'
  | 'CY'
  | 'CZ'
  | 'DE'
  | 'DJ'
  | 'DK'
  | 'DM'
  | 'DO'
  | 'DZ'
  | 'EC'
  | 'EE'
  | 'EG'
  | 'EH'
  | 'ER'
  | 'ES'
  | 'ET'
  | 'FI'
  | 'FJ'
  | 'FK'
  | 'FM'
  | 'FO'
  | 'FR'
  | 'GA'
  | 'GB'
  | 'GD'
  | 'GE'
  | 'GF'
  | 'GG'
  | 'GH'
  | 'GI'
  | 'GL'
  | 'GM'
  | 'GN'
  | 'GP'
  | 'GQ'
  | 'GR'
  | 'GS'
  | 'GT'
  | 'GU'
  | 'GW'
  | 'GY'
  | 'HK'
  | 'HM'
  | 'HN'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'ID'
  | 'IE'
  | 'IL'
  | 'IM'
  | 'IN'
  | 'IO'
  | 'IQ'
  | 'IR'
  | 'IS'
  | 'IT'
  | 'JE'
  | 'JM'
  | 'JO'
  | 'JP'
  | 'KE'
  | 'KG'
  | 'KH'
  | 'KI'
  | 'KM'
  | 'KN'
  | 'KP'
  | 'KR'
  | 'KW'
  | 'KY'
  | 'KZ'
  | 'LA'
  | 'LB'
  | 'LC'
  | 'LI'
  | 'LK'
  | 'LR'
  | 'LS'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'LY'
  | 'MA'
  | 'MC'
  | 'MD'
  | 'ME'
  | 'MF'
  | 'MG'
  | 'MH'
  | 'MK'
  | 'ML'
  | 'MM'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MQ'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MU'
  | 'MV'
  | 'MW'
  | 'MX'
  | 'MY'
  | 'MZ'
  | 'NA'
  | 'NC'
  | 'NE'
  | 'NF'
  | 'NG'
  | 'NI'
  | 'NL'
  | 'NO'
  | 'NP'
  | 'NR'
  | 'NU'
  | 'NZ'
  | 'OM'
  | 'PA'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PH'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PW'
  | 'PY'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RS'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SB'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SJ'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SR'
  | 'SS'
  | 'ST'
  | 'SV'
  | 'SX'
  | 'SY'
  | 'SZ'
  | 'TC'
  | 'TD'
  | 'TF'
  | 'TG'
  | 'TH'
  | 'TJ'
  | 'TK'
  | 'TL'
  | 'TM'
  | 'TN'
  | 'TO'
  | 'TR'
  | 'TT'
  | 'TV'
  | 'TW'
  | 'TZ'
  | 'UA'
  | 'UG'
  | 'UM'
  | 'US'
  | 'UY'
  | 'UZ'
  | 'VA'
  | 'VC'
  | 'VE'
  | 'VG'
  | 'VI'
  | 'VN'
  | 'VU'
  | 'WF'
  | 'WS'
  | 'YE'
  | 'YT'
  | 'ZA'
  | 'ZM'
  | 'ZW';

export type CreateIntentDataForSubscriptionResult = {
  __typename?: 'CreateIntentDataForSubscriptionResult';
  intent?: EntireFieldWrapper<Maybe<Intent>>;
  trialAlreadyActive?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  userBanned?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type Currency = {
  __typename?: 'Currency';
  code?: EntireFieldWrapper<Maybe<CurrencyCode>>;
  symbol: EntireFieldWrapper<Scalars['String']>;
};

export type CurrencyCode = 'aud' | 'cad' | 'cny' | 'dkk' | 'eur' | 'gbp' | 'jpy' | 'pln' | 'usd';

export type DateField = 'lastViewTime' | 'updateTime';

export type DateRange = 'last30Days' | 'last90Days' | 'lastYear' | 'today' | 'yesterday';

export type DeactivateAccountResponse = {
  __typename?: 'DeactivateAccountResponse';
  challenge?: EntireFieldWrapper<Maybe<AuthChallenge>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type DesignReview = {
  __typename?: 'DesignReview';
  alignmentAndProximity?: EntireFieldWrapper<Maybe<ReviewAspect>>;
  colorSchemeHarmonious?: EntireFieldWrapper<Maybe<ReviewAspect>>;
  colorSchemeSuitsPurpose?: EntireFieldWrapper<Maybe<ReviewAspect>>;
  compositionAndBalance?: EntireFieldWrapper<Maybe<ReviewAspect>>;
  consistency?: EntireFieldWrapper<Maybe<ReviewAspect>>;
  contrast?: EntireFieldWrapper<Maybe<ReviewAspect>>;
  graphicsAndImages?: EntireFieldWrapper<Maybe<ReviewAspect>>;
  hierarchyAndEmphasis?: EntireFieldWrapper<Maybe<ReviewAspect>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  imageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  overallScore?: EntireFieldWrapper<Maybe<ReviewAspect>>;
  status: EntireFieldWrapper<DesignReviewStatusType>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  typographyFontChoices?: EntireFieldWrapper<Maybe<ReviewAspect>>;
  typographyLegibility?: EntireFieldWrapper<Maybe<ReviewAspect>>;
  whiteSpace?: EntireFieldWrapper<Maybe<ReviewAspect>>;
};

export type DesignReviewStatusType = 'cancelled' | 'completed' | 'failed' | 'pending' | 'unspecified';

export type DesignReviewerCancelReviewRequestInput = {
  id: Scalars['String'];
};

export type DesignReviewerCancelReviewRequestResponse = {
  __typename?: 'DesignReviewerCancelReviewRequestResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type DesignReviewerDeleteAllReviewResponse = {
  __typename?: 'DesignReviewerDeleteAllReviewResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type DesignReviewerDeleteReviewInput = {
  id: Scalars['ID'];
};

export type DesignReviewerDeleteReviewResponse = {
  __typename?: 'DesignReviewerDeleteReviewResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type DesignReviewerGetReviewInput = {
  id: Scalars['ID'];
};

export type DesignReviewerGetReviewResponse = {
  __typename?: 'DesignReviewerGetReviewResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  review?: EntireFieldWrapper<Maybe<DesignReview>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type DesignReviewerListPagination = {
  __typename?: 'DesignReviewerListPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type DesignReviewerListReviewsInput = {
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
};

export type DesignReviewerListReviewsResponse = {
  __typename?: 'DesignReviewerListReviewsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<DesignReviewerListPagination>>;
  reviews?: EntireFieldWrapper<Maybe<Array<DesignReview>>>;
};

export type DesignReviewerUploadsCreateSignedUrlInput = {
  uploadFile: Scalars['String'];
};

export type DesignReviewerUploadsCreateSignedUrlResponse = {
  __typename?: 'DesignReviewerUploadsCreateSignedUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['String']>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type Discussion = {
  __typename?: 'Discussion';
  assets?: EntireFieldWrapper<Maybe<Array<ImageAsset>>>;
  clubhouseName: EntireFieldWrapper<Scalars['String']>;
  coinsCount: EntireFieldWrapper<Scalars['Int']>;
  comments?: EntireFieldWrapper<Maybe<Array<ClubhousesComment>>>;
  commentsCount: EntireFieldWrapper<Scalars['Int']>;
  content: EntireFieldWrapper<Scalars['String']>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  headline: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  /** @deprecated Use 'assets' instead */
  images?: EntireFieldWrapper<Maybe<Array<ImageAsset>>>;
  isLiked: EntireFieldWrapper<Scalars['Boolean']>;
  isSaved: EntireFieldWrapper<Scalars['Boolean']>;
  likesCount: EntireFieldWrapper<Scalars['Int']>;
  slug?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  topicId: EntireFieldWrapper<Scalars['Int']>;
  topicSlug?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  user?: EntireFieldWrapper<Maybe<PublicUserProfile>>;
  usersCount: EntireFieldWrapper<Scalars['Int']>;
};

export type DiscussionListItem = {
  __typename?: 'DiscussionListItem';
  clubhouseSlug: EntireFieldWrapper<Scalars['String']>;
  commentsCount: EntireFieldWrapper<Scalars['Int']>;
  headline: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  lastActivityAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  slug?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  topicSlug: EntireFieldWrapper<Scalars['String']>;
  usersCount: EntireFieldWrapper<Scalars['Int']>;
};

export type DiscussionsStats = {
  __typename?: 'DiscussionsStats';
  reactionsReceivedCount: EntireFieldWrapper<Scalars['Int']>;
  topicsCount: EntireFieldWrapper<Scalars['Int']>;
};

export type EditUserProfileInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type EditUserProfileResponse = {
  __typename?: 'EditUserProfileResponse';
  error?: EntireFieldWrapper<Maybe<ErrorGrowth>>;
};

export type EmailAddress = {
  __typename?: 'EmailAddress';
  email: EntireFieldWrapper<Scalars['String']>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type EmailAddressInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type EnterpriseRequest = {
  __typename?: 'EnterpriseRequest';
  asset: EntireFieldWrapper<Scalars['String']>;
  createdAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  email: EntireFieldWrapper<Scalars['String']>;
  employees: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  job?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
  owner?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  project?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  usages: EntireFieldWrapper<Array<EnterpriseRequestUsage>>;
};

export type EnterpriseRequestEmployees =
  | 'ELEVEN_TO_FIFTY'
  | 'FIFTY_ONE_TO_ONE_HUNDRED'
  | 'MORE_THAN_FIVE_HUNDRED'
  | 'ONE_HUNDRED_ONE_TO_FIVE_HUNDRED'
  | 'ONE_TO_TEN';

export type EnterpriseRequestUsage = {
  __typename?: 'EnterpriseRequestUsage';
  answer: EntireFieldWrapper<Scalars['String']>;
  enterpriseReqId: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  question: EntireFieldWrapper<Scalars['String']>;
  usage: EntireFieldWrapper<Scalars['String']>;
};

export type EntityDownloadInput = {
  entityId: Scalars['ID'];
  entityType: StudioSocialReactionEntityType;
};

export type EntityDownloadResponse = {
  __typename?: 'EntityDownloadResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
  url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type EntityLoveInput = {
  entityId: Scalars['ID'];
  entityType: StudioSocialReactionEntityType;
};

export type EntityLoveResponse = {
  __typename?: 'EntityLoveResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type EntityReactDeleteInput = {
  entityId: Scalars['ID'];
  entityType: StudioSocialReactionEntityType;
};

export type EntityReactDeleteResponse = {
  __typename?: 'EntityReactDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type EntityReactInput = {
  entityId: Scalars['ID'];
  entityType: StudioSocialReactionEntityType;
  reaction: EntityReactionType;
};

export type EntityReactResponse = {
  __typename?: 'EntityReactResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  reaction?: EntireFieldWrapper<Maybe<EntityReaction>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type EntityReaction = {
  __typename?: 'EntityReaction';
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  deleteTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  entityId: EntireFieldWrapper<Scalars['ID']>;
  entityType: EntireFieldWrapper<StudioSocialReactionEntityType>;
  id: EntireFieldWrapper<Scalars['ID']>;
  reaction: EntireFieldWrapper<EntityReactionType>;
  user: EntireFieldWrapper<PublicUserProfile>;
};

export type EntityReactionType = 'Favorite' | 'Unspecified';

export type EntityReactionsInput = {
  afterId?: InputMaybe<Scalars['ID']>;
  entityId: Scalars['ID'];
  entityType: StudioSocialReactionEntityType;
  take?: InputMaybe<Scalars['Int']>;
};

export type EntityReactionsResponse = {
  __typename?: 'EntityReactionsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasMore?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  reactions?: EntireFieldWrapper<Maybe<Array<EntityReaction>>>;
};

export type EntityStatsResponse = {
  __typename?: 'EntityStatsResponse';
  downloads: EntireFieldWrapper<Scalars['Int']>;
  entityId: EntireFieldWrapper<Scalars['ID']>;
  entityType: EntireFieldWrapper<StudioSocialReactionEntityType>;
  loves: EntireFieldWrapper<Scalars['Int']>;
  onlineViewers: EntireFieldWrapper<Scalars['Int']>;
  tips: EntireFieldWrapper<Scalars['Int']>;
  views: EntireFieldWrapper<Scalars['Int']>;
};

export type EntityViewInput = {
  entityId: Scalars['ID'];
  entityType: StudioSocialReactionEntityType;
};

export type ErrorCode =
  | 'badRequest'
  | 'conflict'
  | 'failedPrecondition'
  | 'forbidden'
  | 'internal'
  | 'notFound'
  | 'permissionDenied'
  | 'tooManyRequests'
  | 'unauthorized';

export type ErrorGrowth = {
  __typename?: 'ErrorGrowth';
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type: EntireFieldWrapper<ErrorTypeGrowth>;
};

export type ErrorMessage = {
  __typename?: 'ErrorMessage';
  code: EntireFieldWrapper<ErrorCode>;
  fields?: EntireFieldWrapper<Maybe<Array<Maybe<FieldError>>>>;
  message: EntireFieldWrapper<Scalars['String']>;
};

export type ErrorTypeGrowth = 'internal';

export type ExtendSubscriptionResult = {
  __typename?: 'ExtendSubscriptionResult';
  maxExtensionsReached?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  nextPaymentDate?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  payInvoiceUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  paymentStatus: EntireFieldWrapper<PaymentStatus>;
  userBanned?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type FieldError = {
  __typename?: 'FieldError';
  errors: EntireFieldWrapper<Array<Scalars['String']>>;
  field: EntireFieldWrapper<Scalars['String']>;
};

export type Flow = {
  __typename?: 'Flow';
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  deleteTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  iterations: EntireFieldWrapper<Array<FlowIteration>>;
  lastIteration: EntireFieldWrapper<FlowIteration>;
  owner: EntireFieldWrapper<Scalars['Boolean']>;
  stats?: EntireFieldWrapper<Maybe<FlowStats>>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updateTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  user: EntireFieldWrapper<PublicUserProfile>;
  visibility: EntireFieldWrapper<FlowVisibility>;
};

export type FlowAspectRatio = 'landscape_4_3' | 'landscape_16_9' | 'portrait_3_4' | 'portrait_9_16' | 'square';

export type FlowCancelIterationPageInput = {
  id: Scalars['ID'];
};

export type FlowCancelIterationPageResponse = {
  __typename?: 'FlowCancelIterationPageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FlowEffect =
  | 'analog'
  | 'glitch'
  | 'lessSaturated'
  | 'moreSaturated'
  | 'none'
  | 'pixelate'
  | 'poster'
  | 'sepia'
  | 'sketch'
  | 'threeDGlasses';

export type FlowFeed = {
  __typename?: 'FlowFeed';
  /** @deprecated use items field instead */
  flows: EntireFieldWrapper<Array<Flow>>;
  items: EntireFieldWrapper<Array<FlowFeedItem>>;
};

export type FlowFeedItem = {
  __typename?: 'FlowFeedItem';
  deleteTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  visibility: EntireFieldWrapper<FlowVisibility>;
};

export type FlowFlowsTippedInput = {
  id: Scalars['String'];
};

export type FlowGenerationsCountResponse = {
  __typename?: 'FlowGenerationsCountResponse';
  created: EntireFieldWrapper<Scalars['Int']>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasUnlimited: EntireFieldWrapper<Scalars['Boolean']>;
  remaining?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
};

export type FlowGetIterationPageRatingInput = {
  pageId: Scalars['String'];
};

export type FlowGetIterationPageRatingResponse = {
  __typename?: 'FlowGetIterationPageRatingResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  rating: EntireFieldWrapper<IterationRating>;
};

export type FlowImage = {
  __typename?: 'FlowImage';
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  errorMessage?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  imageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  published: EntireFieldWrapper<Scalars['Boolean']>;
  state: EntireFieldWrapper<FlowImageState>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type FlowImageFlowInput = {
  imageId: Scalars['ID'];
};

export type FlowImageFlowResponse = {
  __typename?: 'FlowImageFlowResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  flow?: EntireFieldWrapper<Maybe<Flow>>;
};

export type FlowImageGetFavoritesInput = {
  after?: InputMaybe<Scalars['String']>;
  take: Scalars['Int'];
};

export type FlowImageGetFavoritesResponse = {
  __typename?: 'FlowImageGetFavoritesResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  favorites?: EntireFieldWrapper<Maybe<Array<FlowImageReaction>>>;
  hasMore: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FlowImageGetReactions = {
  __typename?: 'FlowImageGetReactions';
  counter?: EntireFieldWrapper<Maybe<FlowImageReactionsCounter>>;
  imageId: EntireFieldWrapper<Scalars['ID']>;
  userReaction?: EntireFieldWrapper<Maybe<ImageReaction>>;
};

export type FlowImageGetReactionsInput = {
  imageIds: Array<Scalars['ID']>;
};

export type FlowImageGetReactionsResponse = {
  __typename?: 'FlowImageGetReactionsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  reactions?: EntireFieldWrapper<Maybe<Array<FlowImageGetReactions>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FlowImageInput = {
  id: Scalars['ID'];
};

export type FlowImageReactInput = {
  imageId: Scalars['ID'];
  reaction: ImageReaction;
};

export type FlowImageReactResponse = {
  __typename?: 'FlowImageReactResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FlowImageReaction = {
  __typename?: 'FlowImageReaction';
  flowId: EntireFieldWrapper<Scalars['ID']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  imageId: EntireFieldWrapper<Scalars['ID']>;
  imageUrl: EntireFieldWrapper<Scalars['String']>;
  reactionTime: EntireFieldWrapper<Scalars['DateTime']>;
  thumbnailUrl: EntireFieldWrapper<Scalars['String']>;
};

export type FlowImageReactionsCounter = {
  __typename?: 'FlowImageReactionsCounter';
  Like: EntireFieldWrapper<Scalars['Int']>;
};

export type FlowImageRemoveReactInput = {
  imageId: Scalars['ID'];
};

export type FlowImageRemoveReactResponse = {
  __typename?: 'FlowImageRemoveReactResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FlowImageReportInput = {
  comment?: InputMaybe<Scalars['String']>;
  imageId: Scalars['ID'];
  reason: FlowImageReportReason;
};

export type FlowImageReportReason =
  | 'ChildEndangerment'
  | 'CopyRight'
  | 'HateDiscrimination'
  | 'Nudity'
  | 'Spam'
  | 'UnlawfulContent'
  | 'Unspecified'
  | 'Violence';

export type FlowImageReportResponse = {
  __typename?: 'FlowImageReportResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FlowImageResponse = {
  __typename?: 'FlowImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  image?: EntireFieldWrapper<Maybe<FlowImage>>;
};

export type FlowImageState = 'failed' | 'generated';

export type FlowImageTop = {
  __typename?: 'FlowImageTop';
  aspectRatio: EntireFieldWrapper<FlowAspectRatio>;
  counter: EntireFieldWrapper<FlowImageReactionsCounter>;
  flowId: EntireFieldWrapper<Scalars['ID']>;
  imageId: EntireFieldWrapper<Scalars['ID']>;
  imageUrl: EntireFieldWrapper<Scalars['String']>;
  iterationId: EntireFieldWrapper<Scalars['ID']>;
  prompt: EntireFieldWrapper<Scalars['String']>;
  thumbnailUrl: EntireFieldWrapper<Scalars['String']>;
  userId: EntireFieldWrapper<Scalars['ID']>;
};

export type FlowImagesTopAllTimeInput = {
  after?: InputMaybe<Scalars['Int']>;
  take: Scalars['Int'];
};

export type FlowImagesTopAllTimeResponse = {
  __typename?: 'FlowImagesTopAllTimeResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasMore: EntireFieldWrapper<Scalars['Boolean']>;
  images?: EntireFieldWrapper<Maybe<Array<FlowImageTop>>>;
  total?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
};

export type FlowImagesTopInput = {
  after: Scalars['Int'];
  take: Scalars['Int'];
};

export type FlowImagesTopResponse = {
  __typename?: 'FlowImagesTopResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasMore: EntireFieldWrapper<Scalars['Boolean']>;
  images?: EntireFieldWrapper<Maybe<Array<FlowImageTop>>>;
  total?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
};

export type FlowInteractionInput = {
  id: Scalars['ID'];
};

export type FlowInteractionResponse = {
  __typename?: 'FlowInteractionResponse';
  downloadsTotal?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  heartsTotal?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  imageReactionsTotal?: EntireFieldWrapper<Maybe<FlowInteractionImageReactionTotal>>;
  tipsTotal?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  viewsTotal?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
};

export type FlowIteration = {
  __typename?: 'FlowIteration';
  aspectRatio?: EntireFieldWrapper<Maybe<FlowAspectRatio>>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  /** @deprecated No longer supported */
  effect?: EntireFieldWrapper<Maybe<FlowEffect>>;
  fileType?: EntireFieldWrapper<Maybe<FlowIterationFileType>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  imageId?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  imageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  pages: EntireFieldWrapper<Array<FlowIterationPage>>;
  pagesTotal: EntireFieldWrapper<Scalars['Int']>;
  prompt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** @deprecated No longer supported */
  quality?: EntireFieldWrapper<Maybe<FlowQuality>>;
  resolution?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  results: EntireFieldWrapper<Array<FlowImage>>;
  style: EntireFieldWrapper<FlowStyle>;
  type: EntireFieldWrapper<FlowType>;
};

export type FlowIterationFileType = 'png' | 'svg' | 'unknown';

export type FlowIterationPage = {
  __typename?: 'FlowIterationPage';
  cancelled: EntireFieldWrapper<Scalars['Boolean']>;
  pageID: EntireFieldWrapper<Scalars['String']>;
  results: EntireFieldWrapper<Array<FlowImage>>;
};

export type FlowIterationPagesInput = {
  after?: InputMaybe<Scalars['String']>;
  iterationId: Scalars['ID'];
  take?: InputMaybe<Scalars['Int']>;
};

export type FlowIterationPagesResponse = {
  __typename?: 'FlowIterationPagesResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasMore: EntireFieldWrapper<Scalars['Boolean']>;
  pages: EntireFieldWrapper<Array<FlowIterationPage>>;
};

export type FlowIterationRateInput = {
  iterationId: Scalars['String'];
  rating: IterationRating;
};

export type FlowIterationRateResponse = {
  __typename?: 'FlowIterationRateResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FlowIterationsInput = {
  after?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type FlowPreview = {
  __typename?: 'FlowPreview';
  flowId: EntireFieldWrapper<Scalars['ID']>;
  isGenerating: EntireFieldWrapper<Scalars['Boolean']>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  visibility: EntireFieldWrapper<FlowVisibility>;
};

export type FlowPreviewSort = 'newest' | 'top';

export type FlowPublishImageInput = {
  id: Scalars['String'];
};

export type FlowPublishImageResponse = {
  __typename?: 'FlowPublishImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  upload?: EntireFieldWrapper<Maybe<StudioUploadsFile>>;
};

export type FlowQuality = 'high' | 'low';

export type FlowQueue = {
  __typename?: 'FlowQueue';
  flowID: EntireFieldWrapper<Scalars['ID']>;
  position: EntireFieldWrapper<Scalars['Int']>;
};

export type FlowRateIterationPageInput = {
  pageId: Scalars['String'];
  rating: IterationRating;
};

export type FlowRateIterationPageResponse = {
  __typename?: 'FlowRateIterationPageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FlowSettingsInput = {
  aspectRatio?: InputMaybe<FlowAspectRatio>;
  effect?: InputMaybe<FlowEffect>;
  imageId?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<FlowQuality>;
  style: FlowStyle;
  type: FlowType;
  visibility?: InputMaybe<FlowVisibility>;
};

export type FlowStats = {
  __typename?: 'FlowStats';
  downloads: EntireFieldWrapper<Scalars['Int']>;
  hearts: EntireFieldWrapper<Scalars['Int']>;
  tips: EntireFieldWrapper<Scalars['Int']>;
  views: EntireFieldWrapper<Scalars['Int']>;
};

export type FlowStatus = {
  __typename?: 'FlowStatus';
  active: EntireFieldWrapper<Scalars['Boolean']>;
  flowId: EntireFieldWrapper<Scalars['ID']>;
};

export type FlowStyle =
  | 'CFVanillaClipart512x001'
  | 'deliberate'
  | 'openjourney'
  | 'photoreal'
  | 'protogen'
  | 'redshift'
  | 'synthwave'
  | 'v2_cartoon'
  | 'v2_cyberpunk'
  | 'v2_inkBlot'
  | 'v2_kawaii'
  | 'v2_lowPoly'
  | 'v2_none'
  | 'v2_photoreal'
  | 'v2_style3d'
  | 'v2_watercolor'
  | 'vectorartz';

export type FlowType =
  | 'animation'
  | 'full'
  | 'pattern'
  | 'svg'
  | 'transparent'
  | 'v2_full'
  | 'v2_pattern'
  | 'v2_transparent';

export type FlowViewersResponse = {
  __typename?: 'FlowViewersResponse';
  activeUsers: EntireFieldWrapper<Array<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['String']>;
  totalViewers: EntireFieldWrapper<Scalars['Int']>;
};

export type FlowVisibility = 'private' | 'public';

export type FlowsFlowTippedResponse = {
  __typename?: 'FlowsFlowTippedResponse';
  tipped: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FlowsPreviewUserFlowsInput = {
  afterId?: InputMaybe<Scalars['String']>;
  createdByUserId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<FlowPreviewSort>;
  take: Scalars['Int'];
};

export type FlowsPreviewUserFlowsResponse = {
  __typename?: 'FlowsPreviewUserFlowsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasMore: EntireFieldWrapper<Scalars['Boolean']>;
  previews: EntireFieldWrapper<Array<FlowPreview>>;
};

export type Font = {
  __typename?: 'Font';
  category: EntireFieldWrapper<FontCategory>;
  /** @deprecated use createdAt */
  claimedAt: EntireFieldWrapper<Scalars['String']>;
  createdAt: EntireFieldWrapper<Scalars['String']>;
  /** @deprecated use subscription stats values */
  downloads: EntireFieldWrapper<Scalars['Int']>;
  fontThumbnailUrl: EntireFieldWrapper<Scalars['String']>;
  /** @deprecated No longer supported */
  fontUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  /** @deprecated use subscription stats values */
  loves: EntireFieldWrapper<Scalars['Int']>;
  prompt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  reactions: EntireFieldWrapper<Scalars['Int']>;
  /** @deprecated shouldn't be used */
  status?: EntireFieldWrapper<Maybe<GeneratedFontStatus>>;
  title: EntireFieldWrapper<Scalars['String']>;
  user: EntireFieldWrapper<PublicUserProfile>;
  userReaction?: EntireFieldWrapper<Maybe<EntityReactionType>>;
  /** @deprecated use subscription stats values */
  views: EntireFieldWrapper<Scalars['Int']>;
};

export type FontCategory = 'Artistic' | 'Decorative' | 'Fancy' | 'SansSerif' | 'Undefined';

export type FontGeneratorAcceptSymbolResponse = {
  __typename?: 'FontGeneratorAcceptSymbolResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FontGeneratorCancelSymbolResponse = {
  __typename?: 'FontGeneratorCancelSymbolResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FontGeneratorFontCreateInput = {
  category?: InputMaybe<GeneratedFontCategory>;
  fontCategory: FontCategory;
  prompt: Scalars['String'];
  visibility?: InputMaybe<GeneratedFontVisibility>;
};

export type FontGeneratorFontCreateResponse = {
  __typename?: 'FontGeneratorFontCreateResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  fontId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FontGeneratorFontDownloadResponse = {
  __typename?: 'FontGeneratorFontDownloadResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  font?: EntireFieldWrapper<Maybe<GeneratedFont>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FontGeneratorFontInput = {
  id: Scalars['ID'];
};

export type FontGeneratorFontProgressResponse = {
  __typename?: 'FontGeneratorFontProgressResponse';
  readiness: EntireFieldWrapper<Scalars['Int']>;
};

export type FontGeneratorFontResponse = {
  __typename?: 'FontGeneratorFontResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  font?: EntireFieldWrapper<Maybe<GeneratedFont>>;
};

export type FontGeneratorFontUpdateFields = 'title' | 'visibility';

export type FontGeneratorFontUpdateInput = {
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  updateFields: Array<FontGeneratorFontUpdateFields>;
  visibility?: InputMaybe<GeneratedFontVisibility>;
};

export type FontGeneratorFontUpdateResponse = {
  __typename?: 'FontGeneratorFontUpdateResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FontGeneratorFontsFeedInput = {
  afterId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<GeneratedFontCategory>;
  sort?: InputMaybe<FontsFeedSort>;
  take?: InputMaybe<Scalars['Int']>;
};

export type FontGeneratorFontsFeedResponse = {
  __typename?: 'FontGeneratorFontsFeedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  fonts?: EntireFieldWrapper<Maybe<Array<Font>>>;
  hasMore?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type FontGeneratorFontsInput = {
  afterId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<GeneratedFontCategory>;
  take?: InputMaybe<Scalars['Int']>;
};

export type FontGeneratorFontsResponse = {
  __typename?: 'FontGeneratorFontsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  fonts?: EntireFieldWrapper<Maybe<Array<GeneratedFont>>>;
  hasMore?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type FontGeneratorSymbolGenerateInput = {
  fontId: Scalars['ID'];
  fontSymbol: FontSymbolName;
};

export type FontGeneratorSymbolGenerateResponse = {
  __typename?: 'FontGeneratorSymbolGenerateResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FontGeneratorSymbolProgressResponse = {
  __typename?: 'FontGeneratorSymbolProgressResponse';
  readiness: EntireFieldWrapper<Scalars['Int']>;
};

export type FontGeneratorUserFontCreateInput = {
  category: FontCategory;
  prompt: Scalars['String'];
  visibility?: InputMaybe<GeneratedFontVisibility>;
};

export type FontGeneratorUserFontCreateResponse = {
  __typename?: 'FontGeneratorUserFontCreateResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  fontId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FontGeneratorUserFontDeleteAllResponse = {
  __typename?: 'FontGeneratorUserFontDeleteAllResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FontGeneratorUserFontDeleteInput = {
  id: Scalars['ID'];
};

export type FontGeneratorUserFontDeleteResponse = {
  __typename?: 'FontGeneratorUserFontDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FontGeneratorUserFontInput = {
  id: Scalars['ID'];
};

export type FontGeneratorUserFontPackResponse = {
  __typename?: 'FontGeneratorUserFontPackResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  font?: EntireFieldWrapper<Maybe<GeneratedFont>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FontGeneratorUserFontProgressResponse = {
  __typename?: 'FontGeneratorUserFontProgressResponse';
  readiness: EntireFieldWrapper<Scalars['Int']>;
};

export type FontGeneratorUserFontResponse = {
  __typename?: 'FontGeneratorUserFontResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  font?: EntireFieldWrapper<Maybe<GeneratedFont>>;
};

export type FontGeneratorUserFontUpdateInput = {
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  updateFields: Array<FontGeneratorFontUpdateFields>;
  visibility?: InputMaybe<GeneratedFontVisibility>;
};

export type FontGeneratorUserFontUpdateResponse = {
  __typename?: 'FontGeneratorUserFontUpdateResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type FontGeneratorUserFontsInput = {
  afterId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<FontCategory>;
  take?: InputMaybe<Scalars['Int']>;
};

export type FontGeneratorUserFontsResponse = {
  __typename?: 'FontGeneratorUserFontsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  fonts?: EntireFieldWrapper<Maybe<Array<GeneratedFont>>>;
  hasMore?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type FontSymbol = {
  __typename?: 'FontSymbol';
  createdAt: EntireFieldWrapper<Scalars['String']>;
  fontSymbol: EntireFieldWrapper<FontSymbolName>;
  fontSymbolUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  status: EntireFieldWrapper<FontSymbolStatus>;
};

export type FontSymbolName =
  | 'ampersand'
  | 'apostrophe'
  | 'asterisk'
  | 'circumflex_accent'
  | 'colon'
  | 'comma'
  | 'commercial_at'
  | 'dollar_sign'
  | 'eight'
  | 'equals_sign'
  | 'euro'
  | 'exclamation_mark'
  | 'five'
  | 'four'
  | 'full_stop'
  | 'grave_accent'
  | 'greater_than_sign'
  | 'hyphen_minus'
  | 'left_curly_bracket'
  | 'left_parenthesis'
  | 'left_square_bracket'
  | 'less_than_sign'
  | 'low_line'
  | 'lower_a'
  | 'lower_b'
  | 'lower_c'
  | 'lower_d'
  | 'lower_e'
  | 'lower_f'
  | 'lower_g'
  | 'lower_h'
  | 'lower_i'
  | 'lower_j'
  | 'lower_k'
  | 'lower_l'
  | 'lower_m'
  | 'lower_n'
  | 'lower_o'
  | 'lower_p'
  | 'lower_q'
  | 'lower_r'
  | 'lower_s'
  | 'lower_t'
  | 'lower_u'
  | 'lower_v'
  | 'lower_w'
  | 'lower_x'
  | 'lower_y'
  | 'lower_z'
  | 'nine'
  | 'number_sign'
  | 'one'
  | 'percent_sign'
  | 'plus_sign'
  | 'pound'
  | 'question_mark'
  | 'quotation_mark'
  | 'reverse_solidus'
  | 'right_curly_bracket'
  | 'right_parenthesis'
  | 'right_square_bracket'
  | 'semicolon'
  | 'seven'
  | 'six'
  | 'solidus'
  | 'three'
  | 'tilde'
  | 'two'
  | 'unspecified'
  | 'upper_a'
  | 'upper_b'
  | 'upper_c'
  | 'upper_d'
  | 'upper_e'
  | 'upper_f'
  | 'upper_g'
  | 'upper_h'
  | 'upper_i'
  | 'upper_j'
  | 'upper_k'
  | 'upper_l'
  | 'upper_m'
  | 'upper_n'
  | 'upper_o'
  | 'upper_p'
  | 'upper_q'
  | 'upper_r'
  | 'upper_s'
  | 'upper_t'
  | 'upper_u'
  | 'upper_v'
  | 'upper_w'
  | 'upper_x'
  | 'upper_y'
  | 'upper_z'
  | 'vertical_line'
  | 'zero';

export type FontSymbolStatus = 'accepted' | 'discarded' | 'error' | 'generated' | 'generating' | 'unspecified';

export type FontType = 'otf' | 'ttf' | 'undefined' | 'woff' | 'woff2';

export type FontsFeedFontBrowserInput = {
  category?: InputMaybe<FontCategory>;
  id: Scalars['ID'];
  sort: FontsFeedSort;
};

export type FontsFeedFontBrowserResponse = {
  __typename?: 'FontsFeedFontBrowserResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  nextId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  previousId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
};

export type FontsFeedFontResponse = {
  __typename?: 'FontsFeedFontResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  font?: EntireFieldWrapper<Maybe<Font>>;
};

export type FontsFeedInput = {
  afterId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<FontCategory>;
  sort?: InputMaybe<FontsFeedSort>;
  take?: InputMaybe<Scalars['Int']>;
};

export type FontsFeedResponse = {
  __typename?: 'FontsFeedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  fonts?: EntireFieldWrapper<Maybe<Array<Font>>>;
  hasMore?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type FontsFeedSort = 'CreateTime' | 'Reactions' | 'Unspecified';

export type FontsFeedUpdatesResponse = {
  __typename?: 'FontsFeedUpdatesResponse';
  font: EntireFieldWrapper<Font>;
};

export type GeneratedFont = {
  __typename?: 'GeneratedFont';
  /** @deprecated use font category */
  category: EntireFieldWrapper<GeneratedFontCategory>;
  /** @deprecated No longer supported */
  claimedAt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  createdAt: EntireFieldWrapper<Scalars['String']>;
  deletedAt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  errorMessage?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  fontCategory: EntireFieldWrapper<FontCategory>;
  fontSymbols?: EntireFieldWrapper<Maybe<Array<FontSymbol>>>;
  fontThumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** @deprecated No longer supported */
  fontUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  missingGlyphs?: EntireFieldWrapper<Maybe<Array<FontSymbolName>>>;
  /** @deprecated No longer supported */
  originalUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  prompt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  status: EntireFieldWrapper<GeneratedFontStatus>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updatedAt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  visibility: EntireFieldWrapper<GeneratedFontVisibility>;
};

export type GeneratedFontCategory = 'Artistic' | 'Decorative' | 'Fancy' | 'Undefined';

export type GeneratedFontStatus =
  | 'customizing'
  | 'error'
  | 'finalized'
  | 'generated'
  | 'generating'
  | 'packing'
  | 'unspecified';

export type GeneratedFontVisibility = 'Private' | 'Public' | 'Undefined';

export type GeneratedFontsDeleteAllForUserResponse = {
  __typename?: 'GeneratedFontsDeleteAllForUserResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type GeneratedFontsDeleteInput = {
  id: Scalars['ID'];
};

export type GeneratedFontsDeleteResponse = {
  __typename?: 'GeneratedFontsDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type GetClubhouseInput = {
  clubhouseSlug: Scalars['String'];
};

export type GetClubhouseResponse = {
  __typename?: 'GetClubhouseResponse';
  clubhouse: EntireFieldWrapper<Clubhouse>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type GetClubhouseTopicInput = {
  clubhouseSlug: Scalars['String'];
  topicSlug: Scalars['String'];
};

export type GetClubhouseTopicResponse = {
  __typename?: 'GetClubhouseTopicResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  topic: EntireFieldWrapper<Topic>;
};

export type GetProductTagsInput = {
  language?: InputMaybe<Language>;
  productId: Scalars['Int'];
};

export type GetRedeemRewardInput = {
  code: Scalars['String'];
  provider: RedeemProvider;
};

export type GetUserSubscriptionInput = {
  subscriptionId: Scalars['String'];
};

export type GetUserSubscriptionResponse = {
  __typename?: 'GetUserSubscriptionResponse';
  error?: EntireFieldWrapper<Maybe<ErrorGrowth>>;
  subscription?: EntireFieldWrapper<Maybe<CfSubscription>>;
};

export type HalloweenSubscriptionPurchase = {
  __typename?: 'HalloweenSubscriptionPurchase';
  bundlePart1?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  bundlePart2?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  bundlePart3?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  error: EntireFieldWrapper<Scalars['String']>;
};

export type HealthCheckResponse = {
  __typename?: 'HealthCheckResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type HealthZResponse = {
  __typename?: 'HealthZResponse';
  timestamp: EntireFieldWrapper<Scalars['String']>;
  userId?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type HelpChannel = 'studio';

export type HelpConversation = {
  __typename?: 'HelpConversation';
  id: EntireFieldWrapper<Scalars['ID']>;
  messages: EntireFieldWrapper<Array<HelpMessage>>;
};

export type HelpMessage = {
  __typename?: 'HelpMessage';
  content: EntireFieldWrapper<Scalars['String']>;
  createdAt: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  rate: EntireFieldWrapper<HelpMessageRate>;
  sender: EntireFieldWrapper<HelpMessageSender>;
  type: EntireFieldWrapper<HelpMessageType>;
};

export type HelpMessageRate = 'negative' | 'positive' | 'unspecified';

export type HelpMessageSender = 'bot' | 'user';

export type HelpMessageType =
  | 'audio'
  | 'error'
  | 'file'
  | 'forbiddenTopic'
  | 'image'
  | 'negativeFeedback'
  | 'negativeSentiment'
  | 'positiveFeedback'
  | 'proposedReply'
  | 'text'
  | 'update'
  | 'video';

export type Image = {
  __typename?: 'Image';
  height?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  url: EntireFieldWrapper<Scalars['String']>;
  width?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
};

export type ImageAsset = {
  __typename?: 'ImageAsset';
  id: EntireFieldWrapper<Scalars['ID']>;
  optimizedUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  url: EntireFieldWrapper<Scalars['String']>;
};

export type ImageReaction = 'Like';

export type IncreaseDownloadCountInput = {
  productId: Scalars['ID'];
};

export type IncreaseDownloadCountResponse = {
  __typename?: 'IncreaseDownloadCountResponse';
  errors: EntireFieldWrapper<Array<ErrorMessage>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type Intent = {
  __typename?: 'Intent';
  clientSecret: EntireFieldWrapper<Scalars['String']>;
  stripeCustomerId: EntireFieldWrapper<Scalars['String']>;
  stripeSubscriptionId: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<IntentType>;
};

export type IntentType = 'payment' | 'setup';

export type InvitationStatus = 'Accepted' | 'AlreadyInvited' | 'AwaitingAdminApproval' | 'Invited' | 'Unknown';

export type InvitedTeamMember = {
  __typename?: 'InvitedTeamMember';
  email: EntireFieldWrapper<Scalars['String']>;
  invitationId: EntireFieldWrapper<Scalars['String']>;
  role: EntireFieldWrapper<Role>;
};

export type IsSubscribedToDigestInput = {
  clubhouseSlug: Scalars['String'];
};

export type IsSubscribedToDigestResponse = {
  __typename?: 'IsSubscribedToDigestResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  isSubscribed: EntireFieldWrapper<Scalars['Boolean']>;
};

export type IsUploadAllowedRequest = {
  size: Scalars['Int'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type IsUploadAllowedResponse = {
  __typename?: 'IsUploadAllowedResponse';
  allowed: EntireFieldWrapper<Scalars['Boolean']>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type IterationRating = 'Disliked' | 'Liked' | 'Unspecified';

export type Language = 'de' | 'en' | 'es' | 'fr' | 'it' | 'nl' | 'pl' | 'pt';

export type LegacyAuthor = {
  __typename?: 'LegacyAuthor';
  avatar?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type LegacyCategory = {
  __typename?: 'LegacyCategory';
  id: EntireFieldWrapper<Scalars['Int']>;
  slug: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
};

export type LegacyCustomMeta = {
  __typename?: 'LegacyCustomMeta';
  craftsCharacteristic: EntireFieldWrapper<Scalars['String']>;
  fontCharacteristic: EntireFieldWrapper<Scalars['String']>;
  graphicCharacteristic: EntireFieldWrapper<Scalars['String']>;
  isCoinRewardBundle: EntireFieldWrapper<Scalars['Boolean']>;
};

export type LegacyLicense = {
  __typename?: 'LegacyLicense';
  DateCreated?: EntireFieldWrapper<Maybe<Scalars['Time']>>;
  Email: EntireFieldWrapper<Scalars['String']>;
  FirstName: EntireFieldWrapper<Scalars['String']>;
  ID: EntireFieldWrapper<Scalars['Int']>;
  LastName: EntireFieldWrapper<Scalars['String']>;
  LicenseKey: EntireFieldWrapper<Scalars['String']>;
  OrderID: EntireFieldWrapper<Scalars['Int']>;
  ProductID: EntireFieldWrapper<Scalars['Int']>;
  SubscriptionID: EntireFieldWrapper<Scalars['Int']>;
  UserID: EntireFieldWrapper<Scalars['Int']>;
};

export type LegacyListUserFavoritesInput = {
  exclude?: InputMaybe<Array<Scalars['String']>>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
};

export type LegacyPpeMeta = {
  __typename?: 'LegacyPPEMeta';
  limit: EntireFieldWrapper<Scalars['Int']>;
  nextOffset: EntireFieldWrapper<Scalars['Int']>;
  offset: EntireFieldWrapper<Scalars['Int']>;
  orderBy?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  total: EntireFieldWrapper<Scalars['Int']>;
};

export type LegacyPpeResponse = {
  __typename?: 'LegacyPPEResponse';
  meta: EntireFieldWrapper<LegacyPpeMeta>;
  products: EntireFieldWrapper<Array<LegacyProduct>>;
};

export type LegacyProduct = {
  __typename?: 'LegacyProduct';
  author: EntireFieldWrapper<LegacyAuthor>;
  customMeta?: EntireFieldWrapper<Maybe<LegacyCustomMeta>>;
  description: EntireFieldWrapper<Scalars['String']>;
  favoriteCount: EntireFieldWrapper<Scalars['Int']>;
  favoriteDate?: EntireFieldWrapper<Maybe<Scalars['Time']>>;
  id: EntireFieldWrapper<Scalars['Int']>;
  image?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  isSkipTrial?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  license?: EntireFieldWrapper<Maybe<LegacyLicense>>;
  productMainCategory?: EntireFieldWrapper<Maybe<LegacyCategory>>;
  productSubCategory?: EntireFieldWrapper<Maybe<LegacyCategory>>;
  rating: EntireFieldWrapper<Scalars['Float']>;
  regularPrice: EntireFieldWrapper<Scalars['Float']>;
  salePrice: EntireFieldWrapper<Scalars['Float']>;
  slug: EntireFieldWrapper<Scalars['String']>;
  sparkType?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  tags: EntireFieldWrapper<Array<Tag>>;
  thumbnail?: EntireFieldWrapper<Maybe<Array<Scalars['String']>>>;
  thumbnailGallery?: EntireFieldWrapper<Maybe<Array<Scalars['String']>>>;
  title: EntireFieldWrapper<Scalars['String']>;
  url: EntireFieldWrapper<Scalars['String']>;
  visibility?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type LegacyProductsListPpeProductsInput = {
  categories?: InputMaybe<Array<Category>>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
};

export type ListRedeemedCodesInput = {
  provider: RedeemProvider;
};

export type ListTransfersInput = {
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  sort: TransferSort;
  teamId?: InputMaybe<Scalars['ID']>;
};

export type ListTransfersResponse = {
  __typename?: 'ListTransfersResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination: EntireFieldWrapper<ProjectListPagination>;
  transfers?: EntireFieldWrapper<Maybe<Array<Transfer>>>;
};

export type ListUserSubscriptionsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type ListUserSubscriptionsResponse = {
  __typename?: 'ListUserSubscriptionsResponse';
  error?: EntireFieldWrapper<Maybe<ErrorGrowth>>;
  subscriptions: EntireFieldWrapper<Array<CfSubscription>>;
};

export type LoginInput = {
  deviceId: Scalars['String'];
  email: Scalars['String'];
  otp?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  remember?: InputMaybe<Scalars['Boolean']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  challenge?: EntireFieldWrapper<Maybe<AuthChallenge>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  user?: EntireFieldWrapper<Maybe<User>>;
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  logout?: EntireFieldWrapper<Maybe<StatusMessage>>;
};

export type LostPasswordInput = {
  email: Scalars['String'];
};

export type LostPasswordResponse = {
  __typename?: 'LostPasswordResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type MembersListInput = {
  clubhouseSlug: Scalars['String'];
  itemsPerPage: Scalars['Int'];
  page: Scalars['Int'];
  sortBy?: InputMaybe<ClubhousesMemberSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type MembersListResponse = {
  __typename?: 'MembersListResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  lastAddedMembers: EntireFieldWrapper<Scalars['Int']>;
  members?: EntireFieldWrapper<Maybe<Array<PublicUserProfile>>>;
  pagination?: EntireFieldWrapper<Maybe<ClubhousesListPagination>>;
  totalMembers: EntireFieldWrapper<Scalars['Int']>;
};

export type MonthlyAction = {
  __typename?: 'MonthlyAction';
  actionDate?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  campaign_id: EntireFieldWrapper<Scalars['String']>;
  clickCount?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  viewCount?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  advertisingCreateCampaign: EntireFieldWrapper<AdvertisingCreateCampaignResponse>;
  advertisingDeleteCampaign: EntireFieldWrapper<AdvertisingDeleteCampaignResponse>;
  advertisingIncreaseClickForCampaign: EntireFieldWrapper<AdvertisingIncreaseClickForCampaignResponse>;
  advertisingIncreaseViewForCampaign: EntireFieldWrapper<AdvertisingIncreaseViewForCampaignResponse>;
  advertisingUpdateCampaign: EntireFieldWrapper<AdvertisingUpdateCampaignResponse>;
  advertisingUploadsCreateSignedUrl: EntireFieldWrapper<AdvertisingUploadsCreateSignedUrlResponse>;
  askCFConfirmQuestion: EntireFieldWrapper<AskCfConfirmQuestionResponse>;
  askCFConfirmTopic: EntireFieldWrapper<AskCfConfirmTopicResponse>;
  askCFDeleteAnswer: EntireFieldWrapper<AskCfDeleteAnswerResponse>;
  askCFDeleteAnswersFromUser: EntireFieldWrapper<AskCfDeleteAnswersFromUserResponse>;
  askCFDeleteQuestion: EntireFieldWrapper<AskCfDeleteQuestionResponse>;
  askCFDeleteQuestionsFromUser: EntireFieldWrapper<AskCfDeleteQuestionsFromUserResponse>;
  askCFDeleteTopic: EntireFieldWrapper<AskCfTopicDeleteResponse>;
  askCFDiscardQuestion: EntireFieldWrapper<AskCfDiscardQuestionResponse>;
  askCFDislikeAnswer: EntireFieldWrapper<AskCfDislikeAnswerResponse>;
  askCFDislikeComment: EntireFieldWrapper<AskCfDislikeCommentResponse>;
  askCFFollowQuestion: EntireFieldWrapper<AskCfFollowQuestionResponse>;
  askCFGiveTipToAnswer: EntireFieldWrapper<AskCfGiveTipToAnswerResponse>;
  askCFLikeAnswer: EntireFieldWrapper<AskCfLikeAnswerResponse>;
  askCFLikeComment: EntireFieldWrapper<AskCfLikeCommentResponse>;
  askCFPostAnswer: EntireFieldWrapper<AskCfPostAnswerResponse>;
  askCFPostComment: EntireFieldWrapper<AskCfPostCommentResponse>;
  askCFPostQuestion: EntireFieldWrapper<AskCfPostQuestionResponse>;
  askCFSetBestAnswer: EntireFieldWrapper<AskCfSetBestAnswerResponse>;
  askCFUnfollowQuestion: EntireFieldWrapper<AskCfUnfollowQuestionResponse>;
  askCFUploadsCreateSignedUrl: EntireFieldWrapper<AskCfUploadCreateSignedUrlResponse>;
  askCFUserDigestSubscribe: EntireFieldWrapper<AskCfUserDigestSubscribeResponse>;
  askCFUserDigestUnsubscribe: EntireFieldWrapper<AskCfUserDigestUnsubscribeResponse>;
  cancelSubscription: EntireFieldWrapper<CancelSubscriptionResponse>;
  cfmainCreateEnterpriseRequest: EntireFieldWrapper<CfMainEnterpriseRequestResponse>;
  cfmainUpdateEnterpriseRequest: EntireFieldWrapper<CfMainUpdateEnterpriseRequestResponse>;
  clubhousesAcceptInvite: EntireFieldWrapper<ClubhouseAcceptInviteResponse>;
  clubhousesAdminUploadsCreateSignedUrl: EntireFieldWrapper<ClubhousesAdminUploadCreateSignedUrlResponse>;
  clubhousesCreateCommunityLeader: EntireFieldWrapper<ClubhousesCreateCommunityLeaderResponse>;
  clubhousesCreateDiscussion: EntireFieldWrapper<ClubhousesCreateDiscussionResponse>;
  clubhousesCreateDiscussionReply: EntireFieldWrapper<ClubhousesCreateDiscussionReplyResponse>;
  clubhousesDeleteDiscussion: EntireFieldWrapper<ClubhousesDeleteDiscussionResponse>;
  clubhousesDeleteDiscussionReply: EntireFieldWrapper<ClubhousesDeleteDiscussionReplyResponse>;
  clubhousesGiveTipToDiscussion: EntireFieldWrapper<ClubhousesGiveTipToDiscussionResponse>;
  clubhousesInvite: EntireFieldWrapper<ClubhouseInviteResponse>;
  clubhousesJoin: EntireFieldWrapper<ClubhouseJoinResponse>;
  clubhousesLeave: EntireFieldWrapper<ClubhouseLeaveResponse>;
  clubhousesLikeReply: EntireFieldWrapper<ClubhousesLikeReplyResponse>;
  clubhousesReactToDiscussion: EntireFieldWrapper<ClubhousesReactToDiscussionResponse>;
  clubhousesRemoveLikeReply: EntireFieldWrapper<ClubhousesRemoveLikeReplyResponse>;
  /** @deprecated Use clubhousesUpdateDigestPreference instead */
  clubhousesSubscribeToDigest: EntireFieldWrapper<SubscribeToClubhouseDigestResponse>;
  /** @deprecated Use clubhousesUpdateDigestPreference instead */
  clubhousesUnsubscribeToDigest: EntireFieldWrapper<UnsubscribeToClubhouseDigestResponse>;
  clubhousesUpdateDigestPreference: EntireFieldWrapper<ClubhouseUpdateDigestPreferenceResponse>;
  clubhousesUploadsCreateSignedUrl: EntireFieldWrapper<ClubhousesUploadCreateSignedUrlResponse>;
  coinsEntityTip: EntireFieldWrapper<CoinsEntityTipResponse>;
  coinsGiveTip: EntireFieldWrapper<CoinsGiveTipResponse>;
  coinsSpendOnProduct: EntireFieldWrapper<CoinsSpendResponse>;
  coinsUpdateTransactionStatus: EntireFieldWrapper<UpdateCoinTransactionStatusResponse>;
  contentCreateFavoriteList: EntireFieldWrapper<Scalars['String']>;
  contentCreateReview: EntireFieldWrapper<Scalars['Boolean']>;
  contentDeleteFavoriteList: EntireFieldWrapper<Scalars['Boolean']>;
  contentDeleteReview: EntireFieldWrapper<Scalars['Boolean']>;
  contentEditReview: EntireFieldWrapper<Scalars['Boolean']>;
  contentFavoriteProduct: EntireFieldWrapper<Scalars['Boolean']>;
  contentIncreaseDownloadCount: EntireFieldWrapper<Scalars['Boolean']>;
  contentUnfavoriteProduct: EntireFieldWrapper<Scalars['Boolean']>;
  contentUpdateFavorite: EntireFieldWrapper<Scalars['Boolean']>;
  contentUpdateFavoriteList: EntireFieldWrapper<Scalars['Boolean']>;
  /** @deprecated Use flowCreateDownloadUrl */
  createDownloadUrl: EntireFieldWrapper<Scalars['String']>;
  /** @deprecated Use flowCreate */
  createFlow: EntireFieldWrapper<Flow>;
  /** @deprecated Use flowCreateIterationPage */
  createFlowIterationPage: EntireFieldWrapper<FlowIterationPage>;
  /** @deprecated Use flowCreateUploadUrl */
  createUploadUrl: EntireFieldWrapper<Scalars['String']>;
  deactivateAccount?: EntireFieldWrapper<Maybe<DeactivateAccountResponse>>;
  /** @deprecated Use flowDeleteAll */
  deleteAllFlows: EntireFieldWrapper<Scalars['Boolean']>;
  /** @deprecated Use flowDelete */
  deleteFlow: EntireFieldWrapper<Scalars['Boolean']>;
  designReviewerCancelReview: EntireFieldWrapper<DesignReviewerCancelReviewRequestResponse>;
  designReviewerDeleteAllReview: EntireFieldWrapper<DesignReviewerDeleteAllReviewResponse>;
  designReviewerDeleteReview: EntireFieldWrapper<DesignReviewerDeleteReviewResponse>;
  designReviewerUploadsCreateSignedUrl: EntireFieldWrapper<DesignReviewerUploadsCreateSignedUrlResponse>;
  editUserProfile: EntireFieldWrapper<EditUserProfileResponse>;
  entityDownload: EntireFieldWrapper<EntityDownloadResponse>;
  entityLove: EntireFieldWrapper<EntityLoveResponse>;
  entityReact: EntireFieldWrapper<EntityReactResponse>;
  entityReactDelete: EntireFieldWrapper<EntityReactDeleteResponse>;
  flowCancelIterationPage: EntireFieldWrapper<FlowCancelIterationPageResponse>;
  flowCreate: EntireFieldWrapper<Flow>;
  flowCreateDownloadUrl: EntireFieldWrapper<Scalars['String']>;
  flowCreateIterationPage: EntireFieldWrapper<FlowIterationPage>;
  flowCreateUploadUrl: EntireFieldWrapper<Scalars['String']>;
  flowDelete: EntireFieldWrapper<Scalars['Boolean']>;
  flowDeleteAll: EntireFieldWrapper<Scalars['Boolean']>;
  flowGiveTip: EntireFieldWrapper<Scalars['Boolean']>;
  flowImageReact: EntireFieldWrapper<FlowImageReactResponse>;
  flowImageRemoveReact: EntireFieldWrapper<FlowImageRemoveReactResponse>;
  flowImageReport: EntireFieldWrapper<FlowImageReportResponse>;
  /** @deprecated Use flowIterationPageRate instead */
  flowIterationRate: EntireFieldWrapper<FlowIterationRateResponse>;
  flowLike: EntireFieldWrapper<Scalars['Boolean']>;
  flowPublishImage: EntireFieldWrapper<FlowPublishImageResponse>;
  flowRateIterationPage: EntireFieldWrapper<FlowRateIterationPageResponse>;
  flowUpdate: EntireFieldWrapper<Flow>;
  flowUpdateVisibility: EntireFieldWrapper<Flow>;
  flowView: EntireFieldWrapper<Scalars['Int']>;
  /** @deprecated Use userFollow */
  followUser: EntireFieldWrapper<Scalars['Boolean']>;
  /** @deprecated use fontGeneratorUserFontCreate */
  fontGeneratorFontCreate: EntireFieldWrapper<FontGeneratorFontCreateResponse>;
  /** @deprecated use fontGeneratorUserFontPack */
  fontGeneratorFontDownload: EntireFieldWrapper<FontGeneratorFontDownloadResponse>;
  /** @deprecated use fontGeneratorUserFontUpdate */
  fontGeneratorFontUpdate: EntireFieldWrapper<FontGeneratorFontUpdateResponse>;
  fontGeneratorSymbolAccept: EntireFieldWrapper<FontGeneratorAcceptSymbolResponse>;
  fontGeneratorSymbolCancel: EntireFieldWrapper<FontGeneratorCancelSymbolResponse>;
  fontGeneratorSymbolGenerate: EntireFieldWrapper<FontGeneratorSymbolGenerateResponse>;
  fontGeneratorUserFontCreate: EntireFieldWrapper<FontGeneratorUserFontCreateResponse>;
  fontGeneratorUserFontDelete: EntireFieldWrapper<FontGeneratorUserFontDeleteResponse>;
  fontGeneratorUserFontDeleteAll: EntireFieldWrapper<FontGeneratorUserFontDeleteAllResponse>;
  fontGeneratorUserFontPack: EntireFieldWrapper<FontGeneratorUserFontPackResponse>;
  fontGeneratorUserFontUpdate: EntireFieldWrapper<FontGeneratorUserFontUpdateResponse>;
  /** @deprecated use fontGeneratorUserFontDelete */
  generatedFontsDelete: EntireFieldWrapper<GeneratedFontsDeleteResponse>;
  /** @deprecated use generatedFontsDeleteAllForUser */
  generatedFontsDeleteAllForUser: EntireFieldWrapper<GeneratedFontsDeleteAllForUserResponse>;
  /** @deprecated Use method flowGiveTip for Flow tips and coinGiveTip for coin tips */
  giveTip: EntireFieldWrapper<Scalars['Boolean']>;
  helpRateMessage?: EntireFieldWrapper<Maybe<HelpMessage>>;
  helpSendMessage?: EntireFieldWrapper<Maybe<HelpConversation>>;
  /** @deprecated Use flowLike */
  likeFlow: EntireFieldWrapper<Scalars['Boolean']>;
  login?: EntireFieldWrapper<Maybe<LoginResponse>>;
  loginWithSocial?: EntireFieldWrapper<Maybe<AuthResponse>>;
  loginWithSocialRedirect?: EntireFieldWrapper<Maybe<SocialRedirectLoginResponse>>;
  logout?: EntireFieldWrapper<Maybe<LogoutResponse>>;
  lostPassword?: EntireFieldWrapper<Maybe<LostPasswordResponse>>;
  paymentsBuildPaymentDataForSubscription: EntireFieldWrapper<BuildPaymentDataForSubscriptionResult>;
  paymentsBuildPaymentForSubscription: EntireFieldWrapper<Payment>;
  paymentsCreateIntentDataForSubscription: EntireFieldWrapper<CreateIntentDataForSubscriptionResult>;
  paymentsCreateIntentForSubscription: EntireFieldWrapper<Intent>;
  paymentsExtendSubscription: EntireFieldWrapper<ExtendSubscriptionResult>;
  paymentsUpgradeSubscription: EntireFieldWrapper<UpgradeSubscriptionResult>;
  publishImage: EntireFieldWrapper<Scalars['Boolean']>;
  publishedTemplatesAddFavorite: EntireFieldWrapper<PublishedTemplatesAddFavoriteResponse>;
  publishedTemplatesRemoveFavorite: EntireFieldWrapper<PublishedTemplatesRemoveFavoriteResponse>;
  publisherCreateTemplateSubmission: EntireFieldWrapper<PublisherCreateTemplateSubmissionResponse>;
  publisherDeleteTemplateSubmission: EntireFieldWrapper<PublisherDeleteTemplateSubmissionResponse>;
  publisherFinaliseTemplateSubmission: EntireFieldWrapper<PublisherFinaliseTemplateSubmissionResponse>;
  publisherRegenerateTemplateSubmissionFields: EntireFieldWrapper<PublisherRegenerateTemplateSubmissionFieldsResponse>;
  publisherUploadsCreateSignedUrl: EntireFieldWrapper<PublisherUploadsCreateSignedUrlResponse>;
  redeemCode: EntireFieldWrapper<Scalars['Boolean']>;
  refreshToken?: EntireFieldWrapper<Maybe<RefreshTokenResponse>>;
  register?: EntireFieldWrapper<Maybe<RegisterResponse>>;
  resetPassword?: EntireFieldWrapper<Maybe<ResetPasswordResponse>>;
  snippetsCreateSnippet: EntireFieldWrapper<SnippetsCreateSnippetResponse>;
  snippetsDeleteSnippet: EntireFieldWrapper<SnippetsDeleteSnippetResponse>;
  snippetsUpdateSnippet: EntireFieldWrapper<SnippetsUpdateSnippetResponse>;
  socialBlockUser: EntireFieldWrapper<SocialBlockUserResponse>;
  socialCommentDelete: EntireFieldWrapper<SocialCommentDeleteResponse>;
  socialCommentLike: EntireFieldWrapper<SocialCommentLikeResponse>;
  socialCommentLikeRemove: EntireFieldWrapper<SocialCommentLikeRemoveResponse>;
  socialCreateComment: EntireFieldWrapper<SocialCreateCommentResponse>;
  socialGiveTipToPost: EntireFieldWrapper<SocialGiveTipToPostResponse>;
  socialPostClass: EntireFieldWrapper<SocialPostResponse>;
  socialPostDelete: EntireFieldWrapper<SocialPostDeleteResponse>;
  socialPostDeleteFromUser: EntireFieldWrapper<SocialPostDeleteFromUserResponse>;
  socialPostLike: EntireFieldWrapper<SocialPostLikeResponse>;
  socialPostLikeRemove: EntireFieldWrapper<SocialPostLikeRemoveResponse>;
  socialPostProject: EntireFieldWrapper<SocialPostResponse>;
  socialPostSave: EntireFieldWrapper<SocialPostSaveResponse>;
  socialPostSaveRemove: EntireFieldWrapper<SocialPostSaveRemoveResponse>;
  socialUnblockUser: EntireFieldWrapper<SocialUnblockUserResponse>;
  socialUploadsCreateSignedUrl: EntireFieldWrapper<SocialUploadCreateSignedUrlResponse>;
  sparkArtDelete: EntireFieldWrapper<SparkArtDeleteResponse>;
  sparkArtGenerate: EntireFieldWrapper<SparkArtGenerateResponse>;
  sparkCrystallineDelete: EntireFieldWrapper<SparkCrystallineDeleteResponse>;
  sparkCrystallineGenerate: EntireFieldWrapper<SparkCrystallineGenerateResponse>;
  sparkImageMixDelete: EntireFieldWrapper<SparkImageMixDeleteResponse>;
  sparkImageMixDeleteAll: EntireFieldWrapper<SparkImageMixDeleteAllResponse>;
  sparkImageMixGenerate: EntireFieldWrapper<SparkImageMixGenerateResponse>;
  sparkInpaintDelete: EntireFieldWrapper<SparkInpaintDeleteResponse>;
  sparkInpaintDeleteAll: EntireFieldWrapper<SparkInpaintDeleteAllResponse>;
  sparkInpaintImage: EntireFieldWrapper<SparkInpaintImageResponse>;
  sparkOutpaintDelete: EntireFieldWrapper<SparkOutpaintDeleteResponse>;
  sparkOutpaintDeleteAll: EntireFieldWrapper<SparkOutpaintDeleteAllResponse>;
  sparkOutpaintImage: EntireFieldWrapper<SparkOutpaintImageResponse>;
  sparkRegisterAnonymousArtToUser: EntireFieldWrapper<SparkRegisterArtResponse>;
  sparkRegisterAnonymousBackgroundRemovedToUser: EntireFieldWrapper<SparkRegisterBackgroundRemovedResponse>;
  sparkRegisterAnonymousCrystallineToUser: EntireFieldWrapper<SparkRegisterCrystallineResponse>;
  sparkRegisterAnonymousImageMixToUser: EntireFieldWrapper<SparkRegisterImageMixResponse>;
  sparkRegisterAnonymousInpaintToUser: EntireFieldWrapper<SparkRegisterInpaintResponse>;
  sparkRegisterAnonymousOutpaintToUser: EntireFieldWrapper<SparkRegisterOutpaintResponse>;
  sparkRemoveBackground: EntireFieldWrapper<SparkRemoveBackgroundResponse>;
  sparkRemovedBackgroundCancel: EntireFieldWrapper<SparkRemovedBackgroundCancelResponse>;
  sparkRemovedBackgroundDelete: EntireFieldWrapper<SparkRemovedBackgroundDeleteResponse>;
  sparkRemovedBackgroundDeleteAll: EntireFieldWrapper<SparkRemovedBackgroundDeleteAllResponse>;
  sparkRemovedBackgroundPublishImage: EntireFieldWrapper<RemoveBackgroundPublishImageResponse>;
  sparkRemovedBackgroundUploadsCreateSignedUrl: EntireFieldWrapper<SparkRemovedBackgroundUploadsCreateSignedUrlResponse>;
  sparkUploadsCreateSignedUrl: EntireFieldWrapper<SparkUploadsCreateSignedUrlResponse>;
  /** @deprecated use coinsSpendOnProduct */
  spendCoinsOnProduct: EntireFieldWrapper<CoinsSpendResponse>;
  statisticsRecordStudioEvent: EntireFieldWrapper<StatisticsRecordStudioEventResponse>;
  storageEnableOverages: EntireFieldWrapper<StorageEnableOveragesResponse>;
  storageUpdateSize: EntireFieldWrapper<StorageUpdateSizeResponse>;
  storeUserSearch: EntireFieldWrapper<UserSearch>;
  studioCommentReact: EntireFieldWrapper<StudioCommentReactResponse>;
  studioCommentReactDelete: EntireFieldWrapper<StudioCommentReactDeleteResponse>;
  studioProjectsAddMember: EntireFieldWrapper<StudioProjectsAddMemberResponse>;
  studioProjectsAddUserToProjectSharingLink: EntireFieldWrapper<StudioProjectsAddUserToProjectSharingLinkResponse>;
  studioProjectsApproveInvite: EntireFieldWrapper<StudioProjectsApproveInviteResponse>;
  studioProjectsApproveProjectMemberUpdate: EntireFieldWrapper<StudioProjectsApproveProjectMemberUpdateResponse>;
  studioProjectsChangeUserRole: EntireFieldWrapper<StudioProjectsChangeUserRoleResponse>;
  studioProjectsConfirmInvite: EntireFieldWrapper<StudioProjectsConfirmInviteResponse>;
  studioProjectsCreateFolder: EntireFieldWrapper<StudioProjectCreateFolderResponse>;
  studioProjectsCreateFromTemplate: EntireFieldWrapper<StudioProjectsCreateFromTemplateResponse>;
  studioProjectsCreateProject: EntireFieldWrapper<StudioProjectsCreateProjectResponse>;
  studioProjectsCreateProjectComment: EntireFieldWrapper<StudioProjectsCreateProjectCommentResponse>;
  studioProjectsCreateProjectSharingLink: EntireFieldWrapper<StudioProjectsCreateProjectSharingLinkResponse>;
  studioProjectsDeleteProject: EntireFieldWrapper<StudioProjectDeleteProjectResponse>;
  studioProjectsEmptyTrash: EntireFieldWrapper<StudioProjectEmptyTrashResponse>;
  studioProjectsFolderDelete: EntireFieldWrapper<StudioProjectFolderDeleteResponse>;
  studioProjectsFolderRename: EntireFieldWrapper<StudioProjectsFolderRenameResponse>;
  studioProjectsFolderRestore: EntireFieldWrapper<StudioProjectsFolderRestoreResponse>;
  studioProjectsMarkProjectCommentDone: EntireFieldWrapper<StudioProjectsMarkProjectCommentDoneResponse>;
  studioProjectsMoveProjects: EntireFieldWrapper<StudioProjectMoveProjectsResponse>;
  studioProjectsOptimizeProject: EntireFieldWrapper<StudioProjectOptimizeProjectResponse>;
  studioProjectsRemoveUser: EntireFieldWrapper<StudioProjectsRemoveUserResponse>;
  studioProjectsRestoreProject: EntireFieldWrapper<StudioProjectRestoreProjectResponse>;
  studioProjectsUpdateProject: EntireFieldWrapper<StudioProjectsUpdateProjectResponse>;
  studioProjectsUpdateProjectLastView: EntireFieldWrapper<StudioProjectsUpdateProjectLastViewResponse>;
  studioSimpleCommentsCreate: EntireFieldWrapper<StudioSimpleCommentsCreateResponse>;
  studioSimpleCommentsDelete: EntireFieldWrapper<StudioSimpleCommentsDeleteResponse>;
  studioSimpleCommentsEdit: EntireFieldWrapper<StudioSimpleCommentsEditResponse>;
  studioTemplateDelete: EntireFieldWrapper<StudioTemplateDeleteResponse>;
  studioTemplatePublishFromProject: EntireFieldWrapper<StudioTemplatePublishFromProjectResponse>;
  studioTemplateRestore: EntireFieldWrapper<StudioTemplateRestoreResponse>;
  studioUploadsAddTagToFiles: EntireFieldWrapper<StudioUploadsAddTagToFilesResponse>;
  studioUploadsCreateFolder: EntireFieldWrapper<StudioUploadsCreateFolderResponse>;
  studioUploadsCreateSignedDownloadUrl: EntireFieldWrapper<StudioUploadsCreateSignedDownloadUrlResponse>;
  studioUploadsCreateSignedUrl: EntireFieldWrapper<StudioUploadsCreateSignedUrlResponse>;
  studioUploadsCreateTag: EntireFieldWrapper<StudioUploadsCreateTagResponse>;
  studioUploadsDeleteFiles: EntireFieldWrapper<StudioUploadsDeleteFilesResponse>;
  studioUploadsDeleteFolder: EntireFieldWrapper<StudioUploadsDeleteFolderResponse>;
  studioUploadsDeleteTag: EntireFieldWrapper<StudioUploadsDeleteTagResponse>;
  studioUploadsMoveFiles: EntireFieldWrapper<StudioUploadsMoveFilesResponse>;
  studioUploadsRemoveTagFromFile: EntireFieldWrapper<StudioUploadsRemoveTagFromFileResponse>;
  studioUploadsRenameFolder: EntireFieldWrapper<StudioUploadsRenameFolderResponse>;
  studioUploadsUpdateTag: EntireFieldWrapper<StudioUploadsUpdateTagResponse>;
  subscribeToDigest: EntireFieldWrapper<SubscribeToDigestResponse>;
  teamsApproveAdminRequest: EntireFieldWrapper<TeamsApproveAdminRequestResponse>;
  teamsApproveNewTeamMember: EntireFieldWrapper<TeamsApproveNewTeamMemberResponse>;
  teamsApproveTeamMemberRoleChange: EntireFieldWrapper<TeamsApproveTeamMemberRoleChangeResponse>;
  teamsCancelInvite: EntireFieldWrapper<TeamsCancelInviteResponse>;
  teamsChangeUserRole: EntireFieldWrapper<TeamsChangeUserRoleResponse>;
  teamsConfirmInvite: EntireFieldWrapper<TeamsConfirmInviteResponse>;
  teamsCreateTeam: EntireFieldWrapper<TeamsCreateTeamResponse>;
  teamsDeactivateTeam: EntireFieldWrapper<TeamsDeactivateTeamResponse>;
  teamsGetCheckoutURL: EntireFieldWrapper<TeamsGetCheckoutUrlResponse>;
  teamsInviteUsers: EntireFieldWrapper<TeamsInviteUsersResponse>;
  teamsLeaveTeam: EntireFieldWrapper<TeamsLeaveTeamResponse>;
  teamsRemoveUsers: EntireFieldWrapper<TeamsRemoveUsersResponse>;
  teamsResendInvite: EntireFieldWrapper<TeamsResendInviteResponse>;
  teamsUpdateTeam: EntireFieldWrapper<TeamsUpdateTeamResponse>;
  transfersAddRecipients: EntireFieldWrapper<TransfersAddRecipientsResponse>;
  transfersCancel: EntireFieldWrapper<TransfersCancelResponse>;
  transfersConfirmOwnerEmail: EntireFieldWrapper<TransfersConfirmOwnerEmailResponse>;
  transfersCreateSignedDownloadUrl: EntireFieldWrapper<TransfersCreateSignedDownloadUrlResponse>;
  transfersDelete: EntireFieldWrapper<TransfersDeleteResponse>;
  transfersInitiateTransfer: EntireFieldWrapper<TransfersInitiateTransferResponse>;
  transfersInitiateTransferV2: EntireFieldWrapper<TransfersInitiateTransferV2Response>;
  transfersNotifyTransferDownloadCompleted: EntireFieldWrapper<NotifyTransferDownloadCompletedResponse>;
  transfersVerifyOwnerEmail: EntireFieldWrapper<TransfersVerifyOwnerEmailResponse>;
  /** @deprecated Use userUnfollow */
  unfollowUser: EntireFieldWrapper<Scalars['Boolean']>;
  unsubscribeFromDigest: EntireFieldWrapper<SubscribeToDigestResponse>;
  /** @deprecated Use flowUpdate */
  updateFlow: EntireFieldWrapper<Flow>;
  /** @deprecated Use flowUpdateVisibility */
  updateFlowVisibility: EntireFieldWrapper<Flow>;
  updateUserGDPR: EntireFieldWrapper<UpdateUserResponse>;
  uploadedFontsCreateSignedUrl: EntireFieldWrapper<UploadedFontsCreateSignedUrlResponse>;
  uploadedFontsDelete: EntireFieldWrapper<UploadedFontsDeleteResponse>;
  uploadsCreateSignedUrlV2: EntireFieldWrapper<UploadsCreateSignedUrlResponseV2>;
  upscalerCancelImage: EntireFieldWrapper<UpscalerCancelImageResponse>;
  upscalerCreateSignedUploadUrl: EntireFieldWrapper<UpscalerCreateSignedUploadUrlResponse>;
  upscalerDeleteAllImages: EntireFieldWrapper<UpscalerDeleteAllImagesResponse>;
  upscalerDeleteImage: EntireFieldWrapper<UpscalerDeleteImageResponse>;
  upscalerDownloadImage: EntireFieldWrapper<UpscalerDownloadImageResponse>;
  upscalerPublishImage: EntireFieldWrapper<UpscalerPublishImageResponse>;
  upscalerUpscaleImage: EntireFieldWrapper<UpscalerUpscaleImageResponse>;
  userFollow: EntireFieldWrapper<Scalars['Boolean']>;
  userUnfollow: EntireFieldWrapper<Scalars['Boolean']>;
  usersClaimGift: EntireFieldWrapper<UsersClaimGiftResponse>;
  usersFavoriteProduct: EntireFieldWrapper<UsersFavoriteProductResponse>;
  usersUpdateCurrency: EntireFieldWrapper<UpdateUserResponse>;
  usersUpdateFlags: EntireFieldWrapper<UpdateUserResponse>;
  usersUpdateLanguage: EntireFieldWrapper<UpdateUserResponse>;
  vectorizerCancelVectorization: EntireFieldWrapper<VectorizerCancelImageVectorizationResponse>;
  vectorizerCreateImage: EntireFieldWrapper<VectorizerCreateImageResponse>;
  vectorizerCreateSignedUploadUrl: EntireFieldWrapper<VectorizerCreateSignedUploadUrlResponse>;
  vectorizerDeleteAllImages: EntireFieldWrapper<VectorizerDeleteAllImagesResponse>;
  vectorizerDeleteImage: EntireFieldWrapper<VectorizerDeleteImageResponse>;
  vectorizerPublishImage: EntireFieldWrapper<VectorizerPublishImageResponse>;
  vectorizerRegisterImagesToUser: EntireFieldWrapper<VectorizerImagesRegisterToUserResponse>;
  /** @deprecated Use flowView */
  viewFlow: EntireFieldWrapper<Scalars['Int']>;
};

export type MutationAdvertisingCreateCampaignArgs = {
  input: AdvertisingCreateCampaignInput;
};

export type MutationAdvertisingDeleteCampaignArgs = {
  input: AdvertisingDeleteCampaignInput;
};

export type MutationAdvertisingIncreaseClickForCampaignArgs = {
  input: AdvertisingIncreaseClickForCampaignInput;
};

export type MutationAdvertisingIncreaseViewForCampaignArgs = {
  input: AdvertisingIncreaseViewForCampaignInput;
};

export type MutationAdvertisingUpdateCampaignArgs = {
  input: AdvertisingUpdateCampaignInput;
};

export type MutationAdvertisingUploadsCreateSignedUrlArgs = {
  input: AdvertisingUploadsCreateSignedUrlInput;
};

export type MutationAskCfConfirmQuestionArgs = {
  input: AskCfConfirmQuestionInput;
};

export type MutationAskCfConfirmTopicArgs = {
  input: AskCfConfirmTopicInput;
};

export type MutationAskCfDeleteAnswerArgs = {
  input: AskCfDeleteAnswerInput;
};

export type MutationAskCfDeleteAnswersFromUserArgs = {
  input: AskCfDeleteAnswersFromUserInput;
};

export type MutationAskCfDeleteQuestionArgs = {
  input: AskCfDeleteQuestionInput;
};

export type MutationAskCfDeleteQuestionsFromUserArgs = {
  input: AskCfDeleteQuestionsFromUserInput;
};

export type MutationAskCfDeleteTopicArgs = {
  input: AskCfTopicDeleteInput;
};

export type MutationAskCfDiscardQuestionArgs = {
  input: AskCfDiscardQuestionInput;
};

export type MutationAskCfDislikeAnswerArgs = {
  input: AskCfDislikeAnswerInput;
};

export type MutationAskCfDislikeCommentArgs = {
  input: AskCfDislikeCommentInput;
};

export type MutationAskCfFollowQuestionArgs = {
  input: AskCfFollowQuestionInput;
};

export type MutationAskCfGiveTipToAnswerArgs = {
  input: AskCfGiveTipToAnswerInput;
};

export type MutationAskCfLikeAnswerArgs = {
  input: AskCfLikeAnswerInput;
};

export type MutationAskCfLikeCommentArgs = {
  input: AskCfLikeCommentInput;
};

export type MutationAskCfPostAnswerArgs = {
  input: AskCfPostAnswerInput;
};

export type MutationAskCfPostCommentArgs = {
  input: AskCfPostCommentInput;
};

export type MutationAskCfPostQuestionArgs = {
  input: AskCfPostQuestionInput;
};

export type MutationAskCfSetBestAnswerArgs = {
  input: AskCfSetBestAnswerInput;
};

export type MutationAskCfUnfollowQuestionArgs = {
  input: AskCfUnfollowQuestionInput;
};

export type MutationAskCfUploadsCreateSignedUrlArgs = {
  input: AskCfUploadCreateSignedUrlInput;
};

export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};

export type MutationCfmainCreateEnterpriseRequestArgs = {
  input: CfMainEnterpriseRequestInput;
};

export type MutationCfmainUpdateEnterpriseRequestArgs = {
  input: CfMainUpdateEnterpriseRequestInput;
};

export type MutationClubhousesAcceptInviteArgs = {
  input: ClubhouseAcceptInviteInput;
};

export type MutationClubhousesAdminUploadsCreateSignedUrlArgs = {
  input: ClubhousesAdminUploadCreateSignedUrlInput;
};

export type MutationClubhousesCreateCommunityLeaderArgs = {
  input: ClubhousesCreateCommunityLeaderInput;
};

export type MutationClubhousesCreateDiscussionArgs = {
  input: ClubhousesCreateDiscussionInput;
};

export type MutationClubhousesCreateDiscussionReplyArgs = {
  input: ClubhousesCreateDiscussionReplyInput;
};

export type MutationClubhousesDeleteDiscussionArgs = {
  input: ClubhousesDeleteDiscussionInput;
};

export type MutationClubhousesDeleteDiscussionReplyArgs = {
  input: ClubhousesDeleteDiscussionReplyInput;
};

export type MutationClubhousesGiveTipToDiscussionArgs = {
  input: ClubhousesGiveTipToDiscussionInput;
};

export type MutationClubhousesInviteArgs = {
  input: ClubhouseInviteInput;
};

export type MutationClubhousesJoinArgs = {
  input: ClubhouseJoinInput;
};

export type MutationClubhousesLeaveArgs = {
  input: ClubhouseLeaveInput;
};

export type MutationClubhousesLikeReplyArgs = {
  input: ClubhousesLikeReplyInput;
};

export type MutationClubhousesReactToDiscussionArgs = {
  input: ClubhousesReactToDiscussionInput;
};

export type MutationClubhousesRemoveLikeReplyArgs = {
  input: ClubhousesRemoveLikeReplyInput;
};

export type MutationClubhousesSubscribeToDigestArgs = {
  input: SubscribeToClubhouseDigestInput;
};

export type MutationClubhousesUnsubscribeToDigestArgs = {
  input: UnsubscribeToClubhouseDigestInput;
};

export type MutationClubhousesUpdateDigestPreferenceArgs = {
  input: ClubhouseUpdateDigestPreferenceInput;
};

export type MutationClubhousesUploadsCreateSignedUrlArgs = {
  input: ClubhousesUploadCreateSignedUrlInput;
};

export type MutationCoinsEntityTipArgs = {
  input: CoinsEntityTipRequest;
};

export type MutationCoinsGiveTipArgs = {
  recipientUserId: Scalars['String'];
};

export type MutationCoinsSpendOnProductArgs = {
  productId: Scalars['String'];
};

export type MutationCoinsUpdateTransactionStatusArgs = {
  id: Scalars['String'];
  status: CoinTransactionStatus;
};

export type MutationContentCreateFavoriteListArgs = {
  input: ContentCreateFavoriteListInput;
};

export type MutationContentCreateReviewArgs = {
  input: ContentCreateReview;
};

export type MutationContentDeleteFavoriteListArgs = {
  id: Scalars['ID'];
};

export type MutationContentDeleteReviewArgs = {
  id: Scalars['ID'];
};

export type MutationContentEditReviewArgs = {
  input: ContentEditReview;
};

export type MutationContentFavoriteProductArgs = {
  productId: Scalars['ID'];
};

export type MutationContentIncreaseDownloadCountArgs = {
  productId: Scalars['ID'];
  source?: InputMaybe<ContentDownloadSource>;
};

export type MutationContentUnfavoriteProductArgs = {
  productId: Scalars['ID'];
};

export type MutationContentUpdateFavoriteArgs = {
  input: ContentUpdateFavoriteInput;
};

export type MutationContentUpdateFavoriteListArgs = {
  input: ContentUpdateFavoriteListInput;
};

export type MutationCreateDownloadUrlArgs = {
  imageId: Scalars['ID'];
};

export type MutationCreateFlowArgs = {
  input: FlowSettingsInput;
};

export type MutationCreateFlowIterationPageArgs = {
  iterationId: Scalars['ID'];
};

export type MutationCreateUploadUrlArgs = {
  fileName: Scalars['String'];
};

export type MutationDeactivateAccountArgs = {
  otp?: InputMaybe<Scalars['String']>;
};

export type MutationDeleteFlowArgs = {
  id: Scalars['String'];
};

export type MutationDesignReviewerCancelReviewArgs = {
  input: DesignReviewerCancelReviewRequestInput;
};

export type MutationDesignReviewerDeleteReviewArgs = {
  input: DesignReviewerDeleteReviewInput;
};

export type MutationDesignReviewerUploadsCreateSignedUrlArgs = {
  input: DesignReviewerUploadsCreateSignedUrlInput;
};

export type MutationEditUserProfileArgs = {
  input: EditUserProfileInput;
};

export type MutationEntityDownloadArgs = {
  id: EntityDownloadInput;
};

export type MutationEntityLoveArgs = {
  id: EntityLoveInput;
};

export type MutationEntityReactArgs = {
  input: EntityReactInput;
};

export type MutationEntityReactDeleteArgs = {
  input: EntityReactDeleteInput;
};

export type MutationFlowCancelIterationPageArgs = {
  input: FlowCancelIterationPageInput;
};

export type MutationFlowCreateArgs = {
  input: FlowSettingsInput;
};

export type MutationFlowCreateDownloadUrlArgs = {
  imageId: Scalars['ID'];
};

export type MutationFlowCreateIterationPageArgs = {
  iterationId: Scalars['ID'];
};

export type MutationFlowCreateUploadUrlArgs = {
  fileName: Scalars['String'];
};

export type MutationFlowDeleteArgs = {
  id: Scalars['String'];
};

export type MutationFlowGiveTipArgs = {
  flowID: Scalars['ID'];
};

export type MutationFlowImageReactArgs = {
  input: FlowImageReactInput;
};

export type MutationFlowImageRemoveReactArgs = {
  input: FlowImageRemoveReactInput;
};

export type MutationFlowImageReportArgs = {
  input: FlowImageReportInput;
};

export type MutationFlowIterationRateArgs = {
  input: FlowIterationRateInput;
};

export type MutationFlowLikeArgs = {
  flowID: Scalars['ID'];
};

export type MutationFlowPublishImageArgs = {
  input: FlowPublishImageInput;
};

export type MutationFlowRateIterationPageArgs = {
  input: FlowRateIterationPageInput;
};

export type MutationFlowUpdateArgs = {
  id: Scalars['ID'];
  input: FlowSettingsInput;
};

export type MutationFlowUpdateVisibilityArgs = {
  id: Scalars['ID'];
  visibility: FlowVisibility;
};

export type MutationFlowViewArgs = {
  flowID: Scalars['ID'];
};

export type MutationFollowUserArgs = {
  userID: Scalars['ID'];
};

export type MutationFontGeneratorFontCreateArgs = {
  input: FontGeneratorFontCreateInput;
};

export type MutationFontGeneratorFontDownloadArgs = {
  id: Scalars['ID'];
};

export type MutationFontGeneratorFontUpdateArgs = {
  input: FontGeneratorFontUpdateInput;
};

export type MutationFontGeneratorSymbolAcceptArgs = {
  id: Scalars['ID'];
};

export type MutationFontGeneratorSymbolCancelArgs = {
  id: Scalars['ID'];
};

export type MutationFontGeneratorSymbolGenerateArgs = {
  input: FontGeneratorSymbolGenerateInput;
};

export type MutationFontGeneratorUserFontCreateArgs = {
  input: FontGeneratorUserFontCreateInput;
};

export type MutationFontGeneratorUserFontDeleteArgs = {
  input: FontGeneratorUserFontDeleteInput;
};

export type MutationFontGeneratorUserFontPackArgs = {
  id: Scalars['ID'];
};

export type MutationFontGeneratorUserFontUpdateArgs = {
  input: FontGeneratorUserFontUpdateInput;
};

export type MutationGeneratedFontsDeleteArgs = {
  input: GeneratedFontsDeleteInput;
};

export type MutationGiveTipArgs = {
  flowID: Scalars['ID'];
};

export type MutationHelpRateMessageArgs = {
  messageId: Scalars['ID'];
  rate: HelpMessageRate;
};

export type MutationHelpSendMessageArgs = {
  channel: HelpChannel;
  conversationId?: InputMaybe<Scalars['ID']>;
  language?: InputMaybe<Language>;
  message: Scalars['String'];
};

export type MutationLikeFlowArgs = {
  flowID: Scalars['ID'];
};

export type MutationLoginArgs = {
  input?: InputMaybe<LoginInput>;
};

export type MutationLoginWithSocialArgs = {
  input?: InputMaybe<SocialLoginInput>;
};

export type MutationLoginWithSocialRedirectArgs = {
  input?: InputMaybe<SocialRedirectLoginInput>;
};

export type MutationLostPasswordArgs = {
  input?: InputMaybe<LostPasswordInput>;
};

export type MutationPaymentsBuildPaymentDataForSubscriptionArgs = {
  subscriptionType: SubscriptionType;
};

export type MutationPaymentsBuildPaymentForSubscriptionArgs = {
  subscriptionType: SubscriptionType;
};

export type MutationPaymentsCreateIntentDataForSubscriptionArgs = {
  currencyCode: AvailableCurrencyCode;
  promo?: InputMaybe<Scalars['String']>;
  subscriptionType: SubscriptionType;
  user: UserInput;
};

export type MutationPaymentsCreateIntentForSubscriptionArgs = {
  currencyCode: AvailableCurrencyCode;
  promo?: InputMaybe<Scalars['String']>;
  subscriptionType: SubscriptionType;
  user: UserInput;
};

export type MutationPaymentsExtendSubscriptionArgs = {
  stripeSubscriptionId: Scalars['String'];
};

export type MutationPaymentsUpgradeSubscriptionArgs = {
  stripeSubscriptionId: Scalars['String'];
  upgradeTo?: InputMaybe<SubscriptionTypeUpgrade>;
};

export type MutationPublishImageArgs = {
  imageId: Scalars['ID'];
};

export type MutationPublishedTemplatesAddFavoriteArgs = {
  input: PublishedTemplatesAddFavoriteInput;
};

export type MutationPublishedTemplatesRemoveFavoriteArgs = {
  input: PublishedTemplatesRemoveFavoriteInput;
};

export type MutationPublisherCreateTemplateSubmissionArgs = {
  input: PublisherCreateTemplateSubmissionInput;
};

export type MutationPublisherDeleteTemplateSubmissionArgs = {
  input: PublisherDeleteTemplateSubmissionInput;
};

export type MutationPublisherFinaliseTemplateSubmissionArgs = {
  input: PublisherFinaliseTemplateSubmissionInput;
};

export type MutationPublisherRegenerateTemplateSubmissionFieldsArgs = {
  input: PublisherRegenerateTemplateSubmissionFieldsInput;
};

export type MutationPublisherUploadsCreateSignedUrlArgs = {
  input: PublisherUploadsCreateSignedUrlInput;
};

export type MutationRedeemCodeArgs = {
  input: RedeemInput;
};

export type MutationRegisterArgs = {
  input?: InputMaybe<RegisterInput>;
};

export type MutationResetPasswordArgs = {
  input?: InputMaybe<ResetPasswordInput>;
};

export type MutationSnippetsCreateSnippetArgs = {
  input: SnippetsCreateSnippetInput;
};

export type MutationSnippetsDeleteSnippetArgs = {
  input: SnippetsDeleteSnippetInput;
};

export type MutationSnippetsUpdateSnippetArgs = {
  input: SnippetsUpdateSnippetInput;
};

export type MutationSocialBlockUserArgs = {
  input: SocialBlockUserInput;
};

export type MutationSocialCommentDeleteArgs = {
  input: SocialCommentDeleteInput;
};

export type MutationSocialCommentLikeArgs = {
  input: SocialCommentLikeInput;
};

export type MutationSocialCommentLikeRemoveArgs = {
  input: SocialCommentLikeRemoveInput;
};

export type MutationSocialCreateCommentArgs = {
  input: SocialCreateCommentInput;
};

export type MutationSocialGiveTipToPostArgs = {
  input: SocialGiveTipToPostInput;
};

export type MutationSocialPostClassArgs = {
  input: SocialPostInput;
};

export type MutationSocialPostDeleteArgs = {
  input: SocialPostDeleteInput;
};

export type MutationSocialPostDeleteFromUserArgs = {
  input: SocialPostDeleteFromUserInput;
};

export type MutationSocialPostLikeArgs = {
  input: SocialPostLikeInput;
};

export type MutationSocialPostLikeRemoveArgs = {
  input: SocialPostLikeRemoveInput;
};

export type MutationSocialPostProjectArgs = {
  input: SocialPostInput;
};

export type MutationSocialPostSaveArgs = {
  input: SocialPostSaveInput;
};

export type MutationSocialPostSaveRemoveArgs = {
  input: SocialPostSaveRemoveInput;
};

export type MutationSocialUnblockUserArgs = {
  input: SocialUnblockUserInput;
};

export type MutationSocialUploadsCreateSignedUrlArgs = {
  input: SocialUploadCreateSignedUrlInput;
};

export type MutationSparkArtDeleteArgs = {
  input: SparkArtDeleteInput;
};

export type MutationSparkArtGenerateArgs = {
  input: SparkArtGenerateInput;
};

export type MutationSparkCrystallineDeleteArgs = {
  input: SparkCrystallineDeleteInput;
};

export type MutationSparkCrystallineGenerateArgs = {
  input: SparkCrystallineGenerateInput;
};

export type MutationSparkImageMixDeleteArgs = {
  input: SparkImageMixDeleteInput;
};

export type MutationSparkImageMixGenerateArgs = {
  input: SparkImageMixGenerateInput;
};

export type MutationSparkInpaintDeleteArgs = {
  input: SparkInpaintDeleteInput;
};

export type MutationSparkInpaintImageArgs = {
  input: SparkInpaintImageInput;
};

export type MutationSparkOutpaintDeleteArgs = {
  input: SparkOutpaintDeleteInput;
};

export type MutationSparkOutpaintImageArgs = {
  input: SparkOutpaintImageInput;
};

export type MutationSparkRegisterAnonymousArtToUserArgs = {
  input: SparkArtRegisterInput;
};

export type MutationSparkRegisterAnonymousBackgroundRemovedToUserArgs = {
  input: SparkBackgroundRemovedRegisterInput;
};

export type MutationSparkRegisterAnonymousCrystallineToUserArgs = {
  input: SparkCrystallineRegisterInput;
};

export type MutationSparkRegisterAnonymousImageMixToUserArgs = {
  input: SparkImageMixRegisterInput;
};

export type MutationSparkRegisterAnonymousInpaintToUserArgs = {
  input: SparkInpaintRegisterInput;
};

export type MutationSparkRegisterAnonymousOutpaintToUserArgs = {
  input: SparkOutpaintRegisterInput;
};

export type MutationSparkRemoveBackgroundArgs = {
  input: SparkRemoveBackgroundInput;
};

export type MutationSparkRemovedBackgroundCancelArgs = {
  input: SparkRemovedBackgroundCancelInput;
};

export type MutationSparkRemovedBackgroundDeleteArgs = {
  input: SparkRemovedBackgroundDeleteInput;
};

export type MutationSparkRemovedBackgroundPublishImageArgs = {
  input: RemoveBackgroundPublishImageInput;
};

export type MutationSparkRemovedBackgroundUploadsCreateSignedUrlArgs = {
  input: SparkRemovedBackgroundUploadsCreateSignedUrlInput;
};

export type MutationSparkUploadsCreateSignedUrlArgs = {
  input: SparkUploadsCreateSignedUrlInput;
};

export type MutationSpendCoinsOnProductArgs = {
  productId: Scalars['String'];
};

export type MutationStatisticsRecordStudioEventArgs = {
  input: StatisticsRecordStudioEventInput;
};

export type MutationStorageEnableOveragesArgs = {
  input: StorageEnableOveragesInput;
};

export type MutationStorageUpdateSizeArgs = {
  input: StorageUpdateSizeInput;
};

export type MutationStoreUserSearchArgs = {
  input: StoreUserSearchInput;
};

export type MutationStudioCommentReactArgs = {
  input: StudioCommentReactInput;
};

export type MutationStudioCommentReactDeleteArgs = {
  id: Scalars['ID'];
};

export type MutationStudioProjectsAddMemberArgs = {
  input: StudioProjectsAddMemberInput;
};

export type MutationStudioProjectsAddUserToProjectSharingLinkArgs = {
  input: StudioProjectsAddUserToProjectSharingLinkInput;
};

export type MutationStudioProjectsApproveInviteArgs = {
  input: StudioProjectsApproveInviteInput;
};

export type MutationStudioProjectsApproveProjectMemberUpdateArgs = {
  input: StudioProjectsApproveProjectMemberUpdateInput;
};

export type MutationStudioProjectsChangeUserRoleArgs = {
  input: StudioProjectsChangeUserRoleInput;
};

export type MutationStudioProjectsConfirmInviteArgs = {
  input: StudioProjectsConfirmInviteInput;
};

export type MutationStudioProjectsCreateFolderArgs = {
  input: StudioProjectCreateFolderInput;
};

export type MutationStudioProjectsCreateFromTemplateArgs = {
  input: StudioProjectsCreateFromTemplateInput;
};

export type MutationStudioProjectsCreateProjectArgs = {
  input: StudioProjectsCreateProjectInput;
};

export type MutationStudioProjectsCreateProjectCommentArgs = {
  input: StudioProjectsCreateProjectCommentInput;
};

export type MutationStudioProjectsCreateProjectSharingLinkArgs = {
  input: StudioProjectsCreateProjectSharingLinkInput;
};

export type MutationStudioProjectsDeleteProjectArgs = {
  input: StudioProjectDeleteProjectInput;
};

export type MutationStudioProjectsEmptyTrashArgs = {
  input: StudioProjectEmptyTrashInput;
};

export type MutationStudioProjectsFolderDeleteArgs = {
  input: StudioProjectFolderDeleteInput;
};

export type MutationStudioProjectsFolderRenameArgs = {
  input: StudioProjectsFolderRenameInput;
};

export type MutationStudioProjectsFolderRestoreArgs = {
  input: StudioProjectsFolderRestoreInput;
};

export type MutationStudioProjectsMarkProjectCommentDoneArgs = {
  input: StudioProjectsMarkProjectCommentDoneInput;
};

export type MutationStudioProjectsMoveProjectsArgs = {
  input: StudioProjectMoveProjectsInput;
};

export type MutationStudioProjectsOptimizeProjectArgs = {
  input: StudioProjectOptimizeProjectInput;
};

export type MutationStudioProjectsRemoveUserArgs = {
  input: StudioProjectsRemoveUserInput;
};

export type MutationStudioProjectsRestoreProjectArgs = {
  input: StudioProjectRestoreProjectInput;
};

export type MutationStudioProjectsUpdateProjectArgs = {
  input?: InputMaybe<StudioProjectsUpdateProjectInput>;
};

export type MutationStudioProjectsUpdateProjectLastViewArgs = {
  input: StudioProjectsUpdateProjectLastViewInput;
};

export type MutationStudioSimpleCommentsCreateArgs = {
  input: StudioSimpleCommentsCreateInput;
};

export type MutationStudioSimpleCommentsDeleteArgs = {
  commentId: Scalars['ID'];
};

export type MutationStudioSimpleCommentsEditArgs = {
  input: StudioSimpleCommentsEditInput;
};

export type MutationStudioTemplateDeleteArgs = {
  input: StudioTemplateDeleteInput;
};

export type MutationStudioTemplatePublishFromProjectArgs = {
  input: StudioTemplatePublishFromProjectInput;
};

export type MutationStudioTemplateRestoreArgs = {
  input: StudioTemplateRestoreInput;
};

export type MutationStudioUploadsAddTagToFilesArgs = {
  input: StudioUploadsAddTagToFilesInput;
};

export type MutationStudioUploadsCreateFolderArgs = {
  input: StudioUploadsCreateFolderInput;
};

export type MutationStudioUploadsCreateSignedDownloadUrlArgs = {
  input: StudioUploadsCreateSignedDownloadUrlInput;
};

export type MutationStudioUploadsCreateSignedUrlArgs = {
  input: StudioUploadsCreateSignedUrlInput;
};

export type MutationStudioUploadsCreateTagArgs = {
  input: StudioUploadsCreateTagInput;
};

export type MutationStudioUploadsDeleteFilesArgs = {
  input: StudioUploadsDeleteFilesInput;
};

export type MutationStudioUploadsDeleteFolderArgs = {
  input: StudioUploadsDeleteFolderInput;
};

export type MutationStudioUploadsDeleteTagArgs = {
  input: StudioUploadsDeleteTagInput;
};

export type MutationStudioUploadsMoveFilesArgs = {
  input: StudioUploadsMoveFilesInput;
};

export type MutationStudioUploadsRemoveTagFromFileArgs = {
  input: StudioUploadsRemoveTagFromFileInput;
};

export type MutationStudioUploadsRenameFolderArgs = {
  input: StudioUploadsRenameFolderInput;
};

export type MutationStudioUploadsUpdateTagArgs = {
  input: StudioUploadsUpdateTagInput;
};

export type MutationTeamsApproveAdminRequestArgs = {
  input: TeamsApproveAdminRequestInput;
};

export type MutationTeamsApproveNewTeamMemberArgs = {
  input: TeamsApproveNewTeamMemberInput;
};

export type MutationTeamsApproveTeamMemberRoleChangeArgs = {
  input: TeamsApproveTeamMemberRoleChangeInput;
};

export type MutationTeamsCancelInviteArgs = {
  input: TeamsCancelInviteInput;
};

export type MutationTeamsChangeUserRoleArgs = {
  input: TeamsChangeUserRoleInput;
};

export type MutationTeamsConfirmInviteArgs = {
  input: TeamsConfirmInviteInput;
};

export type MutationTeamsCreateTeamArgs = {
  input: TeamsCreateTeamInput;
};

export type MutationTeamsDeactivateTeamArgs = {
  input: TeamsDeactivateTeamInput;
};

export type MutationTeamsGetCheckoutUrlArgs = {
  input: TeamsGetCheckoutUrlInput;
};

export type MutationTeamsInviteUsersArgs = {
  input: TeamsInviteUsersInput;
};

export type MutationTeamsLeaveTeamArgs = {
  input: TeamsLeaveTeamInput;
};

export type MutationTeamsRemoveUsersArgs = {
  input: TeamsRemoveUsersInput;
};

export type MutationTeamsResendInviteArgs = {
  input: TeamsResendInviteInput;
};

export type MutationTeamsUpdateTeamArgs = {
  input: TeamsUpdateTeamInput;
};

export type MutationTransfersAddRecipientsArgs = {
  input: TransfersAddRecipientsInput;
};

export type MutationTransfersCancelArgs = {
  input: TransfersCancelInput;
};

export type MutationTransfersConfirmOwnerEmailArgs = {
  input: TransfersConfirmOwnerEmailInput;
};

export type MutationTransfersCreateSignedDownloadUrlArgs = {
  input: TransfersCreateSignedDownloadUrlInput;
};

export type MutationTransfersDeleteArgs = {
  input: TransfersDeleteInput;
};

export type MutationTransfersInitiateTransferArgs = {
  input: TransfersInitiateTransferInput;
};

export type MutationTransfersInitiateTransferV2Args = {
  input: TransfersInitiateTransferV2Input;
};

export type MutationTransfersNotifyTransferDownloadCompletedArgs = {
  input: NotifyTransferDownloadCompletedInput;
};

export type MutationTransfersVerifyOwnerEmailArgs = {
  input: TransfersVerifyOwnerEmailInput;
};

export type MutationUnfollowUserArgs = {
  userID: Scalars['ID'];
};

export type MutationUpdateFlowArgs = {
  id: Scalars['ID'];
  input: FlowSettingsInput;
};

export type MutationUpdateFlowVisibilityArgs = {
  id: Scalars['ID'];
  visibility: FlowVisibility;
};

export type MutationUpdateUserGdprArgs = {
  input: UserUpdateGdprInput;
};

export type MutationUploadedFontsCreateSignedUrlArgs = {
  input: UploadedFontsCreateSignedUrlInput;
};

export type MutationUploadedFontsDeleteArgs = {
  input: UploadedFontsDeleteInput;
};

export type MutationUploadsCreateSignedUrlV2Args = {
  input: UploadsCreateSignedUrlInputV2;
};

export type MutationUpscalerCancelImageArgs = {
  input: UpscalerCancelImageInput;
};

export type MutationUpscalerCreateSignedUploadUrlArgs = {
  input: UpscalerCreateSignedUploadUrl;
};

export type MutationUpscalerDeleteImageArgs = {
  input: UpscalerDeleteImageInput;
};

export type MutationUpscalerDownloadImageArgs = {
  input: UpscalerDownloadImageInput;
};

export type MutationUpscalerPublishImageArgs = {
  input: UpscalerPublishImageInput;
};

export type MutationUpscalerUpscaleImageArgs = {
  input: UpscalerUpscaleImageInput;
};

export type MutationUserFollowArgs = {
  userID: Scalars['ID'];
};

export type MutationUserUnfollowArgs = {
  userID: Scalars['ID'];
};

export type MutationUsersClaimGiftArgs = {
  input: UsersClaimGiftInput;
};

export type MutationUsersFavoriteProductArgs = {
  isFavorite: Scalars['Boolean'];
  productID: Scalars['Int'];
};

export type MutationUsersUpdateCurrencyArgs = {
  currency: CurrencyCode;
};

export type MutationUsersUpdateFlagsArgs = {
  input: UserUpdateFlagsInput;
};

export type MutationUsersUpdateLanguageArgs = {
  language: Language;
};

export type MutationVectorizerCancelVectorizationArgs = {
  input: VectorizerCancelImageVectorizationInput;
};

export type MutationVectorizerCreateImageArgs = {
  input: VectorizerCreateInput;
};

export type MutationVectorizerCreateSignedUploadUrlArgs = {
  input: VectorizerCreateSignedUploadUrl;
};

export type MutationVectorizerDeleteImageArgs = {
  input: VectorizerDeleteImageInput;
};

export type MutationVectorizerPublishImageArgs = {
  input: VectorizerPublishImageInput;
};

export type MutationVectorizerRegisterImagesToUserArgs = {
  input: VectorizerImagesRegisterToUserInput;
};

export type MutationViewFlowArgs = {
  flowID: Scalars['ID'];
};

export type NewsletterPopup = {
  __typename?: 'NewsletterPopup';
  backgroundImageSrc: EntireFieldWrapper<Scalars['String']>;
  button: EntireFieldWrapper<NewsletterPopupButton>;
  closeText: EntireFieldWrapper<Scalars['String']>;
  footerText: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SitePopupType>;
};

export type NewsletterPopupButton = {
  __typename?: 'NewsletterPopupButton';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  link?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  text: EntireFieldWrapper<Scalars['String']>;
};

export type NotificationBanner = {
  __typename?: 'NotificationBanner';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNav: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNavState: EntireFieldWrapper<Scalars['String']>;
  button: EntireFieldWrapper<NotificationBannerButton>;
  countdown?: EntireFieldWrapper<Maybe<SiteCountdown>>;
  text: EntireFieldWrapper<Scalars['String']>;
  textColor: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SiteBannerType>;
};

export type NotificationBannerButton = {
  __typename?: 'NotificationBannerButton';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  hoverBackgroundColor: EntireFieldWrapper<Scalars['String']>;
  hoverTextColor: EntireFieldWrapper<Scalars['String']>;
  link: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  textColor: EntireFieldWrapper<Scalars['String']>;
};

export type NotificationPopup = {
  __typename?: 'NotificationPopup';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  button: EntireFieldWrapper<NotificationPopupButton>;
  closeText: EntireFieldWrapper<Scalars['String']>;
  countdown?: EntireFieldWrapper<Maybe<SiteCountdown>>;
  text: EntireFieldWrapper<Scalars['String']>;
  textColor: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SitePopupType>;
};

export type NotificationPopupButton = {
  __typename?: 'NotificationPopupButton';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  hoverBackgroundColor: EntireFieldWrapper<Scalars['String']>;
  hoverTextColor: EntireFieldWrapper<Scalars['String']>;
  link: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  textColor: EntireFieldWrapper<Scalars['String']>;
};

export type NotifyTransferDownloadCompletedInput = {
  accessCode: Scalars['String'];
  transferId: Scalars['String'];
};

export type NotifyTransferDownloadCompletedResponse = {
  __typename?: 'NotifyTransferDownloadCompletedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type OnHoldSubscriptionBanner = {
  __typename?: 'OnHoldSubscriptionBanner';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNav: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNavState: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SiteBannerType>;
};

export type OwnedBy = 'teams' | 'users';

export type Pagination = {
  __typename?: 'Pagination';
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  page: EntireFieldWrapper<Scalars['Int']>;
  totalItems: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type Payment = {
  __typename?: 'Payment';
  allowedPaymentMethodTypes: EntireFieldWrapper<Array<AvailablePaymentMethod>>;
  currency: EntireFieldWrapper<PaymentCurrency>;
  lineItems: EntireFieldWrapper<Array<PaymentLineItem>>;
  totals: EntireFieldWrapper<PaymentTotals>;
  user: EntireFieldWrapper<User>;
};

export type PaymentCurrency = {
  __typename?: 'PaymentCurrency';
  code: EntireFieldWrapper<AvailableCurrencyCode>;
  symbol: EntireFieldWrapper<Scalars['String']>;
};

export type PaymentLineItem = {
  __typename?: 'PaymentLineItem';
  billingPeriod: EntireFieldWrapper<BillingPeriod>;
  name: EntireFieldWrapper<Scalars['String']>;
  price: EntireFieldWrapper<Scalars['Int']>;
  trialPeriodDays: EntireFieldWrapper<Scalars['Int']>;
};

export type PaymentLineItemInput = {
  billingPeriod: BillingPeriod;
  name: Scalars['String'];
  price: Scalars['Int'];
  trialPeriodDays: Scalars['Int'];
};

export type PaymentStatus = 'failed' | 'processing' | 'requiresAction' | 'succeeded';

export type PaymentTotals = {
  __typename?: 'PaymentTotals';
  subtotal: EntireFieldWrapper<Scalars['Int']>;
  tax: EntireFieldWrapper<Scalars['Int']>;
  total: EntireFieldWrapper<Scalars['Int']>;
  totalAfterTrial: EntireFieldWrapper<Scalars['Int']>;
};

export type Post = {
  __typename?: 'Post';
  assets?: EntireFieldWrapper<Maybe<Array<SocialAsset>>>;
  childComments?: EntireFieldWrapper<Maybe<Array<SocialComment>>>;
  commentsCount: EntireFieldWrapper<Scalars['Int']>;
  content: EntireFieldWrapper<Scalars['String']>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  instructions?: EntireFieldWrapper<Maybe<Array<Scalars['String']>>>;
  isLiked: EntireFieldWrapper<Scalars['Boolean']>;
  isSaved: EntireFieldWrapper<Scalars['Boolean']>;
  level?: EntireFieldWrapper<Maybe<ProjectLevel>>;
  likesCount: EntireFieldWrapper<Scalars['Int']>;
  machines?: EntireFieldWrapper<Maybe<Array<Scalars['String']>>>;
  materials?: EntireFieldWrapper<Maybe<Array<Scalars['String']>>>;
  postSlug?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** @deprecated Use `socialProducts` field instead */
  products?: EntireFieldWrapper<Maybe<Array<LegacyProduct>>>;
  socialProducts?: EntireFieldWrapper<Maybe<Array<SocialProduct>>>;
  type: EntireFieldWrapper<PostType>;
  user: EntireFieldWrapper<PublicUserProfile>;
};

export type PostType = 'class' | 'product';

export type PriceCalculationsResponse = {
  __typename?: 'PriceCalculationsResponse';
  data?: EntireFieldWrapper<Maybe<CalculatePricesResponse>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type ProductCounts = {
  __typename?: 'ProductCounts';
  crafts: EntireFieldWrapper<Scalars['Int']>;
  embroidery: EntireFieldWrapper<Scalars['Int']>;
  fonts: EntireFieldWrapper<Scalars['Int']>;
  graphics: EntireFieldWrapper<Scalars['Int']>;
  knitting: EntireFieldWrapper<Scalars['Int']>;
  laserCutting: EntireFieldWrapper<Scalars['Int']>;
  pngs: EntireFieldWrapper<Scalars['Int']>;
  svgs: EntireFieldWrapper<Scalars['Int']>;
  threeDPaperCrafts: EntireFieldWrapper<Scalars['Int']>;
};

/**
 * ProductsDownloadContentWithBackgroundRemovedResponse defines the response emitted by the dedicated query
 * for accessing a shared content background removed asset type.
 */
export type ProductsDownloadContentWithBackgroundRemovedResponse = {
  __typename?: 'ProductsDownloadContentWithBackgroundRemovedResponse';
  errors: EntireFieldWrapper<Array<ErrorMessage>>;
  generatedImageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  sourceImageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  state?: EntireFieldWrapper<Maybe<SparkState>>;
};

export type ProfileNudgePopup = {
  __typename?: 'ProfileNudgePopup';
  button: EntireFieldWrapper<ProfileNudgePopupButton>;
  text: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SitePopupType>;
};

export type ProfileNudgePopupButton = {
  __typename?: 'ProfileNudgePopupButton';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  link?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  text: EntireFieldWrapper<Scalars['String']>;
};

export type ProjectEditor = 'Fabric' | 'Polotno';

export type ProjectLevel = 'advanced' | 'beginner' | 'intermediate';

export type ProjectListPagination = {
  __typename?: 'ProjectListPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalItems: EntireFieldWrapper<Scalars['Int']>;
};

export type ProjectSort = {
  direction: SortDirection;
  field: ProjectSortField;
};

export type ProjectSortField = 'createTime' | 'deleteTime' | 'lastViewTime' | 'name' | 'unknown' | 'updateTime';

export type ProjectTemplateOrigin = 'Global' | 'Project';

export type PublicUserProfile = {
  __typename?: 'PublicUserProfile';
  avatarUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  displayName?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  firstName?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  following: EntireFieldWrapper<Scalars['Boolean']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  isCreativeFabrica?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  isFollowed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  isPremium?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  isTemporary: EntireFieldWrapper<Scalars['Boolean']>;
  isVerified?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  lastName?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  location: EntireFieldWrapper<UserLocation>;
  profileUrls?: EntireFieldWrapper<Maybe<PublicUserProfileUrls>>;
  shopName?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  slug?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type PublicUserProfileUrlType = 'Crafter' | 'Designer' | 'Teacher' | 'TheArtistry';

export type PublicUserProfileUrls = {
  __typename?: 'PublicUserProfileUrls';
  crafter?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  designer?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  teacher?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  theArtistry?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type PublishedTemplate = {
  __typename?: 'PublishedTemplate';
  category: EntireFieldWrapper<Scalars['String']>;
  createTime: EntireFieldWrapper<Scalars['String']>;
  createdBy: EntireFieldWrapper<PublicUserProfile>;
  engine: EntireFieldWrapper<PublishedTemplateEngine>;
  feature: EntireFieldWrapper<Scalars['String']>;
  fileUrl: EntireFieldWrapper<Scalars['String']>;
  height: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  imageUrl: EntireFieldWrapper<Scalars['String']>;
  pricingMode: EntireFieldWrapper<PublishedTemplatePricingMode>;
  styles: EntireFieldWrapper<Array<Scalars['String']>>;
  subcategory: EntireFieldWrapper<Scalars['String']>;
  subject: EntireFieldWrapper<Scalars['String']>;
  tags: EntireFieldWrapper<Array<Scalars['String']>>;
  themes: EntireFieldWrapper<Array<Scalars['String']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  topic: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<PublishedTemplateType>;
  width: EntireFieldWrapper<Scalars['Int']>;
};

export type PublishedTemplateEngine = 'fabric' | 'polotno' | 'unspecified';

export type PublishedTemplatePricingMode = 'free' | 'paid' | 'unspecified';

export type PublishedTemplateType = 'graphic' | 'unspecified';

export type PublishedTemplatesAddFavoriteInput = {
  templateId: Scalars['ID'];
};

export type PublishedTemplatesAddFavoriteResponse = {
  __typename?: 'PublishedTemplatesAddFavoriteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type PublishedTemplatesFavoritedInput = {
  templateId: Scalars['ID'];
};

export type PublishedTemplatesFavoritedResponse = {
  __typename?: 'PublishedTemplatesFavoritedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  favorited: EntireFieldWrapper<Scalars['Boolean']>;
};

export type PublishedTemplatesListFavoritesInput = {
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
};

export type PublishedTemplatesListFavoritesResponse = {
  __typename?: 'PublishedTemplatesListFavoritesResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<PublishedTemplatesPagination>>;
  templates?: EntireFieldWrapper<Maybe<Array<PublishedTemplate>>>;
};

export type PublishedTemplatesPagination = {
  __typename?: 'PublishedTemplatesPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type PublishedTemplatesRemoveFavoriteInput = {
  templateId: Scalars['ID'];
};

export type PublishedTemplatesRemoveFavoriteResponse = {
  __typename?: 'PublishedTemplatesRemoveFavoriteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type PublisherCreateTemplateSubmissionInput = {
  imageFileUrl: Scalars['String'];
  jsonFileUrl: Scalars['String'];
  projectId: Scalars['String'];
};

export type PublisherCreateTemplateSubmissionResponse = {
  __typename?: 'PublisherCreateTemplateSubmissionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['String']>;
};

export type PublisherDeleteTemplateSubmissionInput = {
  id: Scalars['String'];
};

export type PublisherDeleteTemplateSubmissionResponse = {
  __typename?: 'PublisherDeleteTemplateSubmissionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type PublisherFinaliseTemplateSubmissionInput = {
  category?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type PublisherFinaliseTemplateSubmissionResponse = {
  __typename?: 'PublisherFinaliseTemplateSubmissionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type PublisherRegenerateTemplateSubmissionFieldsInput = {
  id: Scalars['String'];
};

export type PublisherRegenerateTemplateSubmissionFieldsResponse = {
  __typename?: 'PublisherRegenerateTemplateSubmissionFieldsResponse';
  category?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  reachedMaxSuggestions?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type PublisherTemplateSubmissionInput = {
  id: Scalars['ID'];
};

export type PublisherTemplateSubmissionResponse = {
  __typename?: 'PublisherTemplateSubmissionResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  template?: EntireFieldWrapper<Maybe<TemplateSubmission>>;
};

export type PublisherTemplateSubmissionUpdatedResponse = {
  __typename?: 'PublisherTemplateSubmissionUpdatedResponse';
  template?: EntireFieldWrapper<Maybe<TemplateSubmission>>;
};

export type PublisherTemplatesSubmissionsInput = {
  afterId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<TemplateSubmissionStatus>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PublisherTemplatesSubmissionsResponse = {
  __typename?: 'PublisherTemplatesSubmissionsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasMore?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  templates?: EntireFieldWrapper<Maybe<Array<TemplateSubmission>>>;
};

export type PublisherUploadsCreateSignedUrlInput = {
  uploadFile: Scalars['String'];
};

export type PublisherUploadsCreateSignedUrlResponse = {
  __typename?: 'PublisherUploadsCreateSignedUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['String']>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  advertisingGetCampaign: EntireFieldWrapper<AdvertisingGetCampaignResponse>;
  advertisingGetRandomNCampaigns: EntireFieldWrapper<AdvertisingGetRandomNCampaignsResponse>;
  advertisingGetTotalActionsByMonth: EntireFieldWrapper<AdvertisingGetTotalActionsByMonthResponse>;
  advertisingGetUploaded: EntireFieldWrapper<AdvertisingGetUploadedResponse>;
  advertisingListCampaign: EntireFieldWrapper<AdvertisingListCampaignResponse>;
  /** @deprecated Use coinsProductTransactions instead */
  allCoinTransactionsForProductId: EntireFieldWrapper<CoinTransactionsResponseByProduct>;
  askCFDiscoveryFeed: EntireFieldWrapper<AskCfFeedResponse>;
  askCFFollowedQuestionsFeed: EntireFieldWrapper<AskCfFeedResponse>;
  askCFFollowingFeed: EntireFieldWrapper<AskCfFeedResponse>;
  askCFGetGivenTopics: EntireFieldWrapper<AskGetGivenTopicsResponse>;
  askCFGetQuestion: EntireFieldWrapper<AskCfGetQuestionResponse>;
  askCFGetQuestionPartialThread: EntireFieldWrapper<AskCfGetQuestionPartialThreadResponse>;
  askCFGetTopic: EntireFieldWrapper<AskGetTopicResponse>;
  askCFGetTopics: EntireFieldWrapper<AskGetTopicsResponse>;
  askCFGetUploaded: EntireFieldWrapper<AskCfGetUploadedResponse>;
  askCFGetUserDigestStatus: EntireFieldWrapper<AskGetUserDigestStatusResponse>;
  askCFGetUserStats: EntireFieldWrapper<AskGetUserStatsResponse>;
  /** @deprecated Use askCFDiscoveryFeed or askCFFollowingFeed instead */
  askCFHomeFeed: EntireFieldWrapper<AskCfFeedResponse>;
  askCFListComments: EntireFieldWrapper<AskCfListCommentsResponse>;
  askCFTopicFeed: EntireFieldWrapper<AskCfFeedResponse>;
  askCFUserAnsweredFeed: EntireFieldWrapper<AskCfFeedResponse>;
  askCFUserFeed: EntireFieldWrapper<AskCfFeedResponse>;
  cachedSiteData: EntireFieldWrapper<SiteData>;
  calculatePrices: EntireFieldWrapper<PriceCalculationsResponse>;
  cfmainAreUserFavorites: EntireFieldWrapper<Array<CfMainIsUserFavorite>>;
  cfmainGetEnterpriseRequest: EntireFieldWrapper<CfMainGetEnterpriseRequestResponse>;
  cfmainListEnterpriseRequests: EntireFieldWrapper<CfMainListEnterpriseRequestsResponse>;
  cfmainProductsFavoritesCount: EntireFieldWrapper<CfMainProductsFavoritesCount>;
  chipsForImage: EntireFieldWrapper<Array<Scalars['String']>>;
  chipsForPrompt: EntireFieldWrapper<Array<Scalars['String']>>;
  clubhouseListPendingInvitations: EntireFieldWrapper<ClubhouseListPendingInvitationResponse>;
  clubhousesCommunityLeaderStatus: EntireFieldWrapper<ClubhousesCommunityLeaderStatusResponse>;
  clubhousesFriendsList: EntireFieldWrapper<ClubhouseFriendsListResponse>;
  clubhousesFromUser: EntireFieldWrapper<ClubhousesFomUserResponse>;
  clubhousesGetDetails: EntireFieldWrapper<GetClubhouseResponse>;
  clubhousesGetDiscussion: EntireFieldWrapper<ClubhousesGetDiscussionResponse>;
  clubhousesGetDiscussionReplies: EntireFieldWrapper<ClubhousesGetDiscussionRepliesResponse>;
  clubhousesGetSubscriberCount: EntireFieldWrapper<ClubhousesGetSubscriberCountResponse>;
  clubhousesGetUploaded: EntireFieldWrapper<ClubhousesGetUploadedResponse>;
  clubhousesGetUserStats: EntireFieldWrapper<ClubhousesGetUserStatsResponse>;
  clubhousesIsClubhouseMember: EntireFieldWrapper<ClubhouseIsMemberResponse>;
  clubhousesIsSubscribedToDigest: EntireFieldWrapper<IsSubscribedToDigestResponse>;
  clubhousesListAll: EntireFieldWrapper<ClubhousesListResponse>;
  clubhousesListCommunityLeaders: EntireFieldWrapper<ClubhousesCommunityLeadersListResponse>;
  clubhousesListMembers: EntireFieldWrapper<MembersListResponse>;
  clubhousesListTopDiscussions: EntireFieldWrapper<ClubhousesTopDiscussionsListResponse>;
  clubhousesListTopicDiscussions: EntireFieldWrapper<ClubhousesTopicDiscussionsListResponse>;
  clubhousesListTopics: EntireFieldWrapper<ClubhousesTopicsListResponse>;
  clubhousesTopicsGetDetails: EntireFieldWrapper<GetClubhouseTopicResponse>;
  clubhousesUser?: EntireFieldWrapper<Maybe<ClubhousesUserResponse>>;
  clubhousesUsersBatch?: EntireFieldWrapper<Maybe<ClubhousesUsersBatchResponse>>;
  coins: EntireFieldWrapper<CoinWallet>;
  coinsBundles: EntireFieldWrapper<CoinsBundlesResponse>;
  coinsDownloads: EntireFieldWrapper<CoinsDownloadsResponse>;
  coinsPopularProducts: EntireFieldWrapper<CoinsPopularResponse>;
  coinsProductTransactions: EntireFieldWrapper<CoinTransactionsResponseByProduct>;
  coinsSettings: EntireFieldWrapper<CoinSettings>;
  coinsTransactionForProductId: EntireFieldWrapper<CoinTransactionResponse>;
  coinsTransactions: EntireFieldWrapper<CoinTransactionsResponse>;
  contentCountFavorites: EntireFieldWrapper<ContentProductFavoriteCount>;
  contentCountUserReviewsToday: EntireFieldWrapper<Scalars['Int']>;
  contentDownloadAssets: EntireFieldWrapper<Array<AssetDownloadResponse>>;
  /**
   * Allows the download of one or more assets uniquely identify by their asset id.
   *     By default this query will not increase the download count on those products  you should use
   *     the "contentIncreaseDownloadCountV2" mutation for that.
   */
  contentDownloadAssetsV2?: EntireFieldWrapper<Maybe<AssetsDownloadResponseV2>>;
  contentFetchCategory: EntireFieldWrapper<ContentCategory>;
  contentFetchLicense?: EntireFieldWrapper<Maybe<ContentLicense>>;
  contentFetchReview: EntireFieldWrapper<ContentReview>;
  contentIsProductFavorited: EntireFieldWrapper<Scalars['Boolean']>;
  contentLicenseCount: EntireFieldWrapper<Scalars['Int']>;
  contentLinkBlock?: EntireFieldWrapper<Maybe<ContentLinkBlock>>;
  contentListFavoriteLists: EntireFieldWrapper<Array<ContentFavoriteList>>;
  contentListFavorites: EntireFieldWrapper<Array<ContentFavorite>>;
  /** @deprecated Use contentListProductsV2 instead */
  contentListProducts: EntireFieldWrapper<ContentPagination>;
  contentListProductsV2: EntireFieldWrapper<ContentPaginationV2>;
  contentMyReview?: EntireFieldWrapper<Maybe<ContentReview>>;
  contentProduct?: EntireFieldWrapper<Maybe<ContentProduct>>;
  contentProductAssets: EntireFieldWrapper<Array<ContentAsset>>;
  contentProductLicense?: EntireFieldWrapper<Maybe<ContentLicense>>;
  contentProductPublicAssets: EntireFieldWrapper<Array<ContentAsset>>;
  contentProductReviews: EntireFieldWrapper<ContentProductReviews>;
  contentProductStats: EntireFieldWrapper<ContentProductStats>;
  contentSearchCategory: EntireFieldWrapper<Array<ContentCategory>>;
  contentUserFavoritesCount: EntireFieldWrapper<ContentUserListFavoritesCount>;
  contentUserListFavorites: EntireFieldWrapper<ContentUserListFavorites>;
  currentSubscription?: EntireFieldWrapper<Maybe<UserSubscription>>;
  designReviewerGetReview: EntireFieldWrapper<DesignReviewerGetReviewResponse>;
  designReviewerListReviews: EntireFieldWrapper<DesignReviewerListReviewsResponse>;
  entityReactions: EntireFieldWrapper<EntityReactionsResponse>;
  flow?: EntireFieldWrapper<Maybe<Flow>>;
  flowFeed: EntireFieldWrapper<FlowFeed>;
  flowFeedStatus: EntireFieldWrapper<Array<FlowStatus>>;
  flowGenerationsCount: EntireFieldWrapper<FlowGenerationsCountResponse>;
  flowGetIterationPageRating: EntireFieldWrapper<FlowGetIterationPageRatingResponse>;
  flowImage: EntireFieldWrapper<FlowImageResponse>;
  flowImageFlow: EntireFieldWrapper<FlowImageFlowResponse>;
  flowImageGetFavorites: EntireFieldWrapper<FlowImageGetFavoritesResponse>;
  flowImageGetReactions: EntireFieldWrapper<FlowImageGetReactionsResponse>;
  flowImagesTop: EntireFieldWrapper<FlowImagesTopResponse>;
  flowImagesTopAllTime: EntireFieldWrapper<FlowImagesTopAllTimeResponse>;
  flowIterationPages: EntireFieldWrapper<FlowIterationPagesResponse>;
  flowMostLikedFlows: EntireFieldWrapper<Array<Scalars['String']>>;
  flowMostViewedFlows: EntireFieldWrapper<Array<Scalars['String']>>;
  flowQueue: EntireFieldWrapper<Scalars['Int']>;
  flowStatus: EntireFieldWrapper<FlowStatus>;
  flowViewers: EntireFieldWrapper<FlowViewersResponse>;
  /** @deprecated Use flowsUserFlows */
  flows: EntireFieldWrapper<Array<Flow>>;
  flowsPreviewUserFlows: EntireFieldWrapper<FlowsPreviewUserFlowsResponse>;
  /** @deprecated use font fontGeneratorUserFont */
  fontGeneratorFont: EntireFieldWrapper<FontGeneratorFontResponse>;
  /** @deprecated use font fontGeneratorUserFonts */
  fontGeneratorFonts: EntireFieldWrapper<FontGeneratorFontsResponse>;
  /** @deprecated use fontsFeed */
  fontGeneratorFontsFeed: EntireFieldWrapper<FontGeneratorFontsFeedResponse>;
  fontGeneratorUserFont: EntireFieldWrapper<FontGeneratorUserFontResponse>;
  fontGeneratorUserFonts: EntireFieldWrapper<FontGeneratorUserFontsResponse>;
  fontsFeed: EntireFieldWrapper<FontsFeedResponse>;
  fontsFeedFont: EntireFieldWrapper<FontsFeedFontResponse>;
  fontsFeedFontBrowser: EntireFieldWrapper<FontsFeedFontBrowserResponse>;
  getRedeemReward: EntireFieldWrapper<RedeemReward>;
  getUserSubscription: EntireFieldWrapper<GetUserSubscriptionResponse>;
  halloweenSubscriptionPurchase?: EntireFieldWrapper<Maybe<HalloweenSubscriptionPurchase>>;
  helpConversation?: EntireFieldWrapper<Maybe<HelpConversation>>;
  helpWelcomeMessage: EntireFieldWrapper<Scalars['String']>;
  isUploadAllowed: EntireFieldWrapper<IsUploadAllowedResponse>;
  legacyProductsFetchLicense?: EntireFieldWrapper<Maybe<LegacyLicense>>;
  legacyProductsFetchProduct?: EntireFieldWrapper<Maybe<LegacyProduct>>;
  legacyProductsListPPEProducts: EntireFieldWrapper<LegacyPpeResponse>;
  legacyProductsListUserFavorites: EntireFieldWrapper<Array<LegacyProduct>>;
  listRedeemedCodes: EntireFieldWrapper<Array<RedeemCode>>;
  listUserSubscriptions: EntireFieldWrapper<ListUserSubscriptionsResponse>;
  me?: EntireFieldWrapper<Maybe<AuthResponse>>;
  /** @deprecated Use flowMostLikedFlows */
  mostLikedFlows: EntireFieldWrapper<Array<Scalars['String']>>;
  /** @deprecated Use flowMostViewedFlows */
  mostViewedFlows: EntireFieldWrapper<Array<Scalars['String']>>;
  paymentsCalculateTax: EntireFieldWrapper<PaymentTotals>;
  paymentsStripeSubscriptionExtensionInfo?: EntireFieldWrapper<Maybe<StripeSubscriptionExtensionInfo>>;
  paymentsStripeSubscriptionIdToExtend?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  paymentsStripeSubscriptionIdToUpgrade?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** Provides the query that can be used to retrieve the asset with the background removed for the specified product. */
  productsDownloadContentWithBackgroundRemoved: EntireFieldWrapper<ProductsDownloadContentWithBackgroundRemovedResponse>;
  publicUserProfile: EntireFieldWrapper<PublicUserProfile>;
  publicUserProfileById: EntireFieldWrapper<PublicUserProfile>;
  publishedTemplatesFavorited: EntireFieldWrapper<PublishedTemplatesFavoritedResponse>;
  publishedTemplatesListFavorites: EntireFieldWrapper<PublishedTemplatesListFavoritesResponse>;
  publisherTemplateSubmission: EntireFieldWrapper<PublisherTemplateSubmissionResponse>;
  publisherTemplateSubmissions: EntireFieldWrapper<PublisherTemplatesSubmissionsResponse>;
  searchPrompts: EntireFieldWrapper<SearchPromptsResponse>;
  siteData: EntireFieldWrapper<SiteData>;
  snippetsGetSnippet: EntireFieldWrapper<SnippetsGetSnippetResponse>;
  snippetsListSnippets: EntireFieldWrapper<SnippetsListSnippetResponse>;
  socialBlockUserList: EntireFieldWrapper<SocialBlockUserListResponse>;
  socialDiscoveryFeed: EntireFieldWrapper<SocialFeedResponse>;
  socialFollowersFeed: EntireFieldWrapper<SocialFeedResponse>;
  socialGetPost: EntireFieldWrapper<SocialPostResponse>;
  socialGetUploaded: EntireFieldWrapper<SocialGetUploadedResponse>;
  socialListComments: EntireFieldWrapper<SocialCommentsListResponse>;
  socialListPostByProduct: EntireFieldWrapper<SocialListPostByProductResponse>;
  socialSavedFeed: EntireFieldWrapper<SocialSavedFeedResponse>;
  socialUserFeed: EntireFieldWrapper<SocialFeedResponse>;
  sparkArt: EntireFieldWrapper<SparkArtGetResponse>;
  sparkArtList: EntireFieldWrapper<SparkArtListResponse>;
  sparkCrystalline: EntireFieldWrapper<SparkCrystallineGetResponse>;
  sparkCrystallineList: EntireFieldWrapper<SparkCrystallineListResponse>;
  sparkGetUploaded: EntireFieldWrapper<SparkGetUploadedResponse>;
  sparkImageMixGet: EntireFieldWrapper<SparkImageMixGetResponse>;
  sparkImageMixList: EntireFieldWrapper<SparkImageMixListResponse>;
  sparkInpaintGet: EntireFieldWrapper<SparkInpaintGetResponse>;
  sparkInpaintList: EntireFieldWrapper<SparkInpaintListResponse>;
  sparkOutpaintGet: EntireFieldWrapper<SparkOutpaintGetResponse>;
  sparkOutpaintList: EntireFieldWrapper<SparkOutpaintListResponse>;
  sparkRemovedBackground: EntireFieldWrapper<SparkRemoveBackgroundGetResponse>;
  sparkRemovedBackgroundList: EntireFieldWrapper<SparkRemovedBackgroundListResponse>;
  storageInfo: EntireFieldWrapper<StorageInfoResponse>;
  studioAllSimpleComments: EntireFieldWrapper<StudioSimpleCommentsResponse>;
  studioCommentReactions: EntireFieldWrapper<StudioCommentReactionsResponse>;
  studioIsAllAccessUser: EntireFieldWrapper<StudioIsAllAccessUserResponse>;
  studioProjectDownloadAssets: EntireFieldWrapper<StudioProjectDownloadAssetsResponse>;
  studioProjectsFolderGet: EntireFieldWrapper<StudioProjectsFolderGetResponse>;
  studioProjectsGetProject: EntireFieldWrapper<StudioProjectsGetProjectResponse>;
  studioProjectsGetProjectComments: EntireFieldWrapper<StudioProjectsGetProjectCommentsResponse>;
  studioProjectsGetTeam: EntireFieldWrapper<StudioProjectsGetTeamResponse>;
  studioProjectsListItemsInTrash: EntireFieldWrapper<StudioProjectsListItemsInTrashResponse>;
  studioProjectsListMostRecent: EntireFieldWrapper<StudioProjectsListMostRecentResponse>;
  studioProjectsListProjects: EntireFieldWrapper<StudioProjectsListProjectsResponse>;
  studioProjectsListProjectsInTrash: EntireFieldWrapper<StudioProjectsListProjectsInTrashResponse>;
  studioProjectsListProjectsSharedWithMe: EntireFieldWrapper<StudioProjectsListProjectsSharedWithMeResponse>;
  studioSimpleCommentTaggableUsers: EntireFieldWrapper<StudioSimpleCommentTaggableUsersResponse>;
  studioSimpleComments: EntireFieldWrapper<StudioSimpleCommentsResponse>;
  studioTemplatesList: EntireFieldWrapper<StudioTemplateListResponse>;
  studioUploadsGetFolder: EntireFieldWrapper<StudioUploadsGetFolderResponse>;
  studioUploadsGetTagsForUploads: EntireFieldWrapper<StudioUploadsGetTagsForUploadsResponse>;
  studioUploadsSearchFiles: EntireFieldWrapper<StudioUploadsSearchFilesResponse>;
  studioUploadsTags: EntireFieldWrapper<StudioUploadsTagsResponse>;
  tagsGetProductTags: EntireFieldWrapper<Array<Tag>>;
  teamsFetchOutstandingInvoiceUrl: EntireFieldWrapper<TeamsFetchOutstandingInvoiceUrlResponse>;
  /** @deprecated Use teamsPreviewUpcomingCharges instead */
  teamsFetchUpcomingInvoiceUrl: EntireFieldWrapper<TeamsFetchUpcomingInvoiceUrlResponse>;
  teamsGet: EntireFieldWrapper<TeamsGetTeamResponse>;
  teamsPreviewUpcomingCharges: EntireFieldWrapper<TeamsPreviewUpcomingChargesResponse>;
  transfersGetTransfer: EntireFieldWrapper<TransfersGetTransferResponse>;
  transfersListTransfers: EntireFieldWrapper<ListTransfersResponse>;
  uploadedFontsSearch: EntireFieldWrapper<UploadedFontsSearchResponse>;
  upscalerImage: EntireFieldWrapper<UpscalerGetImageResponse>;
  upscalerImages: EntireFieldWrapper<UpscalerImagesResponse>;
  user?: EntireFieldWrapper<Maybe<User>>;
  userBalance: EntireFieldWrapper<UserBalance>;
  userFollowers?: EntireFieldWrapper<Maybe<UserFollowersResponse>>;
  userFollowersCount?: EntireFieldWrapper<Maybe<UserFollowersCountResponse>>;
  userFollowing?: EntireFieldWrapper<Maybe<UserFollowingResponse>>;
  userGetCredit?: EntireFieldWrapper<Maybe<UserGetCreditResponse>>;
  userListLegacyAndContentFavoriteProducts: EntireFieldWrapper<Array<UserListFavoriteProduct>>;
  usersCheckFollowing: EntireFieldWrapper<Scalars['Boolean']>;
  usersLocation: EntireFieldWrapper<UserLocationResponse>;
  usersShippingAddress: EntireFieldWrapper<UserShippingAddressResponse>;
  validateToken?: EntireFieldWrapper<Maybe<ValidateTokenResponse>>;
  vectorizerGetImage: EntireFieldWrapper<VectorizerGetImageResponse>;
  /** @deprecated Use vectorizerListImagesV2 instead */
  vectorizerListImages: EntireFieldWrapper<VectorizerListImagesResponse>;
  vectorizerListImagesV2: EntireFieldWrapper<VectorizerListImagesV2Response>;
};

export type QueryAdvertisingGetCampaignArgs = {
  input: AdvertisingGetCampaignInput;
};

export type QueryAdvertisingGetRandomNCampaignsArgs = {
  input?: InputMaybe<AdvertisingGetRandomNCampaignsInput>;
};

export type QueryAdvertisingGetTotalActionsByMonthArgs = {
  input: AdvertisingGetTotalActionsByMonthInput;
};

export type QueryAdvertisingGetUploadedArgs = {
  input: AdvertisingGetUploadedInput;
};

export type QueryAdvertisingListCampaignArgs = {
  input: AdvertisingListCampaignInput;
};

export type QueryAllCoinTransactionsForProductIdArgs = {
  productId: Scalars['String'];
};

export type QueryAskCfDiscoveryFeedArgs = {
  input: AskCfDiscoveryFeedInput;
};

export type QueryAskCfFollowedQuestionsFeedArgs = {
  input: AskCfFollowedQuestionsInput;
};

export type QueryAskCfFollowingFeedArgs = {
  input: AskCfFollowingFeedInput;
};

export type QueryAskCfGetGivenTopicsArgs = {
  input: AskCfGetGivenTopicsInput;
};

export type QueryAskCfGetQuestionArgs = {
  input: AskCfGetQuestionInput;
};

export type QueryAskCfGetQuestionPartialThreadArgs = {
  input: AskCfGetQuestionPartialThreadInput;
};

export type QueryAskCfGetTopicArgs = {
  input: AskCfGetTopicInput;
};

export type QueryAskCfGetUploadedArgs = {
  input: AskCfGetUploadedInput;
};

export type QueryAskCfGetUserStatsArgs = {
  input: AskCfGetUserStatsInput;
};

export type QueryAskCfHomeFeedArgs = {
  input: AskCfHomeFeedInput;
};

export type QueryAskCfListCommentsArgs = {
  input: AskCfListCommentsInput;
};

export type QueryAskCfTopicFeedArgs = {
  input: AskCfTopicFeedInput;
};

export type QueryAskCfUserAnsweredFeedArgs = {
  input: AskCfUserAnsweredFeedInput;
};

export type QueryAskCfUserFeedArgs = {
  input: AskCfUserFeedInput;
};

export type QueryCachedSiteDataArgs = {
  language?: InputMaybe<Language>;
};

export type QueryCalculatePricesArgs = {
  input: CalculatePricesInput;
};

export type QueryCfmainAreUserFavoritesArgs = {
  productIDs: Array<Scalars['Int']>;
};

export type QueryCfmainGetEnterpriseRequestArgs = {
  input: CfMainGetEnterpriseRequestInput;
};

export type QueryCfmainListEnterpriseRequestsArgs = {
  input: CfMainListEnterpriseRequestsInput;
};

export type QueryCfmainProductsFavoritesCountArgs = {
  productIds: Array<Scalars['Int']>;
};

export type QueryChipsForImageArgs = {
  imageUrl: Scalars['String'];
};

export type QueryChipsForPromptArgs = {
  prompt: Scalars['String'];
};

export type QueryClubhouseListPendingInvitationsArgs = {
  input: ClubhouseListPendingInvitationInput;
};

export type QueryClubhousesCommunityLeaderStatusArgs = {
  input: ClubhousesCommunityLeaderStatusInput;
};

export type QueryClubhousesFriendsListArgs = {
  input: ClubhouseFriendsListInput;
};

export type QueryClubhousesFromUserArgs = {
  input: ClubhousesFromUserInput;
};

export type QueryClubhousesGetDetailsArgs = {
  input: GetClubhouseInput;
};

export type QueryClubhousesGetDiscussionArgs = {
  input: ClubhousesGetDiscussionInput;
};

export type QueryClubhousesGetDiscussionRepliesArgs = {
  input: ClubhousesGetDiscussionRepliesInput;
};

export type QueryClubhousesGetSubscriberCountArgs = {
  input: ClubhousesGetSubscriberCountInput;
};

export type QueryClubhousesGetUploadedArgs = {
  input: ClubhousesGetUploadedInput;
};

export type QueryClubhousesGetUserStatsArgs = {
  input: ClubhousesGetUserStatsInput;
};

export type QueryClubhousesIsClubhouseMemberArgs = {
  input: ClubhouseIsMemberInput;
};

export type QueryClubhousesIsSubscribedToDigestArgs = {
  input: IsSubscribedToDigestInput;
};

export type QueryClubhousesListAllArgs = {
  input: ClubhousesListInput;
};

export type QueryClubhousesListCommunityLeadersArgs = {
  input: ClubhousesCommunityLeadersListInput;
};

export type QueryClubhousesListMembersArgs = {
  input: MembersListInput;
};

export type QueryClubhousesListTopDiscussionsArgs = {
  input: ClubhousesTopDiscussionsListInput;
};

export type QueryClubhousesListTopicDiscussionsArgs = {
  input: ClubhousesTopicDiscussionsListInput;
};

export type QueryClubhousesListTopicsArgs = {
  input: ClubhousesTopicsListInput;
};

export type QueryClubhousesTopicsGetDetailsArgs = {
  input: GetClubhouseTopicInput;
};

export type QueryClubhousesUserArgs = {
  input: ClubhousesUserInput;
};

export type QueryClubhousesUsersBatchArgs = {
  input: ClubhousesUsersBatchInput;
};

export type QueryCoinsDownloadsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CoinsDownloadsOrderBy>;
};

export type QueryCoinsProductTransactionsArgs = {
  productId: Scalars['String'];
};

export type QueryCoinsTransactionForProductIdArgs = {
  productId: Scalars['String'];
};

export type QueryCoinsTransactionsArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryContentCountFavoritesArgs = {
  productId: Scalars['ID'];
};

export type QueryContentDownloadAssetsArgs = {
  ids: Array<Scalars['ID']>;
  source?: InputMaybe<ContentDownloadSource>;
};

export type QueryContentDownloadAssetsV2Args = {
  input: ContentDownloadAssetsInput;
};

export type QueryContentFetchCategoryArgs = {
  id: Scalars['ID'];
  language: ContentLanguage;
};

export type QueryContentFetchLicenseArgs = {
  input: ContentFetchLicenseInput;
};

export type QueryContentFetchReviewArgs = {
  id: Scalars['ID'];
};

export type QueryContentIsProductFavoritedArgs = {
  productId: Scalars['ID'];
};

export type QueryContentLicenseCountArgs = {
  currentSubscriptionOnly?: InputMaybe<Scalars['Boolean']>;
  includeFree?: InputMaybe<Scalars['Boolean']>;
};

export type QueryContentLinkBlockArgs = {
  id: Scalars['ID'];
  language: ContentLanguage;
};

export type QueryContentListFavoriteListsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
};

export type QueryContentListFavoritesArgs = {
  input?: InputMaybe<ContentListFavoritesInput>;
};

export type QueryContentListProductsArgs = {
  categoryId: Scalars['ID'];
  language: ContentLanguage;
  limit?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  type: ContentPaginationType;
};

export type QueryContentListProductsV2Args = {
  categoryId: Scalars['ID'];
  language: ContentLanguage;
  limit?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  type: ContentPaginationType;
};

export type QueryContentMyReviewArgs = {
  productId: Scalars['ID'];
};

export type QueryContentProductArgs = {
  id: Scalars['ID'];
  increaseViewCount?: InputMaybe<Scalars['Boolean']>;
  language: ContentLanguage;
};

export type QueryContentProductAssetsArgs = {
  id: Scalars['ID'];
};

export type QueryContentProductLicenseArgs = {
  id: Scalars['ID'];
};

export type QueryContentProductPublicAssetsArgs = {
  id: Scalars['ID'];
};

export type QueryContentProductReviewsArgs = {
  input: ContentProductReviewsInput;
};

export type QueryContentProductStatsArgs = {
  id: Scalars['ID'];
};

export type QueryContentSearchCategoryArgs = {
  allLevels?: InputMaybe<Scalars['Boolean']>;
  language: ContentLanguage;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['String']>;
};

export type QueryContentUserFavoritesCountArgs = {
  input?: InputMaybe<ContentUserFavoritesCountInput>;
};

export type QueryContentUserListFavoritesArgs = {
  input?: InputMaybe<ContentUserListFavoritesInput>;
};

export type QueryDesignReviewerGetReviewArgs = {
  input: DesignReviewerGetReviewInput;
};

export type QueryDesignReviewerListReviewsArgs = {
  input: DesignReviewerListReviewsInput;
};

export type QueryEntityReactionsArgs = {
  input?: InputMaybe<EntityReactionsInput>;
};

export type QueryFlowArgs = {
  id: Scalars['String'];
  iterations?: InputMaybe<FlowIterationsInput>;
};

export type QueryFlowFeedArgs = {
  afterId?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type QueryFlowGetIterationPageRatingArgs = {
  input: FlowGetIterationPageRatingInput;
};

export type QueryFlowImageArgs = {
  input: FlowImageInput;
};

export type QueryFlowImageFlowArgs = {
  input: FlowImageFlowInput;
};

export type QueryFlowImageGetFavoritesArgs = {
  input: FlowImageGetFavoritesInput;
};

export type QueryFlowImageGetReactionsArgs = {
  input: FlowImageGetReactionsInput;
};

export type QueryFlowImagesTopArgs = {
  input: FlowImagesTopInput;
};

export type QueryFlowImagesTopAllTimeArgs = {
  input: FlowImagesTopAllTimeInput;
};

export type QueryFlowIterationPagesArgs = {
  input?: InputMaybe<FlowIterationPagesInput>;
};

export type QueryFlowQueueArgs = {
  flowID: Scalars['String'];
};

export type QueryFlowStatusArgs = {
  flowID: Scalars['ID'];
};

export type QueryFlowViewersArgs = {
  flowID: Scalars['ID'];
};

export type QueryFlowsArgs = {
  afterId?: InputMaybe<Scalars['String']>;
  take: Scalars['Int'];
};

export type QueryFlowsPreviewUserFlowsArgs = {
  input: FlowsPreviewUserFlowsInput;
};

export type QueryFontGeneratorFontArgs = {
  input: FontGeneratorFontInput;
};

export type QueryFontGeneratorFontsArgs = {
  input?: InputMaybe<FontGeneratorFontsInput>;
};

export type QueryFontGeneratorFontsFeedArgs = {
  input?: InputMaybe<FontGeneratorFontsFeedInput>;
};

export type QueryFontGeneratorUserFontArgs = {
  input: FontGeneratorUserFontInput;
};

export type QueryFontGeneratorUserFontsArgs = {
  input: FontGeneratorUserFontsInput;
};

export type QueryFontsFeedArgs = {
  input: FontsFeedInput;
};

export type QueryFontsFeedFontArgs = {
  id: Scalars['ID'];
};

export type QueryFontsFeedFontBrowserArgs = {
  input: FontsFeedFontBrowserInput;
};

export type QueryGetRedeemRewardArgs = {
  input: GetRedeemRewardInput;
};

export type QueryGetUserSubscriptionArgs = {
  input: GetUserSubscriptionInput;
};

export type QueryHelpConversationArgs = {
  channel: HelpChannel;
  conversationId: Scalars['ID'];
};

export type QueryHelpWelcomeMessageArgs = {
  channel: HelpChannel;
  language?: InputMaybe<Language>;
};

export type QueryIsUploadAllowedArgs = {
  request?: InputMaybe<IsUploadAllowedRequest>;
};

export type QueryLegacyProductsFetchLicenseArgs = {
  productId: Scalars['Int'];
};

export type QueryLegacyProductsFetchProductArgs = {
  id: Scalars['Int'];
};

export type QueryLegacyProductsListPpeProductsArgs = {
  input?: InputMaybe<LegacyProductsListPpeProductsInput>;
};

export type QueryLegacyProductsListUserFavoritesArgs = {
  input?: InputMaybe<LegacyListUserFavoritesInput>;
};

export type QueryListRedeemedCodesArgs = {
  input: ListRedeemedCodesInput;
};

export type QueryListUserSubscriptionsArgs = {
  input: ListUserSubscriptionsInput;
};

export type QueryPaymentsCalculateTaxArgs = {
  address: AddressInput;
  currencyCode: AvailableCurrencyCode;
  euTaxId?: InputMaybe<Scalars['String']>;
  lineItems: Array<PaymentLineItemInput>;
  taxId?: InputMaybe<Scalars['String']>;
};

export type QueryPaymentsStripeSubscriptionExtensionInfoArgs = {
  isPolling?: InputMaybe<Scalars['Boolean']>;
  stripeCustomerId: Scalars['String'];
};

export type QueryPaymentsStripeSubscriptionIdToExtendArgs = {
  stripeCustomerId?: InputMaybe<Scalars['String']>;
};

export type QueryPaymentsStripeSubscriptionIdToUpgradeArgs = {
  stripeCustomerId?: InputMaybe<Scalars['String']>;
};

export type QueryProductsDownloadContentWithBackgroundRemovedArgs = {
  productId: Scalars['ID'];
};

export type QueryPublicUserProfileArgs = {
  slug: Scalars['String'];
};

export type QueryPublicUserProfileByIdArgs = {
  id: Scalars['ID'];
};

export type QueryPublishedTemplatesFavoritedArgs = {
  input: PublishedTemplatesFavoritedInput;
};

export type QueryPublishedTemplatesListFavoritesArgs = {
  input: PublishedTemplatesListFavoritesInput;
};

export type QueryPublisherTemplateSubmissionArgs = {
  input: PublisherTemplateSubmissionInput;
};

export type QueryPublisherTemplateSubmissionsArgs = {
  input: PublisherTemplatesSubmissionsInput;
};

export type QuerySearchPromptsArgs = {
  input: SearchPromptsInput;
};

export type QuerySnippetsGetSnippetArgs = {
  input: SnippetsGetSnippetInput;
};

export type QuerySnippetsListSnippetsArgs = {
  input: SnippetsListSnippetInput;
};

export type QuerySocialBlockUserListArgs = {
  input: SocialBlockUserListInput;
};

export type QuerySocialDiscoveryFeedArgs = {
  input: SocialDiscoveryFeedInput;
};

export type QuerySocialFollowersFeedArgs = {
  input: SocialFollowersFeedInput;
};

export type QuerySocialGetPostArgs = {
  input: SocialGetPostInput;
};

export type QuerySocialGetUploadedArgs = {
  input: SocialGetUploadedInput;
};

export type QuerySocialListCommentsArgs = {
  input: SocialCommentsListInput;
};

export type QuerySocialListPostByProductArgs = {
  input: SocialListPostByProductInput;
};

export type QuerySocialSavedFeedArgs = {
  input: SocialSavedFeedInput;
};

export type QuerySocialUserFeedArgs = {
  input: SocialUserFeedInput;
};

export type QuerySparkArtArgs = {
  input: SparkArtGetInput;
};

export type QuerySparkArtListArgs = {
  input?: InputMaybe<SparkArtListInput>;
};

export type QuerySparkCrystallineArgs = {
  input: SparkCrystallineGetInput;
};

export type QuerySparkCrystallineListArgs = {
  input?: InputMaybe<SparkCrystallineListInput>;
};

export type QuerySparkGetUploadedArgs = {
  input: SparkGetUploadedInput;
};

export type QuerySparkImageMixGetArgs = {
  input: SparkImageMixGetInput;
};

export type QuerySparkImageMixListArgs = {
  input?: InputMaybe<SparkImageMixListInput>;
};

export type QuerySparkInpaintGetArgs = {
  input: SparkInpaintGetInput;
};

export type QuerySparkInpaintListArgs = {
  input?: InputMaybe<SparkInpaintListInput>;
};

export type QuerySparkOutpaintGetArgs = {
  input: SparkOutpaintGetInput;
};

export type QuerySparkOutpaintListArgs = {
  input?: InputMaybe<SparkOutpaintListInput>;
};

export type QuerySparkRemovedBackgroundArgs = {
  input: SparkRemoveBackgroundGetInput;
};

export type QuerySparkRemovedBackgroundListArgs = {
  input?: InputMaybe<SparkRemovedBackgroundListInput>;
};

export type QueryStorageInfoArgs = {
  teamId?: InputMaybe<Scalars['ID']>;
};

export type QueryStudioAllSimpleCommentsArgs = {
  input: StudioAllSimpleCommentsInput;
};

export type QueryStudioCommentReactionsArgs = {
  input: StudioCommentReactionsInput;
};

export type QueryStudioProjectDownloadAssetsArgs = {
  input: StudioProjectDownloadAssetsInput;
};

export type QueryStudioProjectsFolderGetArgs = {
  input: StudioProjectsFolderGetInput;
};

export type QueryStudioProjectsGetProjectArgs = {
  projectId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type QueryStudioProjectsGetProjectCommentsArgs = {
  input: StudioProjectsGetProjectCommentsInput;
};

export type QueryStudioProjectsGetTeamArgs = {
  input: StudioProjectsGetTeamInput;
};

export type QueryStudioProjectsListItemsInTrashArgs = {
  input: StudioProjectsListItemsInTrashInput;
};

export type QueryStudioProjectsListMostRecentArgs = {
  input: StudioProjectsListMostRecentInput;
};

export type QueryStudioProjectsListProjectsArgs = {
  input: StudioProjectsListProjectsInput;
};

export type QueryStudioProjectsListProjectsInTrashArgs = {
  input: StudioProjectsListProjectsInTrashInput;
};

export type QueryStudioProjectsListProjectsSharedWithMeArgs = {
  input: StudioProjectsListProjectsSharedWithMeInput;
};

export type QueryStudioSimpleCommentTaggableUsersArgs = {
  input: StudioSimpleCommentTaggableUsersInput;
};

export type QueryStudioSimpleCommentsArgs = {
  input: StudioSimpleCommentsInput;
};

export type QueryStudioTemplatesListArgs = {
  input: StudioTemplatesListInput;
};

export type QueryStudioUploadsGetFolderArgs = {
  input: StudioUploadsGetFolderInput;
};

export type QueryStudioUploadsGetTagsForUploadsArgs = {
  input: StudioUploadsGetTagsForUploadsInput;
};

export type QueryStudioUploadsSearchFilesArgs = {
  input?: InputMaybe<StudioUploadsSearchFilesInput>;
};

export type QueryStudioUploadsTagsArgs = {
  input?: InputMaybe<StudioUploadsTagsInput>;
};

export type QueryTagsGetProductTagsArgs = {
  input: GetProductTagsInput;
};

export type QueryTeamsFetchOutstandingInvoiceUrlArgs = {
  input: TeamsFetchOutstandingInvoiceUrlInput;
};

export type QueryTeamsFetchUpcomingInvoiceUrlArgs = {
  input: TeamsFetchUpcomingInvoiceUrlInput;
};

export type QueryTeamsGetArgs = {
  input: TeamsGetTeamInput;
};

export type QueryTeamsPreviewUpcomingChargesArgs = {
  input: TeamsPreviewUpcomingChargesInput;
};

export type QueryTransfersGetTransferArgs = {
  input: TransfersGetTransferInput;
};

export type QueryTransfersListTransfersArgs = {
  input: ListTransfersInput;
};

export type QueryUploadedFontsSearchArgs = {
  input?: InputMaybe<UploadedFontsSearchInput>;
};

export type QueryUpscalerImageArgs = {
  input: UpscalerGetImageInput;
};

export type QueryUpscalerImagesArgs = {
  input: UpscalerImagesInput;
};

export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type QueryUserFollowersArgs = {
  input?: InputMaybe<UserFollowersInput>;
};

export type QueryUserFollowersCountArgs = {
  input?: InputMaybe<UserFollowersCountInput>;
};

export type QueryUserFollowingArgs = {
  input?: InputMaybe<UserFollowersInput>;
};

export type QueryUserGetCreditArgs = {
  type?: InputMaybe<UserCreditTypes>;
};

export type QueryUserListLegacyAndContentFavoriteProductsArgs = {
  input: UsersListFavoriteProductsInput;
};

export type QueryUsersCheckFollowingArgs = {
  input: UserCheckFollowingInput;
};

export type QueryVectorizerGetImageArgs = {
  input: VectorizerGetImageInput;
};

export type QueryVectorizerListImagesV2Args = {
  input: VectorizerListImagesInput;
};

export type Question = {
  __typename?: 'Question';
  answers?: EntireFieldWrapper<Maybe<Array<Answer>>>;
  assets?: EntireFieldWrapper<Maybe<Array<AskCfAsset>>>;
  context?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  isFollowed: EntireFieldWrapper<Scalars['Boolean']>;
  question: EntireFieldWrapper<Scalars['String']>;
  questionSlug: EntireFieldWrapper<Scalars['String']>;
  topic: EntireFieldWrapper<Scalars['String']>;
  topicClassifierTimeout: EntireFieldWrapper<Scalars['Boolean']>;
  topicSlug: EntireFieldWrapper<Scalars['String']>;
  totalAnswers: EntireFieldWrapper<Scalars['Int']>;
  user: EntireFieldWrapper<PublicUserProfile>;
  /** @deprecated Use user field instead */
  userId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
};

export type RedeemCode = {
  __typename?: 'RedeemCode';
  code: EntireFieldWrapper<Scalars['String']>;
  createdAt: EntireFieldWrapper<Scalars['Time']>;
  provider: EntireFieldWrapper<RedeemProvider>;
};

export type RedeemInput = {
  code: Scalars['String'];
  provider: RedeemProvider;
};

export type RedeemProvider = 'KREADOE';

export type RedeemReward = {
  __typename?: 'RedeemReward';
  downloadLinks: EntireFieldWrapper<Array<RedeemRewardItem>>;
};

export type RedeemRewardItem = {
  __typename?: 'RedeemRewardItem';
  downloadUrl: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<Scalars['String']>;
};

export type RefreshTokenResponse = {
  __typename?: 'RefreshTokenResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type RegisterInput = {
  deviceId: Scalars['String'];
  email: Scalars['String'];
  otp?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  signIn?: InputMaybe<Scalars['Boolean']>;
  terms: Scalars['Boolean'];
};

export type RegisterResponse = {
  __typename?: 'RegisterResponse';
  challenge?: EntireFieldWrapper<Maybe<AuthChallenge>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  user?: EntireFieldWrapper<Maybe<User>>;
};

export type RemoveBackgroundPublishImageInput = {
  id: Scalars['String'];
};

export type RemoveBackgroundPublishImageResponse = {
  __typename?: 'RemoveBackgroundPublishImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  upload?: EntireFieldWrapper<Maybe<StudioUploadsFile>>;
};

export type ResetPasswordInput = {
  email: Scalars['String'];
  key: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type ReviewAspect = {
  __typename?: 'ReviewAspect';
  feedback: EntireFieldWrapper<Scalars['String']>;
  rating: EntireFieldWrapper<Scalars['Int']>;
};

export type Role = 'Admin' | 'Editor' | 'NoAccess' | 'Owner' | 'Unknown' | 'Viewer';

export type RoleChangeStatus = 'AwaitingAdminApproval' | 'Updated';

export type SearchPromptResponse = {
  __typename?: 'SearchPromptResponse';
  flowID: EntireFieldWrapper<Scalars['String']>;
  iterationID: EntireFieldWrapper<Scalars['String']>;
  prompt: EntireFieldWrapper<Scalars['String']>;
  publishTime: EntireFieldWrapper<Scalars['DateTime']>;
  userID: EntireFieldWrapper<Scalars['String']>;
};

export type SearchPromptsInput = {
  limit: Scalars['Int'];
  sort?: InputMaybe<SearchPromptsSort>;
  text: Scalars['String'];
};

export type SearchPromptsResponse = {
  __typename?: 'SearchPromptsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  prompts?: EntireFieldWrapper<Maybe<Array<SearchPromptResponse>>>;
};

export type SearchPromptsSort = {
  direction: SortDirection;
  field: SearchPromptsSortField;
};

export type SearchPromptsSortField = 'createTime' | 'reactions';

export type SharedProjectsPagination = {
  __typename?: 'SharedProjectsPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  limit: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type SiteBannerCountdown = {
  __typename?: 'SiteBannerCountdown';
  text: EntireFieldWrapper<Scalars['String']>;
  value: EntireFieldWrapper<Scalars['String']>;
};

export type SiteBannerType =
  | 'all_access'
  | 'all_access_yearly'
  | 'all_access_yearly_extend'
  | 'all_access_yearly_trial'
  | 'awaiting_renewal_confirmation'
  | 'cf_pending_cancel'
  | 'classes'
  | 'notification'
  | 'on_hold_subscription'
  | 'pending_cancel'
  | 'spark_free_trial'
  | 'upsell'
  | 'verification';

export type SiteCountdown = {
  __typename?: 'SiteCountdown';
  text: EntireFieldWrapper<Scalars['String']>;
  value: EntireFieldWrapper<Scalars['String']>;
};

export type SiteCurrencies = {
  __typename?: 'SiteCurrencies';
  activeCurrency: EntireFieldWrapper<Currency>;
  currencies: EntireFieldWrapper<Array<Currency>>;
};

export type SiteData = {
  __typename?: 'SiteData';
  allAccessBanner?: EntireFieldWrapper<Maybe<AllAccessBanner>>;
  allAccessYearlyBanner?: EntireFieldWrapper<Maybe<AllAccessYearlyBanner>>;
  allAccessYearlyExtendBanner?: EntireFieldWrapper<Maybe<AllAccessYearlyExtendBanner>>;
  allAccessYearlyTrialBanner?: EntireFieldWrapper<Maybe<AllAccessYearlyTrialBanner>>;
  awaitingRenewalConfirmationBanner?: EntireFieldWrapper<Maybe<AwaitingRenewalConfirmationBanner>>;
  billing: EntireFieldWrapper<Scalars['Boolean']>;
  classesBanner?: EntireFieldWrapper<Maybe<ClassesBanner>>;
  currencies: EntireFieldWrapper<SiteCurrencies>;
  newsletterPopup?: EntireFieldWrapper<Maybe<NewsletterPopup>>;
  notificationBanner?: EntireFieldWrapper<Maybe<NotificationBanner>>;
  notificationPopup?: EntireFieldWrapper<Maybe<NotificationPopup>>;
  onHoldSubscriptionBanner?: EntireFieldWrapper<Maybe<OnHoldSubscriptionBanner>>;
  productCounts: EntireFieldWrapper<ProductCounts>;
  profileNudgePopup?: EntireFieldWrapper<Maybe<ProfileNudgePopup>>;
  promo: EntireFieldWrapper<SitePromotions>;
  sparkFreeTrialBanner?: EntireFieldWrapper<Maybe<SparkFreeTrialBanner>>;
  undoCancelationBanner?: EntireFieldWrapper<Maybe<UndoCancelationBanner>>;
  upsellBanner?: EntireFieldWrapper<Maybe<UpsellBanner>>;
  verificationBanner?: EntireFieldWrapper<Maybe<VerificationBanner>>;
};

export type SitePopupType = 'newsletter' | 'profile_nudge' | 'sitewide_popup';

export type SitePromotion = {
  __typename?: 'SitePromotion';
  discount: EntireFieldWrapper<Scalars['Float']>;
  name: EntireFieldWrapper<Scalars['String']>;
};

export type SitePromotions = {
  __typename?: 'SitePromotions';
  promotion?: EntireFieldWrapper<Maybe<SitePromotion>>;
  takeover?: EntireFieldWrapper<Maybe<SiteTakeover>>;
};

export type SiteTakeover = {
  __typename?: 'SiteTakeover';
  aboveNavBannerBtnColor: EntireFieldWrapper<Scalars['String']>;
  aboveNavBannerBtnTextColor: EntireFieldWrapper<Scalars['String']>;
  aboveNavBannerColor: EntireFieldWrapper<Scalars['String']>;
  aboveNavBannerImg: EntireFieldWrapper<Scalars['String']>;
  homepageFourButtonsColor: EntireFieldWrapper<Scalars['String']>;
  homepageFourButtonsTextColor: EntireFieldWrapper<Scalars['String']>;
  homepageHeroBtnColor: EntireFieldWrapper<Scalars['String']>;
  homepageHeroBtnText: EntireFieldWrapper<Scalars['String']>;
  homepageHeroBtnTextColor: EntireFieldWrapper<Scalars['String']>;
  homepageHeroBtnUrl: EntireFieldWrapper<Scalars['String']>;
  homepageHeroImg: EntireFieldWrapper<Scalars['String']>;
  homepageHeroImgLeftImg: EntireFieldWrapper<Scalars['String']>;
  homepageHeroImgRightImg: EntireFieldWrapper<Scalars['String']>;
  homepageHeroImgUrl: EntireFieldWrapper<Scalars['String']>;
  homepageHeroMblImg: EntireFieldWrapper<Scalars['String']>;
  homepageHeroText: EntireFieldWrapper<Scalars['String']>;
  homepageHeroTextColor: EntireFieldWrapper<Scalars['String']>;
  isActive: EntireFieldWrapper<Scalars['Boolean']>;
  navMenuItemColor: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  websiteLogoImg: EntireFieldWrapper<Scalars['String']>;
};

export type Snippet = {
  __typename?: 'Snippet';
  id: EntireFieldWrapper<Scalars['ID']>;
  name: EntireFieldWrapper<Scalars['String']>;
  snippet: EntireFieldWrapper<Scalars['String']>;
  snippetUrl: EntireFieldWrapper<Scalars['String']>;
};

export type SnippetView = 'logged_users_only' | 'public' | 'unspecified';

export type SnippetsCreateSnippetInput = {
  name: Scalars['String'];
  snippet: Scalars['String'];
};

export type SnippetsCreateSnippetResponse = {
  __typename?: 'SnippetsCreateSnippetResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  snippet?: EntireFieldWrapper<Maybe<Snippet>>;
};

export type SnippetsDeleteSnippetInput = {
  id: Scalars['ID'];
};

export type SnippetsDeleteSnippetResponse = {
  __typename?: 'SnippetsDeleteSnippetResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  snippet?: EntireFieldWrapper<Maybe<Snippet>>;
};

export type SnippetsGetSnippetInput = {
  id: Scalars['ID'];
};

export type SnippetsGetSnippetResponse = {
  __typename?: 'SnippetsGetSnippetResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  snippet?: EntireFieldWrapper<Maybe<Snippet>>;
};

export type SnippetsListPagination = {
  __typename?: 'SnippetsListPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type SnippetsListSnippetInput = {
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
};

export type SnippetsListSnippetResponse = {
  __typename?: 'SnippetsListSnippetResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination: EntireFieldWrapper<SnippetsListPagination>;
  snippets?: EntireFieldWrapper<Maybe<Array<Snippet>>>;
};

export type SnippetsUpdateSnippetInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  snippet?: InputMaybe<Scalars['String']>;
};

export type SnippetsUpdateSnippetResponse = {
  __typename?: 'SnippetsUpdateSnippetResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  snippet?: EntireFieldWrapper<Maybe<Snippet>>;
};

export type SocialAsset = {
  __typename?: 'SocialAsset';
  id: EntireFieldWrapper<Scalars['ID']>;
  optimizedUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type: EntireFieldWrapper<SocialAssetType>;
  url: EntireFieldWrapper<Scalars['String']>;
};

export type SocialAssetInput = {
  type: SocialAssetType;
  url: Scalars['String'];
};

export type SocialAssetType = 'image' | 'video';

export type SocialBlockUserInput = {
  reason: Scalars['String'];
  userId: Scalars['String'];
};

export type SocialBlockUserListInput = {
  itemsPerPage: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};

export type SocialBlockUserListResponse = {
  __typename?: 'SocialBlockUserListResponse';
  UserBlockList?: EntireFieldWrapper<Maybe<Array<UserBlock>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<SocialPagination>>;
};

export type SocialBlockUserResponse = {
  __typename?: 'SocialBlockUserResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialComment = {
  __typename?: 'SocialComment';
  assets?: EntireFieldWrapper<Maybe<Array<SocialAsset>>>;
  childComments?: EntireFieldWrapper<Maybe<Array<SocialComment>>>;
  commentsCount: EntireFieldWrapper<Scalars['Int']>;
  content: EntireFieldWrapper<Scalars['String']>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  isLiked: EntireFieldWrapper<Scalars['Boolean']>;
  likesCount: EntireFieldWrapper<Scalars['Int']>;
  user: EntireFieldWrapper<PublicUserProfile>;
};

export type SocialCommentDeleteInput = {
  commentId: Scalars['ID'];
};

export type SocialCommentDeleteResponse = {
  __typename?: 'SocialCommentDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialCommentLikeInput = {
  CommentId: Scalars['ID'];
};

export type SocialCommentLikeRemoveInput = {
  CommentId: Scalars['ID'];
};

export type SocialCommentLikeRemoveResponse = {
  __typename?: 'SocialCommentLikeRemoveResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialCommentLikeResponse = {
  __typename?: 'SocialCommentLikeResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialCommentListPagination = {
  __typename?: 'SocialCommentListPagination';
  hasNextPage: EntireFieldWrapper<Scalars['Boolean']>;
  nextPageCursor: EntireFieldWrapper<Scalars['DateTime']>;
};

export type SocialCommentsListInput = {
  cursor?: InputMaybe<Scalars['DateTime']>;
  itemsPerPage: Scalars['Int'];
  parentCommentID?: InputMaybe<Scalars['ID']>;
  postID: Scalars['ID'];
};

export type SocialCommentsListResponse = {
  __typename?: 'SocialCommentsListResponse';
  comments?: EntireFieldWrapper<Maybe<Array<SocialComment>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<SocialCommentListPagination>>;
};

export type SocialCreateCommentInput = {
  assets?: InputMaybe<Array<SocialAssetInput>>;
  commentParentId?: InputMaybe<Scalars['ID']>;
  content: Scalars['String'];
  postId: Scalars['ID'];
};

export type SocialCreateCommentResponse = {
  __typename?: 'SocialCreateCommentResponse';
  comment?: EntireFieldWrapper<Maybe<SocialComment>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialDiscoveryFeedInput = {
  cursor?: InputMaybe<Scalars['Int']>;
  itemsPerPage: Scalars['Int'];
};

export type SocialFeedPagination = {
  __typename?: 'SocialFeedPagination';
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  nextPageCursor?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type SocialFeedResponse = {
  __typename?: 'SocialFeedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<SocialFeedPagination>>;
  posts?: EntireFieldWrapper<Maybe<Array<Post>>>;
};

export type SocialFollowersFeedInput = {
  cursor?: InputMaybe<Scalars['Int']>;
  itemsPerPage: Scalars['Int'];
};

export type SocialGetPostInput = {
  postId?: InputMaybe<Scalars['ID']>;
  postSlug?: InputMaybe<Scalars['String']>;
};

export type SocialGetUploadedInput = {
  assetId: Scalars['String'];
};

export type SocialGetUploadedResponse = {
  __typename?: 'SocialGetUploadedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  imageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type SocialGiveTipToPostInput = {
  postId?: InputMaybe<Scalars['Int']>;
  postSlug?: InputMaybe<Scalars['String']>;
};

export type SocialGiveTipToPostResponse = {
  __typename?: 'SocialGiveTipToPostResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialListPostByProductInput = {
  cursor?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  productId: Scalars['ID'];
};

export type SocialListPostByProductPagination = {
  __typename?: 'SocialListPostByProductPagination';
  hasNextPage?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  nextPageCursor?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
};

export type SocialListPostByProductResponse = {
  __typename?: 'SocialListPostByProductResponse';
  Pagination: EntireFieldWrapper<SocialListPostByProductPagination>;
  Posts: EntireFieldWrapper<Array<Maybe<Post>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type SocialLoginInput = {
  accessToken: Scalars['String'];
  clientType: ClientType;
  type: AuthType;
};

export type SocialPagination = {
  __typename?: 'SocialPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type SocialPostDeleteFromUserInput = {
  userId: Scalars['ID'];
};

export type SocialPostDeleteFromUserResponse = {
  __typename?: 'SocialPostDeleteFromUserResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialPostDeleteInput = {
  postId: Scalars['ID'];
};

export type SocialPostDeleteResponse = {
  __typename?: 'SocialPostDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialPostInput = {
  assets?: InputMaybe<Array<SocialAssetInput>>;
  content: Scalars['String'];
  instructions?: InputMaybe<Array<Scalars['String']>>;
  level?: InputMaybe<ProjectLevel>;
  machines?: InputMaybe<Array<Scalars['String']>>;
  materials?: InputMaybe<Array<Scalars['String']>>;
  productIds?: InputMaybe<Array<Scalars['String']>>;
};

export type SocialPostLikeInput = {
  postId: Scalars['Int'];
};

export type SocialPostLikeRemoveInput = {
  postId: Scalars['Int'];
};

export type SocialPostLikeRemoveResponse = {
  __typename?: 'SocialPostLikeRemoveResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialPostLikeResponse = {
  __typename?: 'SocialPostLikeResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialPostResponse = {
  __typename?: 'SocialPostResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  post?: EntireFieldWrapper<Maybe<Post>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialPostSaveInput = {
  postId: Scalars['ID'];
};

export type SocialPostSaveRemoveInput = {
  postId: Scalars['ID'];
};

export type SocialPostSaveRemoveResponse = {
  __typename?: 'SocialPostSaveRemoveResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialPostSaveResponse = {
  __typename?: 'SocialPostSaveResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialProduct = {
  __typename?: 'SocialProduct';
  author: EntireFieldWrapper<PublicUserProfile>;
  category: EntireFieldWrapper<Scalars['String']>;
  categorySlug: EntireFieldWrapper<Scalars['String']>;
  description: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['String']>;
  slug: EntireFieldWrapper<Scalars['String']>;
  thumbnail?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title: EntireFieldWrapper<Scalars['String']>;
};

export type SocialRedirectLoginInput = {
  clientType: ClientType;
  type: AuthType;
};

export type SocialRedirectLoginResponse = {
  __typename?: 'SocialRedirectLoginResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  target_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type SocialSavedFeedInput = {
  cursor?: InputMaybe<Scalars['Int']>;
  itemsPerPage: Scalars['Int'];
};

export type SocialSavedFeedResponse = {
  __typename?: 'SocialSavedFeedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination: EntireFieldWrapper<SocialFeedPagination>;
  posts?: EntireFieldWrapper<Maybe<Array<Post>>>;
  totalSavedPosts: EntireFieldWrapper<Scalars['Int']>;
};

export type SocialUnblockUserInput = {
  userId: Scalars['String'];
};

export type SocialUnblockUserResponse = {
  __typename?: 'SocialUnblockUserResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SocialUploadCreateSignedUrlInput = {
  uploadFile: Scalars['String'];
};

export type SocialUploadCreateSignedUrlResponse = {
  __typename?: 'SocialUploadCreateSignedUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['String']>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type SocialUserFeedInput = {
  cursor?: InputMaybe<Scalars['Int']>;
  itemsPerPage: Scalars['Int'];
  userId?: InputMaybe<Scalars['ID']>;
  userSlug?: InputMaybe<Scalars['String']>;
};

export type SortDirection = 'asc' | 'desc';

export type SortOrder = 'asc' | 'desc';

export type SparkArt = {
  __typename?: 'SparkArt';
  id: EntireFieldWrapper<Scalars['ID']>;
  images: EntireFieldWrapper<Array<SparkArtImage>>;
  prompt: EntireFieldWrapper<Scalars['String']>;
};

export type SparkArtAspectRatio = 'landscape_4_3' | 'landscape_16_9' | 'portrait_3_4' | 'portrait_9_16' | 'square';

export type SparkArtDeleteInput = {
  id: Scalars['String'];
};

export type SparkArtDeleteResponse = {
  __typename?: 'SparkArtDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SparkArtGenerateInput = {
  aspectRatio?: InputMaybe<SparkArtAspectRatio>;
  prompt: Scalars['String'];
};

export type SparkArtGenerateResponse = {
  __typename?: 'SparkArtGenerateResponse';
  art?: EntireFieldWrapper<Maybe<SparkArt>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type SparkArtGetInput = {
  id: Scalars['String'];
};

export type SparkArtGetResponse = {
  __typename?: 'SparkArtGetResponse';
  art?: EntireFieldWrapper<Maybe<SparkArt>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type SparkArtImage = {
  __typename?: 'SparkArtImage';
  id: EntireFieldWrapper<Scalars['ID']>;
  originalUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  state: EntireFieldWrapper<SparkState>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type SparkArtListInput = {
  currentPage?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type SparkArtListPagination = {
  __typename?: 'SparkArtListPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type SparkArtListResponse = {
  __typename?: 'SparkArtListResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  list?: EntireFieldWrapper<Maybe<Array<SparkArt>>>;
  pagination?: EntireFieldWrapper<Maybe<SparkArtListPagination>>;
};

export type SparkArtRegisterInput = {
  ids: Array<Scalars['String']>;
};

export type SparkBackgroundRemovedRegisterInput = {
  ids: Array<Scalars['String']>;
};

export type SparkCrystalline = {
  __typename?: 'SparkCrystalline';
  id: EntireFieldWrapper<Scalars['ID']>;
  images: EntireFieldWrapper<Array<SparkCrystallineImage>>;
  prompt: EntireFieldWrapper<Scalars['String']>;
};

export type SparkCrystallineDeleteInput = {
  id: Scalars['String'];
};

export type SparkCrystallineDeleteResponse = {
  __typename?: 'SparkCrystallineDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SparkCrystallineGenerateInput = {
  prompt: Scalars['String'];
};

export type SparkCrystallineGenerateResponse = {
  __typename?: 'SparkCrystallineGenerateResponse';
  crystalline?: EntireFieldWrapper<Maybe<SparkCrystalline>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type SparkCrystallineGetInput = {
  id: Scalars['String'];
};

export type SparkCrystallineGetResponse = {
  __typename?: 'SparkCrystallineGetResponse';
  crystalline?: EntireFieldWrapper<Maybe<SparkCrystalline>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type SparkCrystallineImage = {
  __typename?: 'SparkCrystallineImage';
  id: EntireFieldWrapper<Scalars['ID']>;
  originalUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  state: EntireFieldWrapper<SparkState>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type SparkCrystallineListInput = {
  currentPage?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type SparkCrystallineListPagination = {
  __typename?: 'SparkCrystallineListPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type SparkCrystallineListResponse = {
  __typename?: 'SparkCrystallineListResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  list?: EntireFieldWrapper<Maybe<Array<SparkCrystalline>>>;
  pagination?: EntireFieldWrapper<Maybe<SparkCrystallineListPagination>>;
};

export type SparkCrystallineRegisterInput = {
  ids: Array<Scalars['String']>;
};

export type SparkFreeTrialBanner = {
  __typename?: 'SparkFreeTrialBanner';
  aboveButtonText: EntireFieldWrapper<Scalars['String']>;
  backgroundImage: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNav: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNavState: EntireFieldWrapper<Scalars['String']>;
  bannerIsMinimized: EntireFieldWrapper<Scalars['Boolean']>;
  belowButtonText: EntireFieldWrapper<Scalars['String']>;
  buttonText: EntireFieldWrapper<Scalars['String']>;
  buttonUrl: EntireFieldWrapper<Scalars['String']>;
  subtext: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SiteBannerType>;
};

export type SparkGetUploadedInput = {
  uploadId: Scalars['String'];
};

export type SparkGetUploadedResponse = {
  __typename?: 'SparkGetUploadedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  imageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type SparkImageMix = {
  __typename?: 'SparkImageMix';
  id: EntireFieldWrapper<Scalars['ID']>;
  imageUrl: EntireFieldWrapper<Scalars['String']>;
  images: EntireFieldWrapper<Array<SparkImageMixVersion>>;
  prompt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  strength: EntireFieldWrapper<Scalars['Float']>;
  userId: EntireFieldWrapper<Scalars['ID']>;
};

export type SparkImageMixDeleteAllResponse = {
  __typename?: 'SparkImageMixDeleteAllResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SparkImageMixDeleteInput = {
  id: Scalars['ID'];
};

export type SparkImageMixDeleteResponse = {
  __typename?: 'SparkImageMixDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SparkImageMixGenerateInput = {
  imageUrl: Scalars['String'];
  prompt?: InputMaybe<Scalars['String']>;
  strength: Scalars['Float'];
};

export type SparkImageMixGenerateResponse = {
  __typename?: 'SparkImageMixGenerateResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  imageMix: EntireFieldWrapper<SparkImageMix>;
};

export type SparkImageMixGetInput = {
  id: Scalars['ID'];
};

export type SparkImageMixGetResponse = {
  __typename?: 'SparkImageMixGetResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  imageMix?: EntireFieldWrapper<Maybe<SparkImageMix>>;
};

export type SparkImageMixListInput = {
  currentPage?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type SparkImageMixListPagination = {
  __typename?: 'SparkImageMixListPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type SparkImageMixListResponse = {
  __typename?: 'SparkImageMixListResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  list?: EntireFieldWrapper<Maybe<Array<SparkImageMix>>>;
  pagination?: EntireFieldWrapper<Maybe<SparkImageMixListPagination>>;
};

export type SparkImageMixRegisterInput = {
  ids: Array<Scalars['String']>;
};

export type SparkImageMixVersion = {
  __typename?: 'SparkImageMixVersion';
  id: EntireFieldWrapper<Scalars['ID']>;
  originalUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  state: EntireFieldWrapper<SparkState>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type SparkInpaint = {
  __typename?: 'SparkInpaint';
  id: EntireFieldWrapper<Scalars['ID']>;
  imageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  prompt: EntireFieldWrapper<Scalars['String']>;
  srcImageUrl: EntireFieldWrapper<Scalars['String']>;
  srcInpaintAreaImageUrl: EntireFieldWrapper<Scalars['String']>;
  srcThumbnailUrl: EntireFieldWrapper<Scalars['String']>;
  state: EntireFieldWrapper<SparkState>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  userId: EntireFieldWrapper<Scalars['ID']>;
};

export type SparkInpaintDeleteAllResponse = {
  __typename?: 'SparkInpaintDeleteAllResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SparkInpaintDeleteInput = {
  id: Scalars['ID'];
};

export type SparkInpaintDeleteResponse = {
  __typename?: 'SparkInpaintDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SparkInpaintGetInput = {
  id: Scalars['ID'];
};

export type SparkInpaintGetResponse = {
  __typename?: 'SparkInpaintGetResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  inpaint?: EntireFieldWrapper<Maybe<SparkInpaint>>;
};

export type SparkInpaintImageInput = {
  imageUrl: Scalars['String'];
  inpaintAreaImageUrl: Scalars['String'];
  prompt: Scalars['String'];
};

export type SparkInpaintImageResponse = {
  __typename?: 'SparkInpaintImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  inpaint?: EntireFieldWrapper<Maybe<SparkInpaint>>;
};

export type SparkInpaintListInput = {
  currentPage?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type SparkInpaintListPagination = {
  __typename?: 'SparkInpaintListPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type SparkInpaintListResponse = {
  __typename?: 'SparkInpaintListResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  list?: EntireFieldWrapper<Maybe<Array<SparkInpaint>>>;
  pagination: EntireFieldWrapper<SparkInpaintListPagination>;
};

export type SparkInpaintRegisterInput = {
  ids: Array<Scalars['String']>;
};

export type SparkOutpaint = {
  __typename?: 'SparkOutpaint';
  id: EntireFieldWrapper<Scalars['ID']>;
  imageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  increaseDown: EntireFieldWrapper<Scalars['Int']>;
  increaseLeft: EntireFieldWrapper<Scalars['Int']>;
  increaseRight: EntireFieldWrapper<Scalars['Int']>;
  increaseUp: EntireFieldWrapper<Scalars['Int']>;
  prompt: EntireFieldWrapper<Scalars['String']>;
  srcImageUrl: EntireFieldWrapper<Scalars['String']>;
  srcThumbnailUrl: EntireFieldWrapper<Scalars['String']>;
  state: EntireFieldWrapper<SparkState>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  userId: EntireFieldWrapper<Scalars['ID']>;
};

export type SparkOutpaintDeleteAllResponse = {
  __typename?: 'SparkOutpaintDeleteAllResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SparkOutpaintDeleteInput = {
  id: Scalars['ID'];
};

export type SparkOutpaintDeleteResponse = {
  __typename?: 'SparkOutpaintDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SparkOutpaintGetInput = {
  id: Scalars['ID'];
};

export type SparkOutpaintGetResponse = {
  __typename?: 'SparkOutpaintGetResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  outpaint?: EntireFieldWrapper<Maybe<SparkOutpaint>>;
};

export type SparkOutpaintImageInput = {
  imageUrl: Scalars['String'];
  increaseDown: Scalars['Int'];
  increaseLeft: Scalars['Int'];
  increaseRight: Scalars['Int'];
  increaseUp: Scalars['Int'];
  prompt: Scalars['String'];
};

export type SparkOutpaintImageResponse = {
  __typename?: 'SparkOutpaintImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  outpaint?: EntireFieldWrapper<Maybe<SparkOutpaint>>;
};

export type SparkOutpaintListInput = {
  currentPage?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type SparkOutpaintListPagination = {
  __typename?: 'SparkOutpaintListPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type SparkOutpaintListResponse = {
  __typename?: 'SparkOutpaintListResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  list?: EntireFieldWrapper<Maybe<Array<SparkOutpaint>>>;
  pagination: EntireFieldWrapper<SparkOutpaintListPagination>;
};

export type SparkOutpaintRegisterInput = {
  ids: Array<Scalars['String']>;
};

export type SparkRegisterArtResponse = {
  __typename?: 'SparkRegisterArtResponse';
  arts?: EntireFieldWrapper<Maybe<Array<SparkArt>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type SparkRegisterBackgroundRemovedResponse = {
  __typename?: 'SparkRegisterBackgroundRemovedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  removedBackgrounds?: EntireFieldWrapper<Maybe<Array<SparkRemoveBackgroundImage>>>;
};

export type SparkRegisterCrystallineResponse = {
  __typename?: 'SparkRegisterCrystallineResponse';
  crystallines?: EntireFieldWrapper<Maybe<Array<SparkCrystalline>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type SparkRegisterImageMixResponse = {
  __typename?: 'SparkRegisterImageMixResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  imagemix?: EntireFieldWrapper<Maybe<Array<SparkImageMix>>>;
};

export type SparkRegisterInpaintResponse = {
  __typename?: 'SparkRegisterInpaintResponse';
  Inpaints?: EntireFieldWrapper<Maybe<Array<SparkInpaint>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type SparkRegisterOutpaintResponse = {
  __typename?: 'SparkRegisterOutpaintResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  outpaints?: EntireFieldWrapper<Maybe<Array<SparkOutpaint>>>;
};

export type SparkRemoveBackgroundGetInput = {
  id: Scalars['String'];
};

export type SparkRemoveBackgroundGetResponse = {
  __typename?: 'SparkRemoveBackgroundGetResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  removedBackground?: EntireFieldWrapper<Maybe<SparkRemoveBackgroundImage>>;
};

export type SparkRemoveBackgroundImage = {
  __typename?: 'SparkRemoveBackgroundImage';
  generatedImagelUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  generatedThumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  sourceImageUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  sourceThumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  state: EntireFieldWrapper<SparkState>;
};

export type SparkRemoveBackgroundInput = {
  imageUrl: Scalars['String'];
};

export type SparkRemoveBackgroundResponse = {
  __typename?: 'SparkRemoveBackgroundResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  removedBackground?: EntireFieldWrapper<Maybe<SparkRemoveBackgroundImage>>;
};

export type SparkRemovedBackgroundCancelInput = {
  id: Scalars['String'];
};

export type SparkRemovedBackgroundCancelResponse = {
  __typename?: 'SparkRemovedBackgroundCancelResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SparkRemovedBackgroundDeleteAllResponse = {
  __typename?: 'SparkRemovedBackgroundDeleteAllResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SparkRemovedBackgroundDeleteInput = {
  id: Scalars['ID'];
};

export type SparkRemovedBackgroundDeleteResponse = {
  __typename?: 'SparkRemovedBackgroundDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SparkRemovedBackgroundListInput = {
  currentPage?: InputMaybe<Scalars['Int']>;
  itemsPerPage?: InputMaybe<Scalars['Int']>;
};

export type SparkRemovedBackgroundListPagination = {
  __typename?: 'SparkRemovedBackgroundListPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type SparkRemovedBackgroundListResponse = {
  __typename?: 'SparkRemovedBackgroundListResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  list?: EntireFieldWrapper<Maybe<Array<SparkRemoveBackgroundImage>>>;
  pagination?: EntireFieldWrapper<Maybe<SparkRemovedBackgroundListPagination>>;
};

export type SparkRemovedBackgroundUploadsCreateSignedUrlInput = {
  uploadFile: Scalars['String'];
};

export type SparkRemovedBackgroundUploadsCreateSignedUrlResponse = {
  __typename?: 'SparkRemovedBackgroundUploadsCreateSignedUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['String']>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type SparkState = 'cancelled' | 'failed' | 'generated' | 'requested' | 'uploadPending';

export type SparkUploadsCreateSignedUrlInput = {
  uploadFile: Scalars['String'];
};

export type SparkUploadsCreateSignedUrlResponse = {
  __typename?: 'SparkUploadsCreateSignedUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['String']>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type StatisticsRecordStudioEventInput = {
  eventType: StudioEventType;
};

export type StatisticsRecordStudioEventResponse = {
  __typename?: 'StatisticsRecordStudioEventResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StatusMessage = {
  __typename?: 'StatusMessage';
  message: EntireFieldWrapper<Scalars['String']>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StatusType = 'cancelled' | 'completed' | 'deleted' | 'failed' | 'pending' | 'unknown';

export type StorageEnableOveragesInput = {
  enableOverages: Scalars['Boolean'];
  teamId: Scalars['String'];
};

export type StorageEnableOveragesResponse = {
  __typename?: 'StorageEnableOveragesResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  storage?: EntireFieldWrapper<Maybe<StorageInfo>>;
};

export type StorageInfo = {
  __typename?: 'StorageInfo';
  available: EntireFieldWrapper<StorageSize>;
  blocks?: EntireFieldWrapper<Maybe<BlocksRange>>;
  enableOverages: EntireFieldWrapper<Scalars['Boolean']>;
  maxFileSizeAllowed?: EntireFieldWrapper<Maybe<StorageSize>>;
  total: EntireFieldWrapper<StorageSize>;
  used: EntireFieldWrapper<StorageSize>;
};

export type StorageInfoResponse = {
  __typename?: 'StorageInfoResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  storage?: EntireFieldWrapper<Maybe<StorageInfo>>;
};

export type StorageSize = {
  __typename?: 'StorageSize';
  bytes: EntireFieldWrapper<Scalars['Int']>;
  humanized: EntireFieldWrapper<Scalars['String']>;
};

export type StorageUpdateSizeInput = {
  blocks: Scalars['Int'];
  teamId: Scalars['String'];
};

export type StorageUpdateSizeResponse = {
  __typename?: 'StorageUpdateSizeResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  storage?: EntireFieldWrapper<Maybe<StorageInfo>>;
};

export type StoreUserSearchInput = {
  searchTerm: Scalars['String'];
};

export type StripeSubscriptionExtensionInfo = {
  __typename?: 'StripeSubscriptionExtensionInfo';
  inProgress: EntireFieldWrapper<Scalars['Boolean']>;
  nextPaymentDate?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  payInvoiceUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  paymentStatus?: EntireFieldWrapper<Maybe<PaymentStatus>>;
  stripeSubscriptionId?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type StudioAllSimpleCommentsInput = {
  afterId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<StudioSocialEntityType>;
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<StudioSimpleCommentType>;
};

export type StudioCommentReactDeleteResponse = {
  __typename?: 'StudioCommentReactDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioCommentReactInput = {
  commentId: Scalars['ID'];
  reaction: StudioCommentReactionType;
};

export type StudioCommentReactResponse = {
  __typename?: 'StudioCommentReactResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  reaction?: EntireFieldWrapper<Maybe<StudioCommentReaction>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioCommentReaction = {
  __typename?: 'StudioCommentReaction';
  commentId: EntireFieldWrapper<Scalars['ID']>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  deleteTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  reaction: EntireFieldWrapper<StudioCommentReactionType>;
  user: EntireFieldWrapper<PublicUserProfile>;
};

export type StudioCommentReactionType = 'Like' | 'Unspecified';

export type StudioCommentReactionsInput = {
  afterId?: InputMaybe<Scalars['ID']>;
  commentId: Scalars['ID'];
  reactionType?: InputMaybe<StudioCommentReactionType>;
  take?: InputMaybe<Scalars['Int']>;
};

export type StudioCommentReactionsResponse = {
  __typename?: 'StudioCommentReactionsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasMore?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  reactions?: EntireFieldWrapper<Maybe<Array<StudioCommentReaction>>>;
};

export type StudioEventType = 'appOnboarding' | 'userLogin';

export type StudioFolderType = 'backgroundRemover' | 'unspecified' | 'user' | 'vectorizer';

export type StudioIsAllAccessUserResponse = {
  __typename?: 'StudioIsAllAccessUserResponse';
  allAccessUser?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type StudioProject = {
  __typename?: 'StudioProject';
  /** @deprecated will be removed soon */
  activeRevision: EntireFieldWrapper<StudioProjectRevision>;
  createTime: EntireFieldWrapper<Scalars['String']>;
  deleteTime: EntireFieldWrapper<Scalars['String']>;
  folderId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  lastViewTime: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
  owner: EntireFieldWrapper<PublicUserProfile>;
  /** @deprecated use owner instead */
  projectOwner?: EntireFieldWrapper<Maybe<PublicUserProfile>>;
  /** @deprecated not being used */
  restoreTime: EntireFieldWrapper<Scalars['String']>;
  team?: EntireFieldWrapper<Maybe<Team>>;
  templateId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  templateOrigin?: EntireFieldWrapper<Maybe<ProjectTemplateOrigin>>;
  thumbnailUrl: EntireFieldWrapper<Scalars['String']>;
  updateTime: EntireFieldWrapper<Scalars['String']>;
  userPermissions: EntireFieldWrapper<Array<UserProjectPermission>>;
};

export type StudioProjectComment = {
  __typename?: 'StudioProjectComment';
  id: EntireFieldWrapper<Scalars['ID']>;
  message: EntireFieldWrapper<Scalars['String']>;
  owner: EntireFieldWrapper<Scalars['String']>;
  parentCommentId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  projectId: EntireFieldWrapper<Scalars['String']>;
  status: EntireFieldWrapper<StudioProjectCommentStatus>;
  timestamp: EntireFieldWrapper<Scalars['String']>;
  tool: EntireFieldWrapper<StudioProjectCommentTool>;
  usersTagged?: EntireFieldWrapper<Maybe<Array<Scalars['String']>>>;
  usersToNotify?: EntireFieldWrapper<Maybe<Array<Scalars['String']>>>;
  xCoordinate: EntireFieldWrapper<Scalars['Int']>;
  yCoordinate: EntireFieldWrapper<Scalars['Int']>;
};

export type StudioProjectCommentStatus = 'done' | 'open' | 'unspecified';

export type StudioProjectCommentTool = 'board' | 'project' | 'unspecified';

export type StudioProjectCreateFolderInput = {
  name: Scalars['String'];
  parentFolderId?: InputMaybe<Scalars['ID']>;
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioProjectCreateFolderResponse = {
  __typename?: 'StudioProjectCreateFolderResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  folder?: EntireFieldWrapper<Maybe<StudioProjectFolder>>;
};

export type StudioProjectDeleteProjectInput = {
  id: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioProjectDeleteProjectResponse = {
  __typename?: 'StudioProjectDeleteProjectResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectDownloadAssetsInput = {
  ids: Array<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioProjectDownloadAssetsResponse = {
  __typename?: 'StudioProjectDownloadAssetsResponse';
  assets: EntireFieldWrapper<Array<AssetDownloadResponse>>;
  errors: EntireFieldWrapper<Array<ErrorMessage>>;
};

export type StudioProjectEmptyTrashInput = {
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioProjectEmptyTrashResponse = {
  __typename?: 'StudioProjectEmptyTrashResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectFolder = {
  __typename?: 'StudioProjectFolder';
  collaborators: EntireFieldWrapper<Array<PublicUserProfile>>;
  createdAt: EntireFieldWrapper<Scalars['DateTime']>;
  deletedAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  folders: EntireFieldWrapper<Array<StudioProjectFolder>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  name: EntireFieldWrapper<Scalars['String']>;
  owner: EntireFieldWrapper<PublicUserProfile>;
  parentFolderId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  projectCount?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  projects: EntireFieldWrapper<Array<StudioProject>>;
  team?: EntireFieldWrapper<Maybe<Team>>;
  /** @deprecated use team instead */
  teamId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  updatedAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  userPermissions: EntireFieldWrapper<Array<UserProjectPermission>>;
};

export type StudioProjectFolderDeleteInput = {
  folderId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioProjectFolderDeleteResponse = {
  __typename?: 'StudioProjectFolderDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectMoveProjectsInput = {
  folderId?: InputMaybe<Scalars['ID']>;
  projectIds: Array<Scalars['ID']>;
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioProjectMoveProjectsResponse = {
  __typename?: 'StudioProjectMoveProjectsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectOptimizeProjectInput = {
  flip?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  ignoreBackground?: InputMaybe<Scalars['Boolean']>;
  returnFileType?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['String']>;
};

export type StudioProjectOptimizeProjectResponse = {
  __typename?: 'StudioProjectOptimizeProjectResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
  url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type StudioProjectRestoreProjectInput = {
  id: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioProjectRestoreProjectResponse = {
  __typename?: 'StudioProjectRestoreProjectResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectRevision = {
  __typename?: 'StudioProjectRevision';
  createTime: EntireFieldWrapper<Scalars['String']>;
  editor: EntireFieldWrapper<ProjectEditor>;
  fileUrl: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  isAutoSave: EntireFieldWrapper<Scalars['Boolean']>;
  projectId: EntireFieldWrapper<Scalars['String']>;
  projectName: EntireFieldWrapper<Scalars['String']>;
  teamId?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  thumbnailLastUpdate?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  thumbnailUrl: EntireFieldWrapper<Scalars['String']>;
  userId?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type StudioProjectSharingLink = {
  __typename?: 'StudioProjectSharingLink';
  defaultAccess: EntireFieldWrapper<StudioProjectSharingLinkAccess>;
  id: EntireFieldWrapper<Scalars['ID']>;
  project: EntireFieldWrapper<StudioProject>;
  url: EntireFieldWrapper<Scalars['String']>;
  usersWithAccess: EntireFieldWrapper<Array<StudioProjectSharingUserAccess>>;
};

export type StudioProjectSharingLinkAccess = 'canEdit' | 'canView' | 'noAccess';

export type StudioProjectSharingUserAccess = {
  __typename?: 'StudioProjectSharingUserAccess';
  access: EntireFieldWrapper<StudioProjectSharingLinkAccess>;
  user: EntireFieldWrapper<User>;
};

export type StudioProjectUpdateFields = 'content' | 'editor' | 'name' | 'templateId' | 'templateOrigin' | 'thumbnail';

export type StudioProjectsAddMemberInput = {
  email: Scalars['String'];
  projectId: Scalars['String'];
  role: Role;
  teamId?: InputMaybe<Scalars['String']>;
};

export type StudioProjectsAddMemberResponse = {
  __typename?: 'StudioProjectsAddMemberResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  status?: EntireFieldWrapper<Maybe<InvitationStatus>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type StudioProjectsAddUserToProjectSharingLinkInput = {
  access: StudioProjectSharingLinkAccess;
  linkId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioProjectsAddUserToProjectSharingLinkResponse = {
  __typename?: 'StudioProjectsAddUserToProjectSharingLinkResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectsApproveInviteInput = {
  invitationCode: Scalars['String'];
  invitationID?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type StudioProjectsApproveInviteResponse = {
  __typename?: 'StudioProjectsApproveInviteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectsApproveProjectMemberUpdateInput = {
  approvalId?: InputMaybe<Scalars['String']>;
  invitationCode: Scalars['String'];
  projectId: Scalars['String'];
};

export type StudioProjectsApproveProjectMemberUpdateResponse = {
  __typename?: 'StudioProjectsApproveProjectMemberUpdateResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type StudioProjectsChangeUserRoleInput = {
  projectId: Scalars['String'];
  role: Role;
  teamId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type StudioProjectsChangeUserRoleResponse = {
  __typename?: 'StudioProjectsChangeUserRoleResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  status?: EntireFieldWrapper<Maybe<RoleChangeStatus>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type StudioProjectsConfirmInviteInput = {
  invitationCode: Scalars['String'];
  inviteId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  teamId?: InputMaybe<Scalars['String']>;
};

export type StudioProjectsConfirmInviteResponse = {
  __typename?: 'StudioProjectsConfirmInviteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectsCreateFromTemplateInput = {
  teamId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
};

export type StudioProjectsCreateFromTemplateResponse = {
  __typename?: 'StudioProjectsCreateFromTemplateResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  project?: EntireFieldWrapper<Maybe<StudioProject>>;
};

export type StudioProjectsCreateProjectCommentInput = {
  message: Scalars['String'];
  parentCommentId?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['String'];
  tool: StudioProjectCommentTool;
  usersTagged?: InputMaybe<Array<Scalars['String']>>;
  usersToNotify?: InputMaybe<Array<Scalars['String']>>;
  xCoordinate: Scalars['Int'];
  yCoordinate: Scalars['Int'];
};

export type StudioProjectsCreateProjectCommentResponse = {
  __typename?: 'StudioProjectsCreateProjectCommentResponse';
  comment?: EntireFieldWrapper<Maybe<StudioProjectComment>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type StudioProjectsCreateProjectInput = {
  autoSave?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  editor?: InputMaybe<ProjectEditor>;
  folderId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['ID']>;
  templateId?: InputMaybe<Scalars['ID']>;
  templateOrigin?: InputMaybe<ProjectTemplateOrigin>;
};

export type StudioProjectsCreateProjectResponse = {
  __typename?: 'StudioProjectsCreateProjectResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  project?: EntireFieldWrapper<Maybe<StudioProject>>;
};

export type StudioProjectsCreateProjectSharingLinkInput = {
  defaultAccess: StudioProjectSharingLinkAccess;
  projectId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioProjectsCreateProjectSharingLinkResponse = {
  __typename?: 'StudioProjectsCreateProjectSharingLinkResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  projectSharingLink?: EntireFieldWrapper<Maybe<StudioProjectSharingLink>>;
};

export type StudioProjectsFolderGetInput = {
  folderId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioProjectsFolderGetResponse = {
  __typename?: 'StudioProjectsFolderGetResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  folder?: EntireFieldWrapper<Maybe<StudioProjectFolder>>;
};

export type StudioProjectsFolderRenameInput = {
  folderId: Scalars['ID'];
  name: Scalars['String'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioProjectsFolderRenameResponse = {
  __typename?: 'StudioProjectsFolderRenameResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectsFolderRestoreInput = {
  folderId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioProjectsFolderRestoreResponse = {
  __typename?: 'StudioProjectsFolderRestoreResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectsGetProjectCommentsInput = {
  projectId: Scalars['String'];
};

export type StudioProjectsGetProjectCommentsResponse = {
  __typename?: 'StudioProjectsGetProjectCommentsResponse';
  comments?: EntireFieldWrapper<Maybe<Array<StudioProjectComment>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type StudioProjectsGetProjectResponse = {
  __typename?: 'StudioProjectsGetProjectResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  project?: EntireFieldWrapper<Maybe<StudioProject>>;
};

export type StudioProjectsGetTeamInput = {
  projectId: Scalars['String'];
};

export type StudioProjectsGetTeamResponse = {
  __typename?: 'StudioProjectsGetTeamResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  team?: EntireFieldWrapper<Maybe<Team>>;
};

export type StudioProjectsListItemsInTrashInput = {
  folderId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  sort: ProjectSort;
  teamId?: InputMaybe<Scalars['ID']>;
  timeFrame?: InputMaybe<TimeFrame>;
};

export type StudioProjectsListItemsInTrashResponse = {
  __typename?: 'StudioProjectsListItemsInTrashResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  folders?: EntireFieldWrapper<Maybe<Array<StudioProjectFolder>>>;
  projects?: EntireFieldWrapper<Maybe<Array<StudioProject>>>;
  templates?: EntireFieldWrapper<Maybe<Array<Template>>>;
};

export type StudioProjectsListMostRecentInput = {
  limit: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
};

export type StudioProjectsListMostRecentResponse = {
  __typename?: 'StudioProjectsListMostRecentResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  projects?: EntireFieldWrapper<Maybe<Array<StudioProject>>>;
};

export type StudioProjectsListProjectsInTrashInput = {
  limit: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  sort: ProjectSort;
  teamId?: InputMaybe<Scalars['ID']>;
  timeFrame?: InputMaybe<TimeFrame>;
};

export type StudioProjectsListProjectsInTrashResponse = {
  __typename?: 'StudioProjectsListProjectsInTrashResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  projects?: EntireFieldWrapper<Maybe<Array<StudioProject>>>;
};

export type StudioProjectsListProjectsInput = {
  filterEmpty?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  sort: ProjectSort;
  teamId?: InputMaybe<Scalars['ID']>;
  timeFrame?: InputMaybe<TimeFrame>;
};

export type StudioProjectsListProjectsResponse = {
  __typename?: 'StudioProjectsListProjectsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  folders?: EntireFieldWrapper<Maybe<Array<StudioProjectFolder>>>;
  projects?: EntireFieldWrapper<Maybe<Array<StudioProject>>>;
};

export type StudioProjectsListProjectsSharedWithMeInput = {
  currentPage?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  ownedBy?: InputMaybe<OwnedBy>;
};

export type StudioProjectsListProjectsSharedWithMeResponse = {
  __typename?: 'StudioProjectsListProjectsSharedWithMeResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<SharedProjectsPagination>>;
  teamsProjects?: EntireFieldWrapper<Maybe<Array<StudioProjectsTeamSharedProjects>>>;
  userProjects?: EntireFieldWrapper<Maybe<Array<StudioProjectsUserSharedProjects>>>;
};

export type StudioProjectsMarkProjectCommentDoneInput = {
  commentId: Scalars['String'];
  projectId: Scalars['String'];
};

export type StudioProjectsMarkProjectCommentDoneResponse = {
  __typename?: 'StudioProjectsMarkProjectCommentDoneResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectsRemoveUserInput = {
  projectId: Scalars['String'];
  teamId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type StudioProjectsRemoveUserResponse = {
  __typename?: 'StudioProjectsRemoveUserResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type StudioProjectsTeamSharedProjects = {
  __typename?: 'StudioProjectsTeamSharedProjects';
  projects: EntireFieldWrapper<Array<StudioProject>>;
  team: EntireFieldWrapper<Team>;
};

export type StudioProjectsUpdateProjectInput = {
  autoSave?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['String']>;
  editor?: InputMaybe<ProjectEditor>;
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
  templateId?: InputMaybe<Scalars['ID']>;
  templateOrigin?: InputMaybe<ProjectTemplateOrigin>;
  thumbnail?: InputMaybe<Scalars['String']>;
  updateFields: Array<StudioProjectUpdateFields>;
};

export type StudioProjectsUpdateProjectLastViewInput = {
  projectId: Scalars['ID'];
};

export type StudioProjectsUpdateProjectLastViewResponse = {
  __typename?: 'StudioProjectsUpdateProjectLastViewResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectsUpdateProjectResponse = {
  __typename?: 'StudioProjectsUpdateProjectResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioProjectsUserSharedProjects = {
  __typename?: 'StudioProjectsUserSharedProjects';
  owner: EntireFieldWrapper<PublicUserProfile>;
  projects: EntireFieldWrapper<Array<StudioProject>>;
};

export type StudioSimpleComment = {
  __typename?: 'StudioSimpleComment';
  childCount: EntireFieldWrapper<Scalars['Int']>;
  createTime: EntireFieldWrapper<Scalars['DateTime']>;
  deleteTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  mentions?: EntireFieldWrapper<Maybe<Array<PublicUserProfile>>>;
  parentId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  reactions: EntireFieldWrapper<Scalars['Int']>;
  text: EntireFieldWrapper<Scalars['String']>;
  updateTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  user: EntireFieldWrapper<PublicUserProfile>;
  userReaction?: EntireFieldWrapper<Maybe<StudioCommentReactionType>>;
};

export type StudioSimpleCommentResponse = {
  __typename?: 'StudioSimpleCommentResponse';
  comment?: EntireFieldWrapper<Maybe<StudioSimpleComment>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type StudioSimpleCommentTaggableUser = {
  __typename?: 'StudioSimpleCommentTaggableUser';
  user: EntireFieldWrapper<PublicUserProfile>;
  userType: EntireFieldWrapper<StudioSimpleCommentTaggableUserType>;
};

export type StudioSimpleCommentTaggableUserType = 'Commenter' | 'Follower' | 'Unspecified';

export type StudioSimpleCommentTaggableUsersInput = {
  entityId: Scalars['ID'];
  entityType?: InputMaybe<StudioSocialEntityType>;
  take?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<StudioSimpleCommentType>;
};

export type StudioSimpleCommentTaggableUsersResponse = {
  __typename?: 'StudioSimpleCommentTaggableUsersResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasMore?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  users?: EntireFieldWrapper<Maybe<Array<StudioSimpleCommentTaggableUser>>>;
};

export type StudioSimpleCommentType = 'Flow' | 'Fonts' | 'Unspecified';

export type StudioSimpleCommentsCreateInput = {
  entityId: Scalars['ID'];
  entityType?: InputMaybe<StudioSocialEntityType>;
  parentId?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
  type?: InputMaybe<StudioSimpleCommentType>;
};

export type StudioSimpleCommentsCreateResponse = {
  __typename?: 'StudioSimpleCommentsCreateResponse';
  comment?: EntireFieldWrapper<Maybe<StudioSimpleComment>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioSimpleCommentsDeleteResponse = {
  __typename?: 'StudioSimpleCommentsDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioSimpleCommentsEditInput = {
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type StudioSimpleCommentsEditResponse = {
  __typename?: 'StudioSimpleCommentsEditResponse';
  comment?: EntireFieldWrapper<Maybe<StudioSimpleComment>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioSimpleCommentsInput = {
  afterId?: InputMaybe<Scalars['ID']>;
  entityId: Scalars['ID'];
  entityType?: InputMaybe<StudioSocialEntityType>;
  parentId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<StudioSimpleCommentsSort>;
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<StudioSimpleCommentType>;
};

export type StudioSimpleCommentsResponse = {
  __typename?: 'StudioSimpleCommentsResponse';
  comments?: EntireFieldWrapper<Maybe<Array<StudioSimpleComment>>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasMore?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  total?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
};

export type StudioSimpleCommentsSort = 'CreateTime' | 'Reactions' | 'Unspecified';

export type StudioSocialEntityType = 'Flow' | 'Fonts' | 'Unspecified';

export type StudioSocialReactionEntityType = 'Comments' | 'Flow' | 'Fonts' | 'Unspecified';

export type StudioTemplateDeleteInput = {
  teamId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
};

export type StudioTemplateDeleteResponse = {
  __typename?: 'StudioTemplateDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioTemplateListResponse = {
  __typename?: 'StudioTemplateListResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  pagination?: EntireFieldWrapper<Maybe<StudioTemplatesPagination>>;
  templates?: EntireFieldWrapper<Maybe<Array<Template>>>;
};

export type StudioTemplatePublishFromProjectInput = {
  projectId: Scalars['String'];
  teamId?: InputMaybe<Scalars['String']>;
};

export type StudioTemplatePublishFromProjectResponse = {
  __typename?: 'StudioTemplatePublishFromProjectResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioTemplateRestoreInput = {
  teamId?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
};

export type StudioTemplateRestoreResponse = {
  __typename?: 'StudioTemplateRestoreResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioTemplatesListInput = {
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

export type StudioTemplatesPagination = {
  __typename?: 'StudioTemplatesPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type StudioUploadsAddTagToFilesInput = {
  fileIds: Array<Scalars['ID']>;
  tagId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioUploadsAddTagToFilesResponse = {
  __typename?: 'StudioUploadsAddTagToFilesResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioUploadsAssetType =
  | 'ASSET_TYPE_BACKGROUND'
  | 'ASSET_TYPE_ELEMENT'
  | 'ASSET_TYPE_FILE'
  | 'ASSET_TYPE_FONT'
  | 'ASSET_TYPE_ICON'
  | 'ASSET_TYPE_PATTERN'
  | 'ASSET_TYPE_PHOTO'
  | 'ASSET_TYPE_UNSPECIFIED';

export type StudioUploadsCreateFolderInput = {
  name: Scalars['String'];
  parent_folder_id?: InputMaybe<Scalars['ID']>;
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioUploadsCreateFolderResponse = {
  __typename?: 'StudioUploadsCreateFolderResponse';
  created?: EntireFieldWrapper<Maybe<StudioUploadsFolder>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type StudioUploadsCreateSignedDownloadUrlInput = {
  teamId?: InputMaybe<Scalars['String']>;
  uploadId: Scalars['String'];
};

export type StudioUploadsCreateSignedDownloadUrlResponse = {
  __typename?: 'StudioUploadsCreateSignedDownloadUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type StudioUploadsCreateSignedUrlInput = {
  folderId?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
  uploadFile: Scalars['String'];
};

export type StudioUploadsCreateSignedUrlResponse = {
  __typename?: 'StudioUploadsCreateSignedUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type StudioUploadsCreateTagInput = {
  color: Scalars['String'];
  label: Scalars['String'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioUploadsCreateTagResponse = {
  __typename?: 'StudioUploadsCreateTagResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  tag: EntireFieldWrapper<StudioUploadsTag>;
};

export type StudioUploadsDeleteFilesInput = {
  fileIds: Array<Scalars['ID']>;
  folderId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioUploadsDeleteFilesResponse = {
  __typename?: 'StudioUploadsDeleteFilesResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioUploadsDeleteFolderInput = {
  folderId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioUploadsDeleteFolderResponse = {
  __typename?: 'StudioUploadsDeleteFolderResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioUploadsDeleteTagInput = {
  id: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioUploadsDeleteTagResponse = {
  __typename?: 'StudioUploadsDeleteTagResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioUploadsFile = {
  __typename?: 'StudioUploadsFile';
  createdAt: EntireFieldWrapper<Scalars['String']>;
  deletedAt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  folderId: EntireFieldWrapper<Scalars['ID']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  name: EntireFieldWrapper<Scalars['String']>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type: EntireFieldWrapper<StudioUploadsAssetType>;
  updatedAt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  url: EntireFieldWrapper<Scalars['String']>;
};

export type StudioUploadsFolder = {
  __typename?: 'StudioUploadsFolder';
  createdAt: EntireFieldWrapper<Scalars['String']>;
  files: EntireFieldWrapper<Array<StudioUploadsFile>>;
  folderType: EntireFieldWrapper<StudioFolderType>;
  id: EntireFieldWrapper<Scalars['ID']>;
  name: EntireFieldWrapper<Scalars['String']>;
  parentFolderId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  subfolders: EntireFieldWrapper<Array<StudioUploadsSubFolder>>;
  teamId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  updatedAt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type StudioUploadsGetFolderInput = {
  folderId?: InputMaybe<Scalars['ID']>;
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioUploadsGetFolderResponse = {
  __typename?: 'StudioUploadsGetFolderResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  folder?: EntireFieldWrapper<Maybe<StudioUploadsFolder>>;
};

export type StudioUploadsGetTagsForUploadsInput = {
  teamId?: InputMaybe<Scalars['ID']>;
  uploadId: Scalars['ID'];
};

export type StudioUploadsGetTagsForUploadsResponse = {
  __typename?: 'StudioUploadsGetTagsForUploadsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  tags: EntireFieldWrapper<Array<StudioUploadsTag>>;
};

export type StudioUploadsMoveFilesInput = {
  fileIds: Array<Scalars['ID']>;
  folderId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioUploadsMoveFilesResponse = {
  __typename?: 'StudioUploadsMoveFilesResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  moved: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioUploadsRemoveTagFromFileInput = {
  fileIds: Array<Scalars['ID']>;
  tagId: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioUploadsRemoveTagFromFileResponse = {
  __typename?: 'StudioUploadsRemoveTagFromFileResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioUploadsRenameFolderInput = {
  folderId: Scalars['ID'];
  name: Scalars['String'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioUploadsRenameFolderResponse = {
  __typename?: 'StudioUploadsRenameFolderResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  renamed: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioUploadsSearchFilesInput = {
  folderId?: InputMaybe<Scalars['ID']>;
  search: Scalars['String'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioUploadsSearchFilesResponse = {
  __typename?: 'StudioUploadsSearchFilesResponse';
  errors: EntireFieldWrapper<Array<ErrorMessage>>;
  files: EntireFieldWrapper<Array<StudioUploadsFile>>;
  folders: EntireFieldWrapper<Array<StudioUploadsFolder>>;
  tags: EntireFieldWrapper<Array<StudioUploadsTag>>;
};

export type StudioUploadsSubFolder = {
  __typename?: 'StudioUploadsSubFolder';
  folderType: EntireFieldWrapper<StudioFolderType>;
  id: EntireFieldWrapper<Scalars['ID']>;
  name: EntireFieldWrapper<Scalars['String']>;
  totalFiles: EntireFieldWrapper<Scalars['Int']>;
};

export type StudioUploadsTag = {
  __typename?: 'StudioUploadsTag';
  color: EntireFieldWrapper<Scalars['String']>;
  createdAt: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  label: EntireFieldWrapper<Scalars['String']>;
  teamId?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  updatedAt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type StudioUploadsTagUpdate = {
  color?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type StudioUploadsTagUpdateField = 'color' | 'label';

export type StudioUploadsTagsInput = {
  teamId?: InputMaybe<Scalars['ID']>;
};

export type StudioUploadsTagsResponse = {
  __typename?: 'StudioUploadsTagsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  tags: EntireFieldWrapper<Array<StudioUploadsTag>>;
};

export type StudioUploadsUpdateTagInput = {
  id: Scalars['ID'];
  teamId?: InputMaybe<Scalars['ID']>;
  updateField: StudioUploadsTagUpdateField;
  updateTag: StudioUploadsTagUpdate;
};

export type StudioUploadsUpdateTagResponse = {
  __typename?: 'StudioUploadsUpdateTagResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type StudioUploadsUploadUpdatedInput = {
  id: Scalars['ID'];
};

export type StudioUploadsUploadUpdatedResponse = {
  __typename?: 'StudioUploadsUploadUpdatedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  upload?: EntireFieldWrapper<Maybe<StudioUploadsFile>>;
};

export type SubmissionAnalyseResults = {
  __typename?: 'SubmissionAnalyseResults';
  passedAesthetics: EntireFieldWrapper<Scalars['Boolean']>;
  passedCopyright: EntireFieldWrapper<Scalars['Boolean']>;
  passedProfanity: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SubscribeToClubhouseDigestInput = {
  clubhouseSlug: Scalars['String'];
};

export type SubscribeToClubhouseDigestResponse = {
  __typename?: 'SubscribeToClubhouseDigestResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type SubscribeToDigestResponse = {
  __typename?: 'SubscribeToDigestResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  clubhouseOnlineCount: EntireFieldWrapper<Scalars['Int']>;
  designReviewUpdates: EntireFieldWrapper<DesignReview>;
  entityView: EntireFieldWrapper<EntityStatsResponse>;
  flowActive: EntireFieldWrapper<Scalars['Boolean']>;
  flowFeedStatusUpdated: EntireFieldWrapper<FlowStatus>;
  flowFeedUpdated: EntireFieldWrapper<Flow>;
  flowInteractions: EntireFieldWrapper<FlowInteractionResponse>;
  flowLiked: EntireFieldWrapper<Scalars['Boolean']>;
  flowMostLikedFlowsUpdated: EntireFieldWrapper<Array<Scalars['String']>>;
  flowMostViewedFlowsUpdated: EntireFieldWrapper<Array<Scalars['String']>>;
  flowOnlineCount: EntireFieldWrapper<Scalars['Int']>;
  flowQueueUpdated: EntireFieldWrapper<FlowQueue>;
  flowStatusUpdated: EntireFieldWrapper<FlowStatus>;
  flowUpdated: EntireFieldWrapper<Flow>;
  flowViewers: EntireFieldWrapper<FlowViewersResponse>;
  flowsFlowTipped: EntireFieldWrapper<FlowsFlowTippedResponse>;
  /** @deprecated use fontGeneratorFontPackProgress */
  fontGeneratorDownloadFontProgress: EntireFieldWrapper<FontGeneratorFontProgressResponse>;
  /** @deprecated use fontGeneratorUserFontProgress */
  fontGeneratorFontProgress: EntireFieldWrapper<FontGeneratorFontProgressResponse>;
  fontGeneratorSymbolProgress: EntireFieldWrapper<FontGeneratorSymbolProgressResponse>;
  fontGeneratorUserFontPackProgress: EntireFieldWrapper<FontGeneratorUserFontProgressResponse>;
  fontGeneratorUserFontProgress: EntireFieldWrapper<FontGeneratorUserFontProgressResponse>;
  fontsFeedUpdates: EntireFieldWrapper<FontsFeedUpdatesResponse>;
  healthz: EntireFieldWrapper<HealthZResponse>;
  /** @deprecated Use flowMostLikedFlowsUpdated */
  mostLikedFlowsUpdated: EntireFieldWrapper<Array<Scalars['String']>>;
  /** @deprecated Use flowMostViewedFlowsUpdated */
  mostViewedFlowsUpdated: EntireFieldWrapper<Array<Scalars['String']>>;
  publisherTemplateSubmissionUpdated: EntireFieldWrapper<PublisherTemplateSubmissionUpdatedResponse>;
  sparkRemovedBackgroundUpdates: EntireFieldWrapper<SparkRemoveBackgroundImage>;
  studioUploadsUploadUpdated: EntireFieldWrapper<StudioUploadsUploadUpdatedResponse>;
  transfersTransferUpdates: EntireFieldWrapper<Transfer>;
  uploadedFontsUploadUpdated: EntireFieldWrapper<UploadedFontsUploadUpdatedResponse>;
  upscalerImageUpdates: EntireFieldWrapper<UpscalerImage>;
  userBalanceChanged?: EntireFieldWrapper<Maybe<UserBalanceChange>>;
  userTipped: EntireFieldWrapper<Scalars['Boolean']>;
  vectorizerImageUpdates: EntireFieldWrapper<VectorizerImage>;
  /** @deprecated Use flowViewers */
  viewers: EntireFieldWrapper<FlowViewersResponse>;
};

export type SubscriptionClubhouseOnlineCountArgs = {
  input?: InputMaybe<ClubhouseOnlineInput>;
};

export type SubscriptionDesignReviewUpdatesArgs = {
  id: Scalars['String'];
};

export type SubscriptionEntityViewArgs = {
  id: EntityViewInput;
};

export type SubscriptionFlowActiveArgs = {
  flowID: Scalars['ID'];
};

export type SubscriptionFlowInteractionsArgs = {
  input: FlowInteractionInput;
};

export type SubscriptionFlowLikedArgs = {
  flowId?: InputMaybe<Scalars['String']>;
};

export type SubscriptionFlowQueueUpdatedArgs = {
  flowID?: InputMaybe<Scalars['String']>;
};

export type SubscriptionFlowStatusUpdatedArgs = {
  flowID: Scalars['ID'];
};

export type SubscriptionFlowUpdatedArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type SubscriptionFlowViewersArgs = {
  flowId: Scalars['String'];
};

export type SubscriptionFlowsFlowTippedArgs = {
  input: FlowFlowsTippedInput;
};

export type SubscriptionFontGeneratorDownloadFontProgressArgs = {
  id: Scalars['ID'];
};

export type SubscriptionFontGeneratorFontProgressArgs = {
  id: Scalars['ID'];
};

export type SubscriptionFontGeneratorSymbolProgressArgs = {
  id: Scalars['ID'];
};

export type SubscriptionFontGeneratorUserFontPackProgressArgs = {
  id: Scalars['ID'];
};

export type SubscriptionFontGeneratorUserFontProgressArgs = {
  id: Scalars['ID'];
};

export type SubscriptionPublisherTemplateSubmissionUpdatedArgs = {
  id: Scalars['ID'];
};

export type SubscriptionStudioUploadsUploadUpdatedArgs = {
  input: StudioUploadsUploadUpdatedInput;
};

export type SubscriptionTransfersTransferUpdatesArgs = {
  id: Scalars['String'];
};

export type SubscriptionUploadedFontsUploadUpdatedArgs = {
  input: UploadedFontsUploadUpdatedInput;
};

export type SubscriptionUpscalerImageUpdatesArgs = {
  id: Scalars['ID'];
};

export type SubscriptionUserTippedArgs = {
  userId?: InputMaybe<Scalars['String']>;
};

export type SubscriptionVectorizerImageUpdatesArgs = {
  id: Scalars['ID'];
};

export type SubscriptionViewersArgs = {
  flowId: Scalars['String'];
};

export type SubscriptionType =
  | 'allAccessMonthly'
  | 'allAccessMonthlyFreeTrial'
  | 'allAccessYearly'
  | 'allAccessYearlyFreeTrial'
  | 'allAccessYearlyPromo';

export type SubscriptionTypeUpgrade = 'allAccessYearly' | 'allAccessYearlyPromo';

export type Subscriptions = {
  __typename?: 'Subscriptions';
  allAccess?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  classes?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  crafts?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  embroidery?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  fonts?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  graphics?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type Tag = {
  __typename?: 'Tag';
  attributes: EntireFieldWrapper<Array<TagAttribute>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['Int']>;
  name: EntireFieldWrapper<Scalars['String']>;
  nameEn: EntireFieldWrapper<Scalars['String']>;
  slug: EntireFieldWrapper<Scalars['String']>;
  slugEn: EntireFieldWrapper<Scalars['String']>;
  tagKey: EntireFieldWrapper<Scalars['String']>;
};

export type TagAttribute = {
  __typename?: 'TagAttribute';
  id: EntireFieldWrapper<Scalars['Int']>;
  key: EntireFieldWrapper<Scalars['String']>;
  value: EntireFieldWrapper<Scalars['String']>;
};

export type TagProduct = {
  __typename?: 'TagProduct';
  createdAt: EntireFieldWrapper<Scalars['Time']>;
  id: EntireFieldWrapper<Scalars['Int']>;
  popularity: EntireFieldWrapper<Scalars['Int']>;
  productId: EntireFieldWrapper<Scalars['Int']>;
  tagIDs: EntireFieldWrapper<Array<Scalars['Int']>>;
  updatedAt: EntireFieldWrapper<Scalars['Time']>;
};

export type Team = {
  __typename?: 'Team';
  avatarColour?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  avatarInitials?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  logoUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  members: EntireFieldWrapper<Array<TeamMember>>;
  name: EntireFieldWrapper<Scalars['String']>;
  owner: EntireFieldWrapper<PublicUserProfile>;
  pendingInvitations?: EntireFieldWrapper<Maybe<Array<InvitedTeamMember>>>;
  scheduledDeletionTime?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  status: EntireFieldWrapper<TeamStatus>;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  member: EntireFieldWrapper<PublicUserProfile>;
  role: EntireFieldWrapper<Role>;
};

export type TeamStatus = 'Deactivated' | 'Free' | 'Premium' | 'Suspended';

export type TeamsApproveAdminRequestInput = {
  invitationCode: Scalars['String'];
  invitationId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

export type TeamsApproveAdminRequestResponse = {
  __typename?: 'TeamsApproveAdminRequestResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type TeamsApproveNewTeamMemberInput = {
  invitationCode: Scalars['String'];
  teamId: Scalars['String'];
};

export type TeamsApproveNewTeamMemberResponse = {
  __typename?: 'TeamsApproveNewTeamMemberResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type TeamsApproveTeamMemberRoleChangeInput = {
  invitationCode: Scalars['String'];
  teamId: Scalars['String'];
};

export type TeamsApproveTeamMemberRoleChangeResponse = {
  __typename?: 'TeamsApproveTeamMemberRoleChangeResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type TeamsCancelInviteInput = {
  invitationId: Scalars['String'];
  teamId: Scalars['String'];
};

export type TeamsCancelInviteResponse = {
  __typename?: 'TeamsCancelInviteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type TeamsChangeUserRoleInput = {
  role: Role;
  teamId: Scalars['String'];
  userId: Scalars['String'];
};

export type TeamsChangeUserRoleResponse = {
  __typename?: 'TeamsChangeUserRoleResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  status?: EntireFieldWrapper<Maybe<ChangeUserRoleStatus>>;
};

export type TeamsConfirmInviteInput = {
  invitationCode: Scalars['String'];
  teamId: Scalars['String'];
};

export type TeamsConfirmInviteResponse = {
  __typename?: 'TeamsConfirmInviteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type TeamsCreateTeamInput = {
  logoUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type TeamsCreateTeamResponse = {
  __typename?: 'TeamsCreateTeamResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  team?: EntireFieldWrapper<Maybe<Team>>;
};

export type TeamsDeactivateTeamInput = {
  teamId: Scalars['String'];
};

export type TeamsDeactivateTeamResponse = {
  __typename?: 'TeamsDeactivateTeamResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type TeamsFetchOutstandingInvoiceUrlInput = {
  teamId: Scalars['String'];
};

export type TeamsFetchOutstandingInvoiceUrlResponse = {
  __typename?: 'TeamsFetchOutstandingInvoiceUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasOutstandingInvoice?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  /** @deprecated Use `url` instead */
  invoiceUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type TeamsFetchUpcomingInvoiceUrlInput = {
  teamId: Scalars['String'];
};

export type TeamsFetchUpcomingInvoiceUrlResponse = {
  __typename?: 'TeamsFetchUpcomingInvoiceUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasUpcomingInvoice?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type TeamsGetCheckoutUrlInput = {
  cancelRedirectUrl?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

export type TeamsGetCheckoutUrlResponse = {
  __typename?: 'TeamsGetCheckoutURLResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type TeamsGetTeamInput = {
  teamId: Scalars['String'];
};

export type TeamsGetTeamResponse = {
  __typename?: 'TeamsGetTeamResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  team?: EntireFieldWrapper<Maybe<Team>>;
};

export type TeamsInviteUsersInput = {
  invitedUser?: InputMaybe<TeamsInvitedUser>;
  teamId: Scalars['String'];
  users?: InputMaybe<Array<TeamsInvitedUser>>;
};

export type TeamsInviteUsersResponse = {
  __typename?: 'TeamsInviteUsersResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  status?: EntireFieldWrapper<Maybe<InvitationStatus>>;
};

export type TeamsInvitedUser = {
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  role: Role;
};

export type TeamsLeaveTeamInput = {
  teamId: Scalars['String'];
};

export type TeamsLeaveTeamResponse = {
  __typename?: 'TeamsLeaveTeamResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type TeamsPreviewUpcomingCharges = {
  __typename?: 'TeamsPreviewUpcomingCharges';
  hasUpcomingCharges: EntireFieldWrapper<Scalars['Boolean']>;
  nextBillingTime: EntireFieldWrapper<Scalars['String']>;
  seatCharges: EntireFieldWrapper<TeamsPreviewUpcomingSeatCharges>;
  storageCharges: EntireFieldWrapper<TeamsPreviewUpcomingStorageCharges>;
};

export type TeamsPreviewUpcomingChargesInput = {
  teamId: Scalars['String'];
};

export type TeamsPreviewUpcomingChargesResponse = {
  __typename?: 'TeamsPreviewUpcomingChargesResponse';
  charges?: EntireFieldWrapper<Maybe<TeamsPreviewUpcomingCharges>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type TeamsPreviewUpcomingSeatCharges = {
  __typename?: 'TeamsPreviewUpcomingSeatCharges';
  freeSeats: EntireFieldWrapper<Scalars['Int']>;
  paidSeats: EntireFieldWrapper<Scalars['Int']>;
  totalSeatsUsed: EntireFieldWrapper<Scalars['Int']>;
  unpaidSeats: EntireFieldWrapper<Scalars['Int']>;
};

export type TeamsPreviewUpcomingStorageCharges = {
  __typename?: 'TeamsPreviewUpcomingStorageCharges';
  paidStorageBlocks: EntireFieldWrapper<Scalars['Int']>;
  usedStorageBlocks: EntireFieldWrapper<Scalars['Int']>;
  usedStorageGbs: EntireFieldWrapper<Scalars['Int']>;
};

export type TeamsRemoveUsersInput = {
  teamId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type TeamsRemoveUsersResponse = {
  __typename?: 'TeamsRemoveUsersResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  removedUserIds: EntireFieldWrapper<Array<Scalars['String']>>;
  teamId: EntireFieldWrapper<Scalars['String']>;
};

export type TeamsResendInviteInput = {
  invitationId: Scalars['String'];
  inviteId?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

export type TeamsResendInviteResponse = {
  __typename?: 'TeamsResendInviteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type TeamsUpdateTeamInput = {
  avatarColour?: InputMaybe<Scalars['String']>;
  avatarInitials?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};

export type TeamsUpdateTeamResponse = {
  __typename?: 'TeamsUpdateTeamResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
  team?: EntireFieldWrapper<Maybe<Team>>;
};

export type Template = {
  __typename?: 'Template';
  contentUrl: EntireFieldWrapper<Scalars['String']>;
  createTime: EntireFieldWrapper<Scalars['String']>;
  /** @deprecated Use createTime */
  createdAt: EntireFieldWrapper<Scalars['String']>;
  createdBy: EntireFieldWrapper<PublicUserProfile>;
  deleteTime?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
  team?: EntireFieldWrapper<Maybe<Team>>;
  thumbnailUrl: EntireFieldWrapper<Scalars['String']>;
};

export type TemplateFormatImageOnly = {
  __typename?: 'TemplateFormatImageOnly';
  image: EntireFieldWrapper<CampaignAsset>;
};

export type TemplateFormatImagesAndLogo = {
  __typename?: 'TemplateFormatImagesAndLogo';
  image: EntireFieldWrapper<CampaignAsset>;
  logo: EntireFieldWrapper<CampaignAsset>;
  textResources: EntireFieldWrapper<TextResources>;
};

export type TemplateFormatImagesAndText = {
  __typename?: 'TemplateFormatImagesAndText';
  mainImage: EntireFieldWrapper<CampaignAsset>;
  secondaryImage: EntireFieldWrapper<CampaignAsset>;
  textResources: EntireFieldWrapper<TextResources>;
};

export type TemplateFormatVideoAndImage = {
  __typename?: 'TemplateFormatVideoAndImage';
  image: EntireFieldWrapper<CampaignAsset>;
  textResources: EntireFieldWrapper<TextResources>;
  video: EntireFieldWrapper<CampaignAsset>;
};

export type TemplateFormatVideoOnly = {
  __typename?: 'TemplateFormatVideoOnly';
  video: EntireFieldWrapper<CampaignAsset>;
};

export type TemplateSubmission = {
  __typename?: 'TemplateSubmission';
  analyseResults?: EntireFieldWrapper<Maybe<SubmissionAnalyseResults>>;
  category?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  createTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  deleteTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  rejectionReason?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  status: EntireFieldWrapper<TemplateSubmissionStatus>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updateTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
};

export type TemplateSubmissionStatus =
  | 'analysing'
  | 'awaitingModeration'
  | 'draft'
  | 'published'
  | 'rejected'
  | 'unknown';

export type TextResources = {
  __typename?: 'TextResources';
  ctaText?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  text?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type TimeFrame = {
  dateField: DateField;
  dateRange: DateRange;
};

export type Topic = {
  __typename?: 'Topic';
  clubhouseSlug: EntireFieldWrapper<Scalars['String']>;
  discussions?: EntireFieldWrapper<Maybe<Array<DiscussionListItem>>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  topicName: EntireFieldWrapper<Scalars['String']>;
  topicSlug: EntireFieldWrapper<Scalars['String']>;
};

export type Transfer = {
  __typename?: 'Transfer';
  accessCode?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  canceledAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  createdAt: EntireFieldWrapper<Scalars['DateTime']>;
  deletedAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  errorMessage?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  expiredAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  failedAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  files: EntireFieldWrapper<Array<Maybe<TransferFile>>>;
  filesCount: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  owner?: EntireFieldWrapper<Maybe<PublicUserProfile>>;
  recipients: EntireFieldWrapper<Array<Maybe<TransferRecipient>>>;
  status: EntireFieldWrapper<TransferStatus>;
  subject: EntireFieldWrapper<Scalars['String']>;
  team?: EntireFieldWrapper<Maybe<Team>>;
  updatedAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  zipFile?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  zipSize: EntireFieldWrapper<Scalars['Int']>;
};

export type TransferFile = {
  __typename?: 'TransferFile';
  createdAt: EntireFieldWrapper<Scalars['DateTime']>;
  errorMessage?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  failedAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  fileName: EntireFieldWrapper<Scalars['String']>;
  filePath: EntireFieldWrapper<Scalars['String']>;
  fileSize: EntireFieldWrapper<Scalars['Int']>;
  fileType: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['String']>;
  transferId: EntireFieldWrapper<Scalars['String']>;
  updatedAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  uploadStatus: EntireFieldWrapper<UploadStatus>;
};

export type TransferRecipient = {
  __typename?: 'TransferRecipient';
  createdAt: EntireFieldWrapper<Scalars['DateTime']>;
  downloaded: EntireFieldWrapper<Scalars['Boolean']>;
  downloadedAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  id: EntireFieldWrapper<Scalars['String']>;
  transferAccessCode?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  transferId: EntireFieldWrapper<Scalars['String']>;
  userInfo?: EntireFieldWrapper<Maybe<UserInfo>>;
};

export type TransferSort = {
  direction: SortDirection;
  field: TransferSortField;
};

export type TransferSortField = 'createdAt' | 'unknown';

export type TransferStatus =
  | 'canceled'
  | 'completed'
  | 'failed'
  | 'initialized'
  | 'ready'
  | 'requiresOTPVerification'
  | 'sending'
  | 'unknown'
  | 'waiting';

export type TransfersAddRecipientsInput = {
  ownerEmail?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
  transferId: Scalars['String'];
  userInfos: Array<UserInfoInput>;
};

export type TransfersAddRecipientsResponse = {
  __typename?: 'TransfersAddRecipientsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  recipients?: EntireFieldWrapper<Maybe<Array<TransferRecipient>>>;
};

export type TransfersCancelInput = {
  id: Scalars['String'];
  ownerEmail?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
};

export type TransfersCancelResponse = {
  __typename?: 'TransfersCancelResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type TransfersConfirmOwnerEmailInput = {
  transferId: Scalars['String'];
  verificationCode: Scalars['String'];
};

export type TransfersConfirmOwnerEmailResponse = {
  __typename?: 'TransfersConfirmOwnerEmailResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type TransfersCreateSignedDownloadUrlInput = {
  accessCode: Scalars['String'];
  transferId: Scalars['String'];
};

export type TransfersCreateSignedDownloadUrlResponse = {
  __typename?: 'TransfersCreateSignedDownloadUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type TransfersDeleteInput = {
  id: Scalars['String'];
  ownerEmail?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
};

export type TransfersDeleteResponse = {
  __typename?: 'TransfersDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type TransfersExpiryDuration = 'ONE_DAY' | 'ONE_MONTH' | 'ONE_WEEK' | 'ONE_YEAR' | 'TEN_MINUTES' | 'THREE_DAYS';

export type TransfersGetTransferInput = {
  accessCode?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  ownerEmail?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
};

export type TransfersGetTransferResponse = {
  __typename?: 'TransfersGetTransferResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  transfer?: EntireFieldWrapper<Maybe<Transfer>>;
};

export type TransfersInitiateTransferInput = {
  expiresAt?: InputMaybe<TransfersExpiryDuration>;
  filesCount: Scalars['Int'];
  message?: InputMaybe<Scalars['String']>;
  ownerEmail?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  teamId?: InputMaybe<Scalars['String']>;
};

export type TransfersInitiateTransferResponse = {
  __typename?: 'TransfersInitiateTransferResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type TransfersInitiateTransferV2Input = {
  expiresAt?: InputMaybe<TransfersExpiryDuration>;
  filesCount: Scalars['Int'];
  message?: InputMaybe<Scalars['String']>;
  ownerEmail?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  teamId?: InputMaybe<Scalars['String']>;
};

export type TransfersInitiateTransferV2Response = {
  __typename?: 'TransfersInitiateTransferV2Response';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  status?: EntireFieldWrapper<Maybe<TransferStatus>>;
};

export type TransfersVerifyOwnerEmailInput = {
  ownerEmail: Scalars['String'];
  transferId: Scalars['String'];
};

export type TransfersVerifyOwnerEmailResponse = {
  __typename?: 'TransfersVerifyOwnerEmailResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type TransformedPricesResponse = {
  __typename?: 'TransformedPricesResponse';
  basePrice: EntireFieldWrapper<Scalars['Int']>;
  currencyPrice: EntireFieldWrapper<Scalars['Int']>;
};

export type UndoCancelationBanner = {
  __typename?: 'UndoCancelationBanner';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNav: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNavState: EntireFieldWrapper<Scalars['String']>;
  button: EntireFieldWrapper<UndoCancelationBannerButton>;
  countdown: EntireFieldWrapper<SiteBannerCountdown>;
  subscriptionId: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SiteBannerType>;
};

export type UndoCancelationBannerButton = {
  __typename?: 'UndoCancelationBannerButton';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  hoverTextColor: EntireFieldWrapper<Scalars['String']>;
  link?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  onClick: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  textColor: EntireFieldWrapper<Scalars['String']>;
};

export type UnsubscribeToClubhouseDigestInput = {
  clubhouseSlug: Scalars['String'];
};

export type UnsubscribeToClubhouseDigestResponse = {
  __typename?: 'UnsubscribeToClubhouseDigestResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type UpdateCoinTransactionStatusResponse = {
  __typename?: 'UpdateCoinTransactionStatusResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  transaction?: EntireFieldWrapper<Maybe<CoinTransaction>>;
};

export type UpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type UpgradeSubscriptionResult = {
  __typename?: 'UpgradeSubscriptionResult';
  payInvoiceUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  paymentStatus: EntireFieldWrapper<PaymentStatus>;
  userBanned?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type UploadStatus = 'completed' | 'failed' | 'pending' | 'started' | 'unknown';

export type UploadedFont = {
  __typename?: 'UploadedFont';
  createdAt: EntireFieldWrapper<Scalars['String']>;
  deletedAt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  name: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<FontType>;
  updatedAt?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  url: EntireFieldWrapper<Scalars['String']>;
};

export type UploadedFontsCreateSignedUrlInput = {
  checksum?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type UploadedFontsCreateSignedUrlResponse = {
  __typename?: 'UploadedFontsCreateSignedUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type UploadedFontsDeleteInput = {
  fontIds: Array<Scalars['ID']>;
  teamId?: InputMaybe<Scalars['ID']>;
};

export type UploadedFontsDeleteResponse = {
  __typename?: 'UploadedFontsDeleteResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type UploadedFontsSearchInput = {
  search?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<FontType>;
};

export type UploadedFontsSearchResponse = {
  __typename?: 'UploadedFontsSearchResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  fonts?: EntireFieldWrapper<Maybe<Array<UploadedFont>>>;
};

export type UploadedFontsUploadUpdatedInput = {
  id: Scalars['ID'];
};

export type UploadedFontsUploadUpdatedResponse = {
  __typename?: 'UploadedFontsUploadUpdatedResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  font?: EntireFieldWrapper<Maybe<UploadedFont>>;
};

export type UploadsApp = 'studio' | 'vectorizer';

export type UploadsCreateSignedUrlInputV2 = {
  app: UploadsApp;
  fileName: Scalars['String'];
};

export type UploadsCreateSignedUrlResponseV2 = {
  __typename?: 'UploadsCreateSignedUrlResponseV2';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['String']>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type UpscaleImageSource = 'flows';

export type UpscalerCancelImageInput = {
  id: Scalars['ID'];
};

export type UpscalerCancelImageResponse = {
  __typename?: 'UpscalerCancelImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type UpscalerCreateSignedUploadUrl = {
  fileSize?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type UpscalerCreateSignedUploadUrlResponse = {
  __typename?: 'UpscalerCreateSignedUploadUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  signedUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type UpscalerDeleteAllImagesResponse = {
  __typename?: 'UpscalerDeleteAllImagesResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type UpscalerDeleteImageInput = {
  id: Scalars['ID'];
};

export type UpscalerDeleteImageResponse = {
  __typename?: 'UpscalerDeleteImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type UpscalerDownloadImageInput = {
  id: Scalars['ID'];
};

export type UpscalerDownloadImageResponse = {
  __typename?: 'UpscalerDownloadImageResponse';
  downloadUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type UpscalerGetImageInput = {
  id: Scalars['ID'];
};

export type UpscalerGetImageResponse = {
  __typename?: 'UpscalerGetImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  image?: EntireFieldWrapper<Maybe<UpscalerImage>>;
};

export type UpscalerImage = {
  __typename?: 'UpscalerImage';
  createTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  originalUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  previewUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  status: EntireFieldWrapper<UpscalerImageStatus>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updateTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
};

export type UpscalerImageStatus = 'completed' | 'failed' | 'pending' | 'unknown';

export type UpscalerImagesInput = {
  afterId?: InputMaybe<Scalars['String']>;
  take: Scalars['Int'];
};

export type UpscalerImagesResponse = {
  __typename?: 'UpscalerImagesResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasMore?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  images?: EntireFieldWrapper<Maybe<Array<UpscalerImage>>>;
};

export type UpscalerPublishImageInput = {
  id: Scalars['ID'];
};

export type UpscalerPublishImageResponse = {
  __typename?: 'UpscalerPublishImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type UpscalerUpscaleImageInput = {
  id: Scalars['ID'];
  source: UpscaleImageSource;
};

export type UpscalerUpscaleImageResponse = {
  __typename?: 'UpscalerUpscaleImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  /** @deprecated Use image.id instead */
  id?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
  image?: EntireFieldWrapper<Maybe<UpscalerImage>>;
};

export type UpsellBanner = {
  __typename?: 'UpsellBanner';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  button: EntireFieldWrapper<UpsellBannerButton>;
  countdown: EntireFieldWrapper<SiteBannerCountdown>;
  text: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SiteBannerType>;
};

export type UpsellBannerButton = {
  __typename?: 'UpsellBannerButton';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  hoverTextColor: EntireFieldWrapper<Scalars['String']>;
  link: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  textColor: EntireFieldWrapper<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  affiliateInfo?: EntireFieldWrapper<Maybe<AffiliateInfo>>;
  avatarUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  billingDetails: EntireFieldWrapper<BillingDetails>;
  bio: EntireFieldWrapper<Scalars['String']>;
  canSwitchVisibility: EntireFieldWrapper<Scalars['Boolean']>;
  capabilities: EntireFieldWrapper<Array<Scalars['String']>>;
  contentInterests: EntireFieldWrapper<Array<Scalars['String']>>;
  craftingTypes: EntireFieldWrapper<Array<Scalars['String']>>;
  currency: EntireFieldWrapper<Currency>;
  email: EntireFieldWrapper<Scalars['String']>;
  firstName?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  flags?: EntireFieldWrapper<Maybe<UserFlags>>;
  following: EntireFieldWrapper<Scalars['Boolean']>;
  id: EntireFieldWrapper<Scalars['ID']>;
  isEligibleForFreeTrial: EntireFieldWrapper<Scalars['Boolean']>;
  isEligibleForYearlyUpgrade: EntireFieldWrapper<Scalars['Boolean']>;
  isSubscribedToFlowDailyDigest: EntireFieldWrapper<Scalars['Boolean']>;
  isTemporary: EntireFieldWrapper<Scalars['Boolean']>;
  language: EntireFieldWrapper<Language>;
  lastName?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  location: EntireFieldWrapper<UserLocation>;
  login?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  machineTypes: EntireFieldWrapper<Array<Scalars['String']>>;
  nickname?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  registeredAt?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  roles?: EntireFieldWrapper<Maybe<Array<Maybe<Scalars['String']>>>>;
  slug?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  stripeCustomerId: EntireFieldWrapper<Scalars['String']>;
  subscriptions?: EntireFieldWrapper<Maybe<Subscriptions>>;
  superSkill?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  teams: EntireFieldWrapper<Array<Team>>;
  url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type UserBalance = {
  __typename?: 'UserBalance';
  balance: EntireFieldWrapper<Scalars['Int']>;
};

export type UserBalanceChange = {
  __typename?: 'UserBalanceChange';
  balance: EntireFieldWrapper<Scalars['Int']>;
};

export type UserBlock = {
  __typename?: 'UserBlock';
  BlockedBy: EntireFieldWrapper<Scalars['String']>;
  EndDate?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  Reason: EntireFieldWrapper<Scalars['String']>;
  StartDate: EntireFieldWrapper<Scalars['DateTime']>;
  Status: EntireFieldWrapper<Scalars['String']>;
};

export type UserCheckFollowingInput = {
  targetUserId?: InputMaybe<Scalars['ID']>;
  targetUserSlug?: InputMaybe<Scalars['String']>;
};

export type UserCreditTypes = 'BLACK_FRIDAY_2024';

export type UserFlags = {
  __typename?: 'UserFlags';
  hasNewUserNewsletter?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  identifyUser?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  isCreativeFabrica?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  isGAdsSignup?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  isNew?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  isOnHoldSubscriber?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  isUserVerificationRequired?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type UserFollowersCountInput = {
  userId: Scalars['String'];
};

export type UserFollowersCountResponse = {
  __typename?: 'UserFollowersCountResponse';
  FollowersCount: EntireFieldWrapper<Scalars['Int']>;
  FollowingCount: EntireFieldWrapper<Scalars['Int']>;
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
};

export type UserFollowersInput = {
  itemsPerPage: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};

export type UserFollowersPagination = {
  __typename?: 'UserFollowersPagination';
  currentPage: EntireFieldWrapper<Scalars['Int']>;
  itemsPerPage: EntireFieldWrapper<Scalars['Int']>;
  totalPages: EntireFieldWrapper<Scalars['Int']>;
};

export type UserFollowersResponse = {
  __typename?: 'UserFollowersResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  followers: EntireFieldWrapper<Array<PublicUserProfile>>;
  pagination: EntireFieldWrapper<UserFollowersPagination>;
};

export type UserFollowingResponse = {
  __typename?: 'UserFollowingResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  following: EntireFieldWrapper<Array<PublicUserProfile>>;
  pagination: EntireFieldWrapper<UserFollowersPagination>;
};

export type UserGetCreditResponse = {
  __typename?: 'UserGetCreditResponse';
  amount: EntireFieldWrapper<Scalars['Float']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  address?: EntireFieldWrapper<Maybe<EmailAddress>>;
  user?: EntireFieldWrapper<Maybe<UserProfile>>;
};

export type UserInfoInput = {
  address?: InputMaybe<EmailAddressInput>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UserInput = {
  billingDetails: BillingDetailsInput;
  referredByAffiliateId?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
};

export type UserListFavoriteProduct = {
  __typename?: 'UserListFavoriteProduct';
  favoriteCount: EntireFieldWrapper<Scalars['Int']>;
  hasBeenDownloaded: EntireFieldWrapper<Scalars['Boolean']>;
  mainCategoryName: EntireFieldWrapper<Scalars['String']>;
  productId: EntireFieldWrapper<Scalars['String']>;
  productImage: EntireFieldWrapper<Scalars['String']>;
  productTitle: EntireFieldWrapper<Scalars['String']>;
};

export type UserLocation = {
  __typename?: 'UserLocation';
  country: EntireFieldWrapper<CountryCode>;
};

export type UserLocationResponse = {
  __typename?: 'UserLocationResponse';
  location: EntireFieldWrapper<UserLocation>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  email?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['String']>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type UserProjectPermission = {
  __typename?: 'UserProjectPermission';
  projectRole: EntireFieldWrapper<Role>;
  teamRole: EntireFieldWrapper<Role>;
  user: EntireFieldWrapper<PublicUserProfile>;
};

export type UserSearch = {
  __typename?: 'UserSearch';
  createdAt: EntireFieldWrapper<Scalars['Time']>;
  id: EntireFieldWrapper<Scalars['String']>;
  searchTerm: EntireFieldWrapper<Scalars['String']>;
  userId: EntireFieldWrapper<Scalars['String']>;
};

export type UserShippingAddressResponse = {
  __typename?: 'UserShippingAddressResponse';
  address?: EntireFieldWrapper<Maybe<UsersShippingAddress>>;
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  isTrial: EntireFieldWrapper<Scalars['Boolean']>;
};

export type UserUpdateFlagsInput = {
  identifyUser?: InputMaybe<Scalars['Boolean']>;
  isGAdsSignup?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
};

export type UserUpdateGdprConsent = 'news' | 'none';

export type UserUpdateGdprInput = {
  consent: UserUpdateGdprConsent;
  page: Scalars['String'];
  userID: Scalars['ID'];
};

export type UsersClaimGiftInput = {
  giftId: Scalars['String'];
  type: UserCreditTypes;
};

export type UsersClaimGiftResponse = {
  __typename?: 'UsersClaimGiftResponse';
  message: EntireFieldWrapper<Scalars['String']>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type UsersFavoriteProductResponse = {
  __typename?: 'UsersFavoriteProductResponse';
  favoriteCount: EntireFieldWrapper<Scalars['Int']>;
  productID: EntireFieldWrapper<Scalars['Int']>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type UsersGetInput = {
  id: Scalars['ID'];
};

export type UsersGetResponse = {
  __typename?: 'UsersGetResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  user?: EntireFieldWrapper<Maybe<User>>;
};

export type UsersListFavoriteProductsInput = {
  exclude?: InputMaybe<Array<Scalars['String']>>;
  excludeSkipTrial?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<ContentLanguage>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
};

export type UsersShippingAddress = {
  __typename?: 'UsersShippingAddress';
  address1: EntireFieldWrapper<Scalars['String']>;
  address2: EntireFieldWrapper<Scalars['String']>;
  city: EntireFieldWrapper<Scalars['String']>;
  country: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
  postCode: EntireFieldWrapper<Scalars['String']>;
  state: EntireFieldWrapper<Scalars['String']>;
};

export type ValidateTokenResponse = {
  __typename?: 'ValidateTokenResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  valid?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type VectorizerCancelImageVectorizationInput = {
  id: Scalars['ID'];
};

export type VectorizerCancelImageVectorizationResponse = {
  __typename?: 'VectorizerCancelImageVectorizationResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
};

export type VectorizerCreateImageResponse = {
  __typename?: 'VectorizerCreateImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id?: EntireFieldWrapper<Maybe<Scalars['ID']>>;
};

export type VectorizerCreateInput = {
  fileName?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type VectorizerCreateSignedUploadUrl = {
  fileName: Scalars['String'];
  fileSize?: InputMaybe<Scalars['Int']>;
};

export type VectorizerCreateSignedUploadUrlResponse = {
  __typename?: 'VectorizerCreateSignedUploadUrlResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  signedUrl: EntireFieldWrapper<Scalars['String']>;
};

export type VectorizerDeleteAllImagesResponse = {
  __typename?: 'VectorizerDeleteAllImagesResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  ids?: EntireFieldWrapper<Maybe<Array<Scalars['ID']>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type VectorizerDeleteImageInput = {
  id: Scalars['ID'];
};

export type VectorizerDeleteImageResponse = {
  __typename?: 'VectorizerDeleteImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  success: EntireFieldWrapper<Scalars['Boolean']>;
};

export type VectorizerGetImageInput = {
  id: Scalars['ID'];
};

export type VectorizerGetImageResponse = {
  __typename?: 'VectorizerGetImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  image?: EntireFieldWrapper<Maybe<VectorizerImage>>;
};

export type VectorizerImage = {
  __typename?: 'VectorizerImage';
  createTime?: EntireFieldWrapper<Maybe<Scalars['DateTime']>>;
  id: EntireFieldWrapper<Scalars['ID']>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  originalUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  status: EntireFieldWrapper<StatusType>;
  thumbnailUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  vectorizedUrl?: EntireFieldWrapper<Maybe<Scalars['String']>>;
};

export type VectorizerImagesRegisterToUserInput = {
  ids: Array<Scalars['String']>;
};

export type VectorizerImagesRegisterToUserResponse = {
  __typename?: 'VectorizerImagesRegisterToUserResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  images: EntireFieldWrapper<Array<VectorizerImage>>;
};

export type VectorizerListImagesInput = {
  afterId?: InputMaybe<Scalars['String']>;
  take: Scalars['Int'];
};

export type VectorizerListImagesResponse = {
  __typename?: 'VectorizerListImagesResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  images: EntireFieldWrapper<Array<VectorizerImage>>;
};

export type VectorizerListImagesV2Response = {
  __typename?: 'VectorizerListImagesV2Response';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  hasMore?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  images?: EntireFieldWrapper<Maybe<Array<VectorizerImage>>>;
};

export type VectorizerPublishImageInput = {
  id: Scalars['ID'];
};

export type VectorizerPublishImageResponse = {
  __typename?: 'VectorizerPublishImageResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  upload?: EntireFieldWrapper<Maybe<StudioUploadsFile>>;
};

export type VerificationBanner = {
  __typename?: 'VerificationBanner';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNav: EntireFieldWrapper<Scalars['String']>;
  bannerAboveNavState: EntireFieldWrapper<Scalars['String']>;
  button: EntireFieldWrapper<VerificationBannerButton>;
  text: EntireFieldWrapper<Scalars['String']>;
  textColor: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<SiteBannerType>;
};

export type VerificationBannerButton = {
  __typename?: 'VerificationBannerButton';
  backgroundColor: EntireFieldWrapper<Scalars['String']>;
  link: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  textColor: EntireFieldWrapper<Scalars['String']>;
};

export type AskGetGivenTopicsResponse = {
  __typename?: 'askGetGivenTopicsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  topics?: EntireFieldWrapper<Maybe<Array<Maybe<AskCfTopic>>>>;
};

export type AskGetTopicResponse = {
  __typename?: 'askGetTopicResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  topic?: EntireFieldWrapper<Maybe<AskCfTopic>>;
};

export type AskGetTopicsResponse = {
  __typename?: 'askGetTopicsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  topics?: EntireFieldWrapper<Maybe<Array<AskCfTopic>>>;
};

export type AskGetUserDigestStatusResponse = {
  __typename?: 'askGetUserDigestStatusResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  subscribed: EntireFieldWrapper<Scalars['Boolean']>;
};

export type AskGetUserStatsResponse = {
  __typename?: 'askGetUserStatsResponse';
  errors?: EntireFieldWrapper<Maybe<Array<ErrorMessage>>>;
  stats?: EntireFieldWrapper<Maybe<AskCfUserStats>>;
};

export type FlowInteractionImageReactionTotal = {
  __typename?: 'flowInteractionImageReactionTotal';
  imageId: EntireFieldWrapper<Scalars['ID']>;
  reaction: EntireFieldWrapper<ImageReaction>;
  reactionsTotal: EntireFieldWrapper<Scalars['Int']>;
};

export type CoinsSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type CoinsSettingsQuery = {
  __typename?: 'Query';
  coinsSettings: {
    __typename?: 'CoinSettings';
    spending?: {
      __typename?: 'CoinSpendingSettings';
      products: { __typename?: 'CoinSpendingProductsSettings'; classes: number; bundles: number; crafts: number };
    } | null;
    errors?: Array<{ __typename?: 'ErrorMessage'; message: string }> | null;
  };
};

export type CoinsBalanceQueryVariables = Exact<{ [key: string]: never }>;

export type CoinsBalanceQuery = { __typename?: 'Query'; coins: { __typename?: 'CoinWallet'; balance: number } };

export type CoinsTransactionForProductIdQueryVariables = Exact<{
  productId: Scalars['String'];
}>;

export type CoinsTransactionForProductIdQuery = {
  __typename?: 'Query';
  coinsTransactionForProductId: {
    __typename?: 'CoinTransactionResponse';
    transaction?: {
      __typename?: 'CoinTransaction';
      id: string;
      type: CoinTransactionType;
      amount: number;
      status: CoinTransactionStatus;
    } | null;
    errors?: Array<{ __typename?: 'ErrorMessage'; message: string }> | null;
  };
};

export type CoinsUpdateTransactionStatusMutationVariables = Exact<{
  id: Scalars['String'];
  status: CoinTransactionStatus;
}>;

export type CoinsUpdateTransactionStatusMutation = {
  __typename?: 'Mutation';
  coinsUpdateTransactionStatus: {
    __typename?: 'UpdateCoinTransactionStatusResponse';
    transaction?: {
      __typename?: 'CoinTransaction';
      id: string;
      type: CoinTransactionType;
      amount: number;
      status: CoinTransactionStatus;
    } | null;
    errors?: Array<{ __typename?: 'ErrorMessage'; message: string }> | null;
  };
};

export type CoinsSpendOnProductMutationVariables = Exact<{
  productId: Scalars['String'];
}>;

export type CoinsSpendOnProductMutation = {
  __typename?: 'Mutation';
  coinsSpendOnProduct: {
    __typename?: 'CoinsSpendResponse';
    transaction?: {
      __typename?: 'CoinTransaction';
      id: string;
      type: CoinTransactionType;
      amount: number;
      status: CoinTransactionStatus;
    } | null;
    errors?: Array<{ __typename?: 'ErrorMessage'; message: string }> | null;
  };
};

export const CoinsSettingsDocument = `
    query coinsSettings {
  coinsSettings {
    spending {
      products {
        classes
        bundles
        crafts
      }
    }
    errors {
      message
    }
  }
}
    `;
export const useCoinsSettingsQuery = <TData = CoinsSettingsQuery, TError = unknown>(
  variables?: CoinsSettingsQueryVariables,
  options?: UseQueryOptions<CoinsSettingsQuery, TError, TData>,
) =>
  useQuery<CoinsSettingsQuery, TError, TData>(
    variables === undefined ? ['coinsSettings'] : ['coinsSettings', variables],
    mutationFetcher<CoinsSettingsQuery, CoinsSettingsQueryVariables>(CoinsSettingsDocument, variables),
    options,
  );
useCoinsSettingsQuery.fetcher = (variables?: CoinsSettingsQueryVariables, options?: RequestInit['headers']) =>
  mutationFetcher<CoinsSettingsQuery, CoinsSettingsQueryVariables>(CoinsSettingsDocument, variables, options);
export const CoinsBalanceDocument = `
    query coinsBalance {
  coins {
    balance
  }
}
    `;
export const useCoinsBalanceQuery = <TData = CoinsBalanceQuery, TError = unknown>(
  variables?: CoinsBalanceQueryVariables,
  options?: UseQueryOptions<CoinsBalanceQuery, TError, TData>,
) =>
  useQuery<CoinsBalanceQuery, TError, TData>(
    variables === undefined ? ['coinsBalance'] : ['coinsBalance', variables],
    mutationFetcher<CoinsBalanceQuery, CoinsBalanceQueryVariables>(CoinsBalanceDocument, variables),
    options,
  );
useCoinsBalanceQuery.fetcher = (variables?: CoinsBalanceQueryVariables, options?: RequestInit['headers']) =>
  mutationFetcher<CoinsBalanceQuery, CoinsBalanceQueryVariables>(CoinsBalanceDocument, variables, options);
export const CoinsTransactionForProductIdDocument = `
    query coinsTransactionForProductId($productId: String!) {
  coinsTransactionForProductId(productId: $productId) {
    transaction {
      id
      type
      amount
      status
    }
    errors {
      message
    }
  }
}
    `;
export const useCoinsTransactionForProductIdQuery = <TData = CoinsTransactionForProductIdQuery, TError = unknown>(
  variables: CoinsTransactionForProductIdQueryVariables,
  options?: UseQueryOptions<CoinsTransactionForProductIdQuery, TError, TData>,
) =>
  useQuery<CoinsTransactionForProductIdQuery, TError, TData>(
    ['coinsTransactionForProductId', variables],
    mutationFetcher<CoinsTransactionForProductIdQuery, CoinsTransactionForProductIdQueryVariables>(
      CoinsTransactionForProductIdDocument,
      variables,
    ),
    options,
  );
useCoinsTransactionForProductIdQuery.fetcher = (
  variables: CoinsTransactionForProductIdQueryVariables,
  options?: RequestInit['headers'],
) =>
  mutationFetcher<CoinsTransactionForProductIdQuery, CoinsTransactionForProductIdQueryVariables>(
    CoinsTransactionForProductIdDocument,
    variables,
    options,
  );
export const CoinsUpdateTransactionStatusDocument = `
    mutation coinsUpdateTransactionStatus($id: String!, $status: CoinTransactionStatus!) {
  coinsUpdateTransactionStatus(id: $id, status: $status) {
    transaction {
      id
      type
      amount
      status
    }
    errors {
      message
    }
  }
}
    `;
export const useCoinsUpdateTransactionStatusMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CoinsUpdateTransactionStatusMutation,
    TError,
    CoinsUpdateTransactionStatusMutationVariables,
    TContext
  >,
) =>
  useMutation<CoinsUpdateTransactionStatusMutation, TError, CoinsUpdateTransactionStatusMutationVariables, TContext>(
    ['coinsUpdateTransactionStatus'],
    (variables?: CoinsUpdateTransactionStatusMutationVariables) =>
      mutationFetcher<CoinsUpdateTransactionStatusMutation, CoinsUpdateTransactionStatusMutationVariables>(
        CoinsUpdateTransactionStatusDocument,
        variables,
      )(),
    options,
  );
useCoinsUpdateTransactionStatusMutation.fetcher = (
  variables: CoinsUpdateTransactionStatusMutationVariables,
  options?: RequestInit['headers'],
) =>
  mutationFetcher<CoinsUpdateTransactionStatusMutation, CoinsUpdateTransactionStatusMutationVariables>(
    CoinsUpdateTransactionStatusDocument,
    variables,
    options,
  );
export const CoinsSpendOnProductDocument = `
    mutation coinsSpendOnProduct($productId: String!) {
  coinsSpendOnProduct(productId: $productId) {
    transaction {
      id
      type
      amount
      status
    }
    errors {
      message
    }
  }
}
    `;
export const useCoinsSpendOnProductMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CoinsSpendOnProductMutation, TError, CoinsSpendOnProductMutationVariables, TContext>,
) =>
  useMutation<CoinsSpendOnProductMutation, TError, CoinsSpendOnProductMutationVariables, TContext>(
    ['coinsSpendOnProduct'],
    (variables?: CoinsSpendOnProductMutationVariables) =>
      mutationFetcher<CoinsSpendOnProductMutation, CoinsSpendOnProductMutationVariables>(
        CoinsSpendOnProductDocument,
        variables,
      )(),
    options,
  );
useCoinsSpendOnProductMutation.fetcher = (
  variables: CoinsSpendOnProductMutationVariables,
  options?: RequestInit['headers'],
) =>
  mutationFetcher<CoinsSpendOnProductMutation, CoinsSpendOnProductMutationVariables>(
    CoinsSpendOnProductDocument,
    variables,
    options,
  );
